/** Kid-friendly emoji icons for Analyse "Words with this sound". */
const EXAMPLE_ICONS: Record<string, string> = {
  'अग्निः': '🔥',
  'अश्वः': '🐴',
  'अन्नम्': '🌾',
  'आकाशः': '🌌',
  'माता': '👩',
  'बालः': '🧒',
  'गिरिः': '⛰️',
  'मित्रम्': '🤝',
  'सिंहः': '🦁',
  'नदी': '🏞️',
  'सीता': '🙏',
  'गीतम्': '🎵',
  'गुरुः': '📿',
  'पुत्रः': '👦',
  'मुखम्': '🙂',
  'ऊनम्': '📉',
  'कूर्मः': '🐢',
  'मूलम्': '🌱',
  'ऋषिः': 'ॐ',
  'वृक्षः': '🌳',
  'कृष्णः': '🪈',
  'पितॄणाम्': '👴',
  'नॄणाम्': '👥',
  'क्लृप्तम्': '🧩',
  'देवः': '🛕',
  'मेघः': '☁️',
  'एकः': '1',
  'ऐश्वर्यम्': '💎',
  'नैतिकः': '⚖️',
  'कैलासः': '🏔️',
  'गोः': '🐄',
  'तोयम्': '💧',
  'लोकः': '🌍',
  'औषधम्': '💊',
  'गौः': '🐄',
  'नौका': '⛵',
  'अंशः': '🧩',
  'हंसः': '🦢',
  'नमः': '🙏',
  'मनः': '🧠',
  'कमलम्': '🪷',
  'काकः': '🐦',
  'करः': '✋',
  'खगः': '🐦',
  'दुःखम्': '😢',
  'गजः': '🐘',
  'गङ्गा': '🌊',
  'घनः': '🧊',
  'घरम्': '🏠',
  'घटः': '🏺',
  'घृतम्': '🧈',
  'अङ्गम्': '🦵',
  'रङ्गः': '🎨',
  'अङ्कुरः': '🌱',
  'पङ्कजम्': '🪷',
  'सङ्गीतम्': '🎵',
  'चन्द्रः': '🌙',
  'चक्रम्': '⚙️',
  'चित्रम्': '🖼️',
  'छात्रः': '🎓',
  'छत्रम्': '☂️',
  'छाया': '🌑',
  'जलम्': '💧',
  'जगत्': '🌍',
  'राजः': '👑',
  'झण्डा': '🚩',
  'झूला': '🎠',
  'झरी': '💦',
  'पञ्च': '5',
  'ज्ञानम्': '📚',
  'अञ्जलिः': '🙏',
  'अञ्जनम्': '👁️',
  'कुञ्जरः': '🐘',
  'मञ्जरी': '🌸',
  'किञ्चित्': '🤏',
  'पञ्जरम्': '🏠',
  'पटः': '🧵',
  'कटः': '🧺',
  'वाटिका': '🏡',
  'पाठः': '📖',
  'कण्ठः': '🗣️',
  'कठिनम्': '💪',
  'अण्डम्': '🥚',
  'डमरुः': '🥁',
  'नाडी': '💓',
  'दृढम्': '🪨',
  'गूढम्': '🕵️',
  'गाढम्': '🌊',
  'गणः': '👥',
  'कर्णः': '👂',
  'वेणुः': '🎶',
  'तातः': '👨',
  'तरुः': '🌳',
  'तारा': '⭐',
  'कथा': '📜',
  'पथः': '🛤️',
  'अथवा': '↔️',
  'दधि': '🥛',
  'दुग्धम्': '🥛',
  'धर्मः': '☸️',
  'धनुः': '🏹',
  'धनम्': '💰',
  'नरः': '🧍',
  'नयनम्': '👁️',
  'पत्रम्': '🍃',
  'पद्मम्': '🪷',
  'फलम्': '🍎',
  'फणिः': '🐍',
  'फेनम्': '🫧',
  'बलम्': '💪',
  'बकः': '🦩',
  'भूमिः': '🌍',
  'भानुः': '☀️',
  'भक्तः': '🙏',
  'यज्ञः': '🔥',
  'यमः': '⚖️',
  'यन्त्रम्': '⚙️',
  'रामः': '🏹',
  'रविः': '☀️',
  'रथः': '🛞',
  'लता': '🌿',
  'लालः': '❤️',
  'वनम्': '🌲',
  'वायुः': '💨',
  'वानरः': '🐒',
  'शशिः': '🌙',
  'शङ्खः': '🐚',
  'शिष्यः': '🎓',
  'षट्': '6',
  'विषम्': '☠️',
  'पुरुषः': '🧍',
  'सूर्यः': '☀️',
  'सरः': '🏞️',
  'हस्तः': '✋',
  'हरिः': '🙏',
  'क्षेत्रम्': '🌾',
  'लक्ष्मीः': '🪷',
  'नेत्रम्': '👁️',
  'सूत्रम्': '🧵',

  'कार्यम्': '🛠️',
  'किरणः': '✨',
  'किम्': '❓',
  'किसलयम्': '🍃',
  'कीटः': '🐛',
  'कीर्तिः': '🏆',
  'कीर्तनम्': '🎶',
  'कुसुमम्': '🌸',
  'कुम्भः': '🏺',
  'कुक्कुरः': '🐕',
  'कूपः': '🪣',
  'कूटः': '⛰️',
  'कृषिः': '🌾',
  'कृमिः': '🪱',
  'केशः': '💇',
  'केलिः': '🎈',
  'केन्द्रम्': '🎯',
  'कैकेयी': '👸',
  'कैवर्तः': '🎣',
  'कोकिलः': '🐦',
  'कोपः': '😠',
  'कोशः': '📦',
  'कौशलम्': '🏅',
  'कौशिकः': '🦉',
  'कौस्तुभः': '💎',
  'कंसः': '👑',
  'कंबलः': '🧣',
  'अंकः': '🔢',
  'बालकः': '👦',
  'नायकः': '🦸',
  'कः': '❓',

  'खड्गः': '⚔️',
  'खट्वा': '🛏️',
  'खादति': '🍽️',
  'शाखा': '🌿',
  'आखुः': '🐭',
  'शिखी': '🦚',
  'लेखिका': '✍️',
  'खिन्नः': '😞',
  'सखी': '👭',
  'सुखी': '😊',
  'नखी': '💅',
  'खुरः': '🐴',
  'खेलति': '🎲',
  'लेखः': '📝',
  'मुखेन': '👄',
  'खं': '🌌',
  'सुखं': '😊',
  'नखः': '💅',
  'शिखः': '🔥',
  'खातम्': '🕳️',
  'विज्ञानम्': '🔬',

  'खूर्दति': '🦘',
  'खृ': '🔢',
  'नखैः': '💅',
  'सुखैः': '😊',
  'मुखैः': '🙂',
  'खोदति': '⛏️',
  'मुखो': '🙂',
  'शिखोपरि': '🏔️',
  'नखौ': '💅',
  'शिखौ': '🔥',

  'गानम्': '🎵',
  'गावः': '🐄',
  'गंगा': '🌊',
  'गिरिशः': '🕉️',
  'गीता': '📖',
  'गुणः': '⭐',
  'गृहम्': '🏠',
  'गृध्रः': '🦅',
  'गृहिणी': '👩',
  'गेहम्': '🏡',
  'गेयम्': '🎶',
  'गैरिकम्': '🟠',
  'स्वर्गैः': '☁️',
  'गोपालः': '🪈',
  'गोमयम्': '🌿',
  'गौरवम्': '🏅',
  'गंधः': '🌸',
  'नागः': '🐍',
  'भागः': '🧩',
  'योगः': '🧘',

  'घाटः': '🏞️',
  'आघातः': '💥',
  'घातः': '⚔️',
  'दीर्घिका': '🏞️',
  'परिघिः': '⭕',
  'घी': '🧈',
  'दीर्घी': '📏',
  'घुणः': '🐛',
  'घुसृणम्': '🧡',
  'घूकः': '🦉',
  'घृणा': '😖',
  'मेघेन': '☁️',
  'संघेन': '👥',
  'मेघैः': '☁️',
  'संघैः': '👥',
  'घोषः': '📢',
  'घोटकः': '🐴',
  'मेघौ': '☁️',
  'संघौ': '👥',
  'घंटा': '🔔',
  'संघं': '👥',
  'संघः': '👥',
  'उल्लाघः': '💪',

  'ङा': '🔢',
  'ङि': '🔢',
  'ङी': '🔢',
  'ङु': '🔊',
  'ङू': '🔢',
  'ङृ': '🔢',
  'ङे': '🔢',
  'ङै': '🔢',
  'ङो': '🔢',
  'ङौ': '🔢',
  'ङं': '🔢',
  'ङः': '🕉️',

  'चातकः': '🐦',
  'वाचा': '🗣️',
  'आचारः': '🙏',
  'चिन्ता': '💭',
  'अचिरम्': '⏱️',
  'चीरम्': '🧥',
  'चीवरम्': '🧥',
  'वाची': '🗣️',
  'चुम्बति': '💋',
  'चुलुकः': '🤲',
  'चुक्रम्': '🍋',
  'चूडः': '💇',
  'चूतम्': '🥭',
  'चूडामणिः': '💎',
  'चृ': '🔢',
  'चेतना': '🧠',
  'चेष्टा': '🤸',
  'चेतः': '💛',
  'चैत्रः': '🌸',
  'चैतन्यम्': '✨',
  'चैत्यम्': '🛕',
  'चोरः': '🦹',
  'चोदनम्': '👉',
  'प्रचोदयात्': '🙏',
  'चौर्यम्': '🦹',
  'चौरः': '🦹',
  'चौलम्': '✂️',
  'चंपकः': '🌼',
  'चंद्रः': '🌙',
  'उच्चं': '⬆️',
  'वाचः': '🗣️',
  'वचः': '💬',
  'ऋचः': '📜',

  'छागः': '🐐',
  'छिद्रम्': '🕳️',
  'छिनत्ति': '✂️',
  'अच्छिन्नः': '🔗',
  'छीकः': '🤧',
  'छुरिका': '🔪',
  'छुरति': '✂️',
  'छू': '🔢',
  'छृ': '🔢',
  'छेदः': '✂️',
  'छेदनम्': '🪓',
  'अच्छेद्यः': '🛡️',
  'कच्छैः': '🏖️',
  'अच्छैः': '💎',
  'तुच्छैः': '📭',
  'अच्छोदः': '🏞️',
  'छोलङ्गः': '🍊',
  'कच्छो': '🏖️',
  'कच्छौ': '🏖️',
  'अच्छौ': '💎',
  'तुच्छौ': '📭',
  'छंदः': '📜',
  'अच्छं': '💎',
  'कच्छः': '🏖️',
  'अच्छः': '💎',
  'तुच्छः': '📭',

  'जातकम्': '📖',
  'राजा': '👑',
  'जाम्बवन्': '🐻',
  'जिह्वा': '👅',
  'जितम्': '🏆',
  'अजितः': '🛡️',
  'जीवनम्': '🌱',
  'जीरकम्': '🌿',
  'जीमूतः': '☁️',
  'अर्जुनः': '🏹',
  'मञ्जुः': '🌸',
  'जुष्टम्': '💛',
  'जूटः': '💇',
  'जूका': '🪱',
  'जृम्भते': '🥱',
  'जृम्भणम्': '🥱',
  'जृम्भा': '🥱',
  'जेता': '🏆',
  'अजेयः': '🛡️',
  'विजेता': '🥇',
  'जैत्रः': '🏅',
  'जैमिनिः': '📿',
  'जैत्रम्': '🎖️',
  'जोषम्': '😌',
  'द्विजो': '🐦',
  'गजो': '🐘',
  'अजौ': '🐐',
  'गजौ': '🐘',
  'द्विजौ': '🐦',
  'जंबू': '🍎',
  'जंबुकः': '🦊',
  'गजं': '🐘',
  'अजः': '🐐',

  'झाटः': '🌳',
  'झालि': '🥭',
  'झावुः': '🌲',
  'उज्झितः': '🚪',
  'झिल्ली': '🦗',
  'झिरिका': '🦗',
  'झीरिका': '🦗',
  'झीरुका': '🦗',
  'झुण्टः': '🌿',
  'झुम्बरि': '🎸',
  'झूणि': '🌰',
  'झृ': '🔢',
  'झेन': '🔊',
  'झैः': '🔊',
  'झोडः': '🌴',
  'झो': '🔤',
  'झौ': '2️⃣',
  'झौलिकम्': '👜',
  'झंकारः': '🔔',
  'झंपः': '🦘',
  'झंपा': '🦘',
  'झः': '🔔',

  'ञा': '🔢',
  'ञि': '🔢',
  'ञी': '🔢',
  'ञु': '🔢',
  'ञू': '🔢',
  'ञृ': '🔢',
  'ञे': '🔢',
  'ञै': '🔢',
  'ञो': '🔢',
  'ञौ': '🔢',
  'ञं': '🔢',
  'ञः': '🔢',

  'घण्टा': '🔔',
  'फटा': '🐍',
  'कटाक्षः': '👀',
  'घटिका': '⏳',
  'टिट्टिभः': '🐦',
  'कोटी': '💯',
  'नटी': '💃',
  'तटी': '🏞️',
  'कुटुम्बम्': '👪',
  'कटु': '🌶️',
  'पटु': '🧠',
  'कटू': '🌶️',
  'पटू': '🧠',
  'तटे': '🏞️',
  'वटे': '🌳',
  'नटे': '🎭',
  'नटैः': '🎭',
  'पटैः': '🧵',
  'कटैः': '🧺',
  'नटो': '🎭',
  'पटो': '🧵',
  'कण्टो': '🌵',
  'नटौ': '🎭',
  'पटौ': '🧵',
  'कटौ': '🧺',
  'टंकः': '🪙',
  'पटं': '🧵',
  'नटं': '🎭',
  'नटः': '🎭',

  'कण्ठाभरणम्': '📿',
  'कोष्ठागारम्': '🏚️',
  'ठाकुर': '👤',
  'पीठिका': '🪑',
  'कण्ठिका': '📿',
  'कोष्ठी': '🏚️',
  'पृष्ठी': '🔙',
  'पाठी': '📖',
  'निष्ठुरः': '😠',
  'निष्ठुरम्': '😠',
  'ठू': '🔢',
  'ठृ': '🔢',
  'पीठे': '🪑',
  'पाठे': '📖',
  'मठे': '🛕',
  'पाठैः': '📖',
  'पीठैः': '🪑',
  'मठैः': '🛕',
  'कठोरः': '🪨',
  'कठोरम्': '🪨',
  'पाठो': '📖',
  'ओष्ठौ': '👄',
  'पीठौ': '🪑',
  'कण्ठौ': '🗣️',
  'कण्ठं': '🗣️',
  'पीठं': '🪑',
  'पाठं': '📖',
  'पीठः': '🪑',

  'अण्डाकारः': '🥚',
  'भाण्डागारम्': '🏚️',
  'डाकिनी': '🧚',
  'डिम्भः': '👶',
  'पण्डितः': '📿',
  'डिण्डिमः': '🥁',
  'चण्डी': '🕉️',
  'कुण्डी': '🥣',
  'डुण्डुभः': '🐍',
  'हुडुक्कः': '🥁',
  'गुडुची': '🌿',
  'गुडूची': '🌿',
  'गुडूचिका': '🌿',
  'डृ': '🔢',
  'दण्डे': '🪵',
  'अण्डे': '🥚',
  'पिण्डे': '⚪',
  'दण्डैः': '🪵',
  'अण्डैः': '🥚',
  'पिण्डैः': '⚪',
  'दण्डो': '🪵',
  'पिण्डो': '⚪',
  'भण्डो': '🤡',
  'दण्डौ': '🪵',
  'पिण्डौ': '⚪',
  'भण्डौ': '🤡',
  'दण्डं': '🪵',
  'अण्डं': '🥚',
  'पिण्डं': '⚪',
  'दण्डः': '🪵',
  'पिण्डः': '⚪',
  'भण्डः': '🤡',

  'गाढा': '🌊',
  'दृढा': '🪨',
  'ऊढा': '👰',
  'रूढिः': '📌',
  'प्रौढिः': '🎓',
  'रूढी': '📌',
  'दृढीकरणम्': '💪',
  'दृढीकृत': '💪',
  'ढुण्ढिः': '🕉️',
  'ढू': '🔢',
  'ढृ': '🔢',
  'दृढे': '🪨',
  'गूढे': '🕵️',
  'गाढे': '🌊',
  'दृढैः': '🪨',
  'गूढैः': '🕵️',
  'गाढैः': '🌊',
  'दृढो': '🪨',
  'गूढो': '🕵️',
  'गाढो': '🌊',
  'दृढौ': '🪨',
  'गूढौ': '🕵️',
  'गाढौ': '🌊',
  'दृढं': '🪨',
  'गूढं': '🕵️',
  'गाढं': '🌊',
  'दृढः': '🪨',
  'गूढः': '🕵️',
  'गाढः': '🌊',

  'बाणाः': '🏹',
  'प्राणाः': '🌬️',
  'कृष्णा': '🕉️',
  'मणिः': '💎',
  'पाणिः': '✋',
  'कणिका': '💧',
  'वाणी': '🗣️',
  'श्रेणी': '📶',
  'वेणी': '💇',
  'विष्णुः': '🕉️',
  'अणुः': '⚛️',
  'णू': '🔢',
  'णृ': '🔢',
  'गुणे': '⭐',
  'बाणे': '🏹',
  'कर्णे': '👂',
  'गुणैः': '⭐',
  'बाणैः': '🏹',
  'गणैः': '👥',
  'गुणो': '⭐',
  'बाणो': '🏹',
  'गणो': '👥',
  'कर्णौ': '👂',
  'गुणौ': '⭐',
  'बाणौ': '🏹',
  'गुणं': '⭐',
  'बाणं': '🏹',
  'कर्णं': '👂',

// त-row
  'गतिः': '🏃',
  'मतिः': '🧠',
  'पतिः': '👔',
  'तीरम्': '🏞️',
  'तीर्थम्': '🛕',
  'सरस्वती': '📚',
  'तुला': '⚖️',
  'धातुः': '⚙️',
  'वस्तु': '📦',
  'तूलम्': '☁️',
  'तूणः': '🏹',
  'ऋतूनाम्': '🍂',
  'तृणम्': '🌿',
  'तृप्तः': '😊',
  'तृष्णा': '🥤',
  'तेजः': '✨',
  'गते': '🚶',
  'हस्ते': '✋',
  'तैः': '👥',
  'गतैः': '🚶',
  'हस्तैः': '✋',
  'गतो': '🚶',
  'हस्तो': '✋',
  'हस्तौ': '✋',
  'गतौ': '🚶',
  'कृतौ': '✅',
  'तं': '👉',
  'हस्तं': '✋',
  'गतं': '🚶',
  'गतः': '🚶',
  'कृतः': '✅',

// थ-row
  'यथा': '↔️',
  'तथा': '✔️',
  'स्थितिः': '📍',
  'पथिकः': '🥾',
  'अतिथिः': '🚪',
  'मेथी': '🌱',
  'अर्थी': '🙏',
  'मथुरा': '🏙️',
  'मन्थुः': '🌀',
  'थू': '🔢',
  'थृ': '🔢',
  'पथे': '🛤️',
  'कथे': '📜',
  'अर्थे': '💡',
  'पथैः': '🛤️',
  'अर्थैः': '💡',
  'कथैः': '📜',
  'अथो': '➡️',
  'पथो': '🛤️',
  'अर्थो': '💡',
  'पथौ': '🛤️',
  'अर्थौ': '💡',
  'पथं': '🛤️',
  'अर्थं': '💡',
  'कथं': '❓',
  'अर्थः': '💡',

// द-row
  'दानम्': '🎁',
  'दाता': '🤲',
  'दासी': '🧹',
  'दिनम्': '📅',
  'आदिः': '1️⃣',
  'मदिरा': '🍷',
  'दीपः': '🪔',
  'दीनः': '🥺',
  'दुर्गा': '🕉️',
  'दूतः': '📨',
  'दूरम्': '📏',
  'दूषितम्': '☣️',
  'दृष्टिः': '👀',
  'दृशः': '👁️',
  'देशः': '🗺️',
  'देहः': '🧍',
  'दैवम्': '🌟',
  'दैत्यः': '👹',
  'दोषः': '⚠️',
  'दोहनम्': '🥛',
  'पदो': '🦶',
  'दौर्बल्यम्': '😩',
  'पदौ': '🦶',
  'मदौ': '😵',
  'इदं': '☝️',
  'पदं': '🦶',
  'दंतः': '🦷',
  'पदः': '🦶',
  'मदः': '😵',
  'हृदः': '❤️',

// ध-row
  'धावति': '🏃',
  'सुधा': '🍯',
  'धात्री': '🤱',
  'बुद्धिः': '🧠',
  'विधिः': '📋',
  'निधिः': '💎',
  'धीरः': '🦁',
  'सुधी': '🎓',
  'धी': '💡',
  'मधु': '🍯',
  'सिन्धुः': '🌊',
  'अधुना': '⏰',
  'धूमः': '💨',
  'धूलिः': '🌪️',
  'वधू': '👰',
  'धृतिः': '💪',
  'धृतम्': '🤲',
  'धेनुः': '🐄',
  'नूपुरम्': '🔔',
  'मक्षिका': '🪰',
  'नेत्रे': '👀',
  'सेना': '🪖',
  'वृश्चिकः': '🦂',
  'पिपीलिका': '🐜',
  'नक्रः': '🐊',
  'उष्ट्रः': '🐪',
  'हिमम्': '❄️',
  'शुकः': '🦜',
  'बन्धे': '🔗',
  'धैर्यम्': '🧘',
  'बन्धैः': '🔗',
  'रोधैः': '🚧',
  'बन्धो': '🔗',
  'रोधो': '🚧',
  'अधो': '⬇️',
  'धौतम्': '🧼',
  'बन्धौ': '🔗',
  'रोधौ': '🚧',
  'बन्धं': '🔗',
  'रोधं': '🚧',
  'बन्धः': '🔗',
  'रोधः': '🚧',
  'अधः': '⬇️',

// न-row
  'नाम': '🏷️',
  'नासिका': '👃',
  'नारी': '👩',
  'नियमः': '📏',
  'नित्यम्': '♾️',
  'नीरम्': '💧',
  'नीलः': '🔵',
  'नीतिः': '⚖️',
  'मनुः': '👤',
  'तनुः': '🧍',
  'नूतनम्': '🆕',
  'नूनम्': '✅',
  'नृपः': '👑',
  'नृत्यम्': '💃',
  'नेता': '🗣️',
  'वने': '🌲',
  'वनैः': '🌲',
  'मनो': '🧠',
  'वनो': '🌲',
  'नो': '🚫',
  'वनौ': '🌲',
  'वनं': '🌲',
  'नयनं': '👁️',
  'गगनं': '🌌',
  'धनः': '💰',
  'जीवनः': '🌱',

// प-row
  'पातालम्': '🌋',
  'पानीयम्': '🥤',
  'पादः': '🦶',
  'पिता': '👨',
  'पिकः': '🐦',
  'पिपासा': '🏜️',
  'पीतम्': '🟡',
  'पीनः': '🤗',
  'पुष्पम्': '🌸',
  'पुराणम्': '📖',
  'पूजा': '🙏',
  'पूर्णम्': '🌕',
  'पूजकः': '🛕',
  'पृथ्वी': '🌍',
  'पृष्ठम्': '📄',
  'पृथक्': '↔️',
  'पेयम्': '🧃',
  'पेचकः': '🦉',
  'पैतृकः': '👪',
  'नृपैः': '👑',
  'गोपैः': '🐄',
  'पोतः': '⛵',
  'पोषणम्': '🍼',
  'पौत्रः': '🧒',
  'पौरः': '🏘️',
  'पापं': '⚠️',
  'पुष्पं': '🌸',
  'नृपं': '👑',
  'सर्पः': '🐍',
  'तपः': '🔥',

// फ-row
  'फाल्गुनः': '🎊',
  'फालः': '🪓',
  'स्फीतः': '📈',
  'स्फीतिः': '📊',
  'फुल्लम्': '🌼',
  'फुल्लः': '🌺',
  'फूत्कारः': '💨',
  'फेनकः': '🫧',

// ब-row
  'बाणः': '🏹',
  'बाला': '👧',
  'बिम्बम्': '🪞',
  'बिन्दुः': '⚫',
  'बिलम्': '🕳️',
  'बीजम्': '🌱',
  'बुधः': '🪐',
  'बुद्धः': '🧘',
  'बृहत्': '🗻',
  'बृहस्पतिः': '👨‍🏫',
  'कुबेरः': '💰',
  'अम्बैः': '👩',
  'बोधः': '💡',
  'बोधनम्': '📚',
  'बौद्धः': '☸️',
  'बिम्बं': '🪞',
  'जम्बं': '🍇',
  'जम्बः': '🍇',

// भ-row
  'भारतम्': '🇮🇳',
  'भाषा': '🗣️',
  'भिषजः': '🩺',
  'भित्तिः': '🧱',
  'भिन्नम्': '🧩',
  'भीमः': '💪',
  'भीतिः': '😨',
  'भीरुः': '😰',
  'भुजः': '💪',
  'भुवनम्': '🌐',
  'भुक्तिः': '🍽️',
  'भूतम्': '👻',
  'भूपः': '👑',
  'भृगुः': '🧔',
  'भृत्यः': '🙇',
  'भृङ्गः': '🐝',
  'भेदः': '✂️',
  'भेकः': '🐸',
  'भेरी': '🥁',
  'भैषज्यम्': '💊',
  'भोजनम्': '🍲',
  'भोगः': '😋',
  'भौतिकः': '⚛️',
  'भौमः': '🔴',
  'शुभं': '✨',
  'शुभः': '✨',
  'लाभः': '🎁',

// म-row
  'मानवः': '🧍',
  'माला': '📿',
  'मिथ्या': '❌',
  'मिलनम्': '🤗',
  'मीनः': '🐟',
  'लक्ष्मी': '🪷',
  'मुनिः': '🧘',
  'मुकुटः': '👑',
  'मूर्तिः': '🛕',
  'मूर्खः': '🤪',
  'मृगः': '🦌',
  'मृत्युः': '💀',
  'मृदुः': '🧸',
  'मेरुः': '⛰️',
  'मेधा': '🧠',
  'मैत्री': '🤝',
  'मोक्षः': '🕊️',
  'मोदकः': '🍡',
  'मोहः': '😵‍💫',
  'मौनम्': '🤫',
  'मौर्यः': '🏛️',
  'रामं': '🏹',
  'समं': '⚖️',
  'आमं': '🥭',
  'समः': '⚖️',

  // Nature / board words
  'मयूरः': '🦚',
  'पर्वतः': '⛰️',
  'शशः': '🐇',
  'बिडालः': '🐱',
  'कुक्कुटः': '🐓',
  'उलूकः': '🦉',
  'भ्रमरः': '🐝',
  'चटकः': '🐦',
  'मत्स्यः': '🐟',
  'मूषकः': '🐭',
  'व्याघ्रः': '🐯',
  'महिषः': '🐃',
  'शृगालः': '🦊',
  'नकुलः': '🦡',
  'सैन्यम्': '🪖',
  'सैन्यं': '🪖',
  'पैदलं': '🚶',
  'नैकाः': '⭐',
  'मकरः': '🐊',
  'हरिणः': '🦌',
  'शार्दूलः': '🐅',
  'सारसः': '🦩',
  'भल्लूकः': '🐻',
  'वृकः': '🐺',
  'मेषः': '🐑',
  'श्वानः': '🐕',
  'सोपानम्': '🪜',
  'सोपानं': '🪜',
  'कौशेयम्': '🧵',
  'कौशेयं': '🧵',
  'मौक्तिकम्': '🦪',
  'मौक्तिकं': '🦪',
  'सौन्दर्यम्': '✨',
  'सौन्दर्यं': '✨',
  'मोदकं': '🍡',
  'कच्छपः': '🐢',
  'हस्तिनी': '🐘',
  'मयूरी': '🦚',
  'गोधा': '🦎',
  'जम्बूकः': '🦊',
  'कपिः': '🐒',
  'सृष्टिः': '🌌',
  'अद्भुता': '✨',
  'वेणुं': '🎶',
  'राज्यम्': '🏰',
  'राज्यं': '🏰',
  'अन्नं': '🌾',
  'कपोतः': '🕊️',
  'वत्सः': '🐮',
  'द्वीपः': '🏝️',
  'सागरः': '🌊',
  'नभः': '🌌',
  'विद्युत्': '⚡',
  'तुषारः': '❄️',
  'पवनः': '🌬️',
  'कन्दुकः': '⚽',
  'सन्देशः': '✉️',
  'पम्पा': '🏞️',
  'नन्दः': '😊',
  'मन्दं': '🐢',
  'पर्णम्': '🍃',
  'सरसिजम्': '🪷',
  'तडागः': '🏞️',
  'मरुभूमिः': '🏜️',
  'वर्षा': '🌧️',
  'जनः': '🧑',
  'गुल्मः': '🪴',
  'दलम्': '🍃',
  'आतपः': '☀️',
  'शीतम्': '❄️',
  'उष्णम्': '🔥',
  'तुरगः': '🐴',
  'तैलं': '🪔',
  'तैलम्': '🪔',
  'तीरे': '🏞️',
  'तूष्णीं': '🤫',
  'तोयं': '💧',
  'बालकौ': '🧒',
  'दानं': '🎁',
  'दिनं': '🌅',
  'दूरं': '🌄',
  'दैवं': '☯️',
  'दौर्बल्यं': '😩',
  'हिमालयः': '🏔️',
  'कन्दरा': '🕳️',
  'गुहा': '🕳️',
  'झरः': '💦',
  'उत्सः': '⛲',
  'पङ्कः': '🟤',
  'सिकता': '🏖️',
  'शिला': '🪨',
  'लोष्ठः': '🧱',
  'बीजं': '🌱',
  'खर्बूजं': '🍈',
  'बैलः': '🐂',
  'नीडम्': '🪺',
  'पक्षः': '🪽',
  'चञ्चुः': '🐦',
  'लोमशः': '🦊',
  'मृत्तिका': '🏺',
  'पांसुः': '🌫️',
  'कर्दमः': '🟤',
  'शैवालम्': '🌿',
  'शैत्यम्': '🥶',
  'भारतं': '🇮🇳',
  'भैरवः': '🕉️',
  'भुवि': '🌍',
  'भोजनं': '🍲',
  'भौतिकं': '⚛️',
  'धौतं': '👕',
  'धोति': '🫧',
  'यानं': '🚗',
  'यियासा': '🚶',
  'गायी': '🎤',
  'युगं': '⏳',
  'यूथं': '🦌',
  'यैः': '🌸',
  'यौवनं': '🌟',
  'मधुकः': '🐝',
  'पुष्करिणी': '🏞️',
  'नलिनी': '🪷',
  'सरोजम्': '🪷',
  'अम्भः': '💧',
  'पयः': '🥛',
  'क्षीरम्': '🥛',
  'नवनीतम्': '🧈',
  'क्षीरं': '🥛',
  'नवनीतं': '🧈',
  'धारा': '💦',
  'धान्यम्': '🌾',
  'धान्यं': '🌾',
  'ध्वजः': '🚩',
  'धरा': '🌍',
  'शलभः': '🦋',
  'मक्षिकः': '🪰',
  'अरण्यम्': '🌲',
  'अरण्यं': '🌲',
  'काननम्': '🌳',
  'काननं': '🌳',
  'यवः': '🌾',
  'यष्टिः': '🪵',
  'युगम्': '⏳',
  'यूथम्': '🦌',
  'कुमुदम्': '🤍',
  'कुमुदं': '🤍',
  'उत्पलम्': '💙',
  'उत्पलं': '💙',
  'उपवनम्': '🌿',
  'उपवनं': '🌿',
  'उद्यानम्': '🏡',
  'उद्यानं': '🏡',
  'चम्पकः': '🌼',
  'धैर्यं': '🧘',
  'ये': '👥',

  // र/ल/व/श/ष/स/ह जोडो + Nature
  'रात्रिः': '🌙',
  'रूपं': '✨',
  'रेणुः': '🌫️',
  'नरैः': '👥',
  'रोगः': '🤒',
  'रौप्यं': '🥈',
  'लिपिः': '✍️',
  'लीला': '🎭',
  'बालुका': '🏖️',
  'लूता': '🕷️',
  'बालैः': '🧒',
  'लौहं': '⚙️',
  'ववुः': '💨',
  'वूतं': '🧵',
  'वेदः': '📖',
  'वैद्यः': '🩺',
  'वोढा': '🏋️',
  'नावौ': '⛵',
  'रजनी': '🌃',
  'रसः': '🧃',
  'मरुस्थलम्': '🏜️',
  'मरुस्थलं': '🏜️',
  'शरत्': '🍂',
  'करका': '🧊',
  'रजः': '🌫️',
  'बकुलः': '🌸',
  'अलिः': '🐝',
  'बालुकम्': '🏖️',
  'बालुकं': '🏖️',
  'नीलम्': '🔵',
  'पल्लवः': '🌱',
  'लवणम्': '🧂',
  'लवणं': '🧂',
  'मालती': '🤍',
  'पलाशः': '🧡',
  'लकुटः': '🪵',
  'बिल्वम्': '🍃',
  'बिल्वं': '🍃',
  'वल्ली': '🌿',
  'वापी': '🏞️',
  'अश्वत्थः': '🌳',
  'विहगः': '🐦',
  'सस्यम्': '🌾',
  'सस्यं': '🌾',
  'अवनिः': '🌍',
  'वृष्टिः': '🌧️',
  'वल्मीकः': '🐜',
  'वराहः': '🐗',
  'वल्कलम्': '🪵',
  'वल्कलं': '🪵',
  'शिशुः': '👶',
  'शीतं': '❄️',
  'शुचि': '✨',
  'शूरः': '⚔️',
  'शेखरः': '👑',
  'शैलः': '🏔️',
  'शोभनं': '🌺',
  'शौचं': '🧼',
  'महीषी': '🐃',
  'सुषुप्तिः': '😴',
  'षूत्कारः': '🐍',
  'वर्षे': '🌧️',
  'ऋषैः': '🧙',
  'महिषौ': '🐃',
  'हास्यं': '😄',
  'हीरकं': '💎',
  'हुतं': '🔥',
  'बहूनि': '🔢',
  'हेमन्त': '🧥',
  'हैमं': '🥇',
  'होत्रं': '🔥',
  'हौत्रं': '📜',
  'शष्पम्': '🌱',
  'शष्पं': '🌱',
  'शाद्वलम्': '🟢',
  'शाद्वलं': '🟢',
  'शरभः': '🦌',
  'शल्मलिः': '🌳',
  'शीकरः': '💦',
  'श्यामलम्': '🌲',
  'श्यामलं': '🌲',
  'शुण्डा': '🐘',
  'शालः': '🌳',
  'वृषभः': '🐂',
  'वृषः': '🐂',
  'ओषधिः': '🌿',
  'ओषधम्': '💊',
  'ओषधं': '💊',
  'तुषारम्': '❄️',
  'तुषारं': '❄️',
  'कषायम्': '🍵',
  'कषायं': '🍵',
  'पाषाणः': '🪨',
  'विषाणम्': '📯',
  'विषाणं': '📯',
  'आषाढः': '☔',
  'पृषत्': '💧',
  'सेतुः': '🌉',
  'सलिलम्': '💧',
  'सलिलं': '💧',
  'सप्तपर्णः': '🍃',
  'सस्यक्षेत्रम्': '🌾',
  'सस्यक्षेत्रं': '🌾',
  'सूर्यकिरणः': '🌞',
  'सरोजिनी': '🪷',
  'सुवर्णम्': '🥇',
  'सुवर्णं': '🥇',
  'स्रोतः': '🏞️',
  'स्फटिकः': '💎',
  'ह्रदः': '🏞️',
  'हरिणशावः': '🦌',
  'हिमबिन्दुः': '❄️',
  'हिमपातः': '🌨️',
  'हरिततृणम्': '🌿',
  'हरिततृणं': '🌿',
  'हिमशिखरम्': '🏔️',
  'हिमशिखरं': '🏔️',
  'हिमजम्': '🧊',
  'हिमजं': '🧊',
  'हस्तिकः': '🐘',
  'हेमन्तः': '🧥',
  'हरितम्': '💚',
  'हरितं': '💚',

  // ट/ठ/ड/ढ/ण/क/ख/ग/घ/ङ जोडो + Nature
  'घटे': '🏺',
  'कोटः': '🏰',
  'वटौ': '🌳',
  'ठाटः': '✨',
  'कठिनं': '💪',
  'गोष्ठी': '👥',
  'पठुः': '🧠',
  'ठूत्कारः': '🔊',
  'कण्ठे': '🗣️',
  'मठो': '🛕',
  'डाकः': '📬',
  'खडी': '🤍',
  'पाण्डुः': '🟨',
  'मण्डूकः': '🐸',
  'वृद्धी': '📈',
  'ढुण्डुभः': '🥁',
  'ढूत्कारः': '🔊',
  'प्राणः': '💨',
  'अणूनि': '🔬',
  'प्राणे': '💨',
  'कीरः': '🦜',
  'कुसुमं': '🌸',
  'केसरः': '🌸',
  'कौतुकं': '🤩',
  'लिखितं': '✍️',
  'खूत्कारः': '😤',
  'खे': '☁️',
  'नखो': '💅',
  'गानं': '🎵',
  'गीतं': '🎵',
  'गेहे': '🏠',
  'नगैः': '⛰️',
  'गोमाता': '🐄',
  'घाटी': '🏞️',
  'मेघी': '☁️',
  'मेघे': '☁️',
  'रङ्गाः': '🌈',
  'सङ्गिः': '🤝',
  'सङ्गीतं': '🎶',
  'अङ्गुली': '☝️',
  'अङ्गूष्ठः': '👍',
  'अङ्गे': '💪',
  'रङ्गैः': '🌈',
  'रङ्गो': '🎨',
  'रङ्गौ': '🎨',
  'वटः': '🌳',
  'तटः': '🏖️',
  'कोटरः': '🪺',
  'अटवी': '🌲',
  'कर्कटकः': '🦀',
  'उटजः': '🛖',
  'अट्टः': '⛰️',
  'मठः': '🛕',
  'पीठम्': '🪨',
  'जठरम्': '🫄',
  'जठरं': '🫄',
  'गोष्ठम्': '🐄',
  'गोष्ठं': '🐄',
  'कुठारः': '🪓',
  'उत्कण्ठितः': '🐦',
  'शिलापीठम्': '🪨',
  'शिलापीठं': '🪨',
  'नडः': '🌾',
  'तडित्': '⚡',
  'उडुपः': '🌙',
  'गरुडः': '🦅',
  'मण्डलम्': '☀️',
  'मण्डलं': '☀️',
  'खड्गिन्': '🦏',
  'खड्गी': '🦏',
  'अण्डकोशः': '🥚',
  'रूढम्': '🌱',
  'रूढं': '🌱',
  'दृढस्कन्धः': '🌳',
  'गाढच्छाया': '🌳',
  'गूढबिलम्': '🕳️',
  'गूढबिलं': '🕳️',
  'बाढम्': '💦',
  'बाढं': '💦',
  'द्रढिमा': '💪',
  'गाढहरितम्': '💚',
  'गाढहरितं': '💚',
  'पुण्डरीकम्': '🪷',
  'पुण्डरीकं': '🪷',
  'क्रौञ्चः': '🐦',
  'कणः': '🌾',
  'वर्णः': '🎨',
  'चूर्णम्': '🌼',
  'चूर्णं': '🌼',
  'ऊर्णम्': '🐑',
  'ऊर्णं': '🐑',
  'कदली': '🍌',
  'कुञ्जः': '🌿',
  'किंशुकः': '🔥',
  'कदम्बः': '🌼',
  'करिः': '🐘',
  'कल्लोलः': '🌊',
  'कुशः': '🌾',
  'कूलम्': '🏖️',
  'कूलं': '🏖️',
  'मेखला': '⛰️',
  'शाखामृगः': '🐒',
  'शिखरम्': '🏔️',
  'शिखरं': '🏔️',
  'खनिः': '⛏️',
  'मुखं': '🙂',
  'खण्डः': '🪨',
  'खद्योतः': '✨',
  'गगनम्': '🌌',
  'नगः': '⛰️',
  'गर्तः': '🕳️',
  'ओघः': '🌊',
  'गभस्तिः': '☀️',
  'गन्धः': '🌸',
  'गुञ्जा': '🔴',
  'गोधूमः': '🌾',
  'उरगः': '🐍',
  'घर्मः': '🌡️',
  'घनम्': '☁️',
  'घनं': '☁️',
  'घोणा': '🐽',
  'परिघः': '⭕',
  'घनच्छाया': '🌳',
  'भुजङ्गः': '🐍',
  'शृङ्गम्': '📯',
  'शृङ्गं': '📯',
  'तुङ्गः': '🏔️',
  'भ्रुङ्गः': '🐝',
  'कुरङ्गः': '🦌',
  'अङ्गं': '💪',
  'उत्तुङ्गः': '⛰️',
  'अङ्गारः': '🔥',
  'पिङ्गलः': '🦊',

  // च–ञ / प–न जोडो + Nature
  'चित्रं': '🖼️',
  'चीरं': '🪵',
  'चुलुकं': '💧',
  'चूतः': '🥭',
  'चैत्रे': '🌸',
  'चोलकः': '🧥',
  'चौकः': '🏞️',
  'छिद्रं': '🕳️',
  'छूत्कारः': '🔊',
  'जम्बूफलं': '🍎',
  'जीवनं': '🌱',
  'मञ्जु': '🎵',
  'जूतकं': '👟',
  'जेमनं': '🍲',
  'ज्योतिः': '✨',
  'जौ': '🌾',
  'झीङ्कारः': '🔔',
  'झुमकं': '💍',
  'झूलनं': '🎠',
  'झेङ्कारः': '🐝',
  'झषैः': '🐟',
  'झोलः': '🎒',
  'झषौ': '🐟',
  'ज्ञानं': '📚',
  'अञ्जिरा': '🍈',
  'ज्ञानी': '🧠',
  'मञ्जुनदः': '🎵',
  'मञ्जूषा': '📦',
  'यज्ञे': '🔥',
  'गुणज्ञैः': '✨',
  'अज्ञो': '🙈',
  'अज्ञौ': '👥',
  'पारावतः': '🕊️',
  'पीनं': '🍑',
  'पुरतः': '➡️',
  'पूरः': '🌊',
  'तपैः': '🔥',
  'पोतं': '⛵',
  'पौषे': '❄️',
  'फाल्गुने': '🌸',
  'स्फितिः': '🌾',
  'फीत्कारः': '💨',
  'फुल्लं': '🌸',
  'फेनं': '🫧',
  'सफलैः': '🍎',
  'स्फोटः': '💥',
  'शफौ': '🐴',
  'मारालः': '🦢',
  'मिलिन्दः': '🐝',
  'मीनौ': '🐟',
  'मुकुलं': '🌱',
  'मूषिकः': '🐭',
  'मेघगर्जनं': '⛈️',
  'मैनाकः': '⛰️',
  'मोरः': '🦚',
  'नाकं': '🌌',
  'निकुञ्जः': '🌿',
  'नीरं': '💧',
  'नूतनं': '🍃',
  'चक्रवाकः': '🦆',
  'चकोरः': '🐦',
  'चन्दनम्': '🪵',
  'चूतवृक्षः': '🥭',
  'चटका': '🐦',
  'चित्रकः': '🐆',
  'चमसपुष्पम्': '🌸',
  'अचिरप्रसूनम्': '🌺',
  'चञ्चरीकः': '🐝',
  'छदनम्': '🍃',
  'मच्छिका': '🪰',
  'पर्णच्छदः': '🍃',
  'छत्रकः': '🍄',
  'मेघच्छायम्': '☁️',
  'चिरबिल्वः': '🌳',
  'जम्बुकः': '🦊',
  'जतुका': '🦇',
  'जम्बूफलम्': '🍎',
  'जवा': '🌺',
  'ज्योत्स्ना': '🌕',
  'जालिका': '🕸️',
  'जलचरः': '🐠',
  'जवनः': '🐴',
  'जातीपुष्पम्': '🌼',
  'जतु': '🟤',
  'झषः': '🐟',
  'झङ्कारः': '🐝',
  'झाटी': '🌿',
  'झर्झरः': '🥁',
  'झषराजः': '🐟',
  'झिल्लीनादः': '🦗',
  'वात्यझञ्झा': '💨',
  'झिल्लीकः': '🦗',
  'झञ्झावातः': '🌪️',
  'किञ्जल्कः': '🌸',
  'मञ्जिष्ठा': '🔴',
  'गुञ्जनम्': '🐝',
  'वञ्जुलः': '🎋',
  'पिञ्छम्': '🦚',
  'अञ्जलिपत्रम्': '🍃',
  'अञ्जिरवृक्षः': '🌳',
  'परागः': '🌼',
  'पन्नगः': '🐍',
  'प्रसूनम्': '🌸',
  'पक्वफलम्': '🍎',
  'पिप्पलः': '🌳',
  'पवनवेगः': '💨',
  'पल्लवितः': '🌱',
  'कुररः': '🦅',
  'तित्तिरिः': '🐦',
  'फेनिलम्': '🫧',
  'फलिनः': '🌳',
  'फेरवः': '🦊',
  'स्फुलिङ्गः': '✨',
  'उत्फुल्लम्': '🪷',
  'शफरः': '🐟',
  'फेनपुञ्जः': '🫧',
  'अम्बुजम्': '🪷',
  'मल्लिका': '🌼',
  'मधुकरः': '🐝',
  'मर्कतः': '🐒',
  'मुकुलम्': '🌱',
  'मधूलिका': '🌸',
  'मधुकरी': '🐝',
  'मरालयूथम्': '🦢',
  'नीहारः': '🌫️',
  'नारिकेलः': '🥥',
  'निर्झरः': '💦',
  'नक्षत्रम्': '⭐',
  'नवपत्रम्': '🍃',
  'नगकन्दरः': '🕳️',
  'नभश्चरः': '🦅',
  'नलिनम्': '🪷',
  'निम्बः': '🌳',
  'न्यग्रोधः': '🌳',

  // थ / क्ष / ज्ञ / त्र जोडो + Nature
  'था': '🍽️',
  'थि': '🌳',
  'थी': '📖',
  'थु': '⛰️',
  'थे': '🦌',
  'थै': '🛕',
  'थो': '🏇',
  'थौ': '🏇',
  'क्षा': '🪽',
  'क्षि': '🐦',
  'क्षी': '🥛',
  'क्षु': '🎋',
  'क्षू': '🎋',
  'क्षे': '🌾',
  'क्षै': '🪽',
  'क्षो': '🌳',
  'क्षौ': '🌳',
  'ज्ञा': '🏷️',
  'ज्ञि': '🌼',
  'ज्ञी': '🧠',
  'ज्ञु': '😊',
  'ज्ञू': '👥',
  'ज्ञे': '🔎',
  'ज्ञै': '✨',
  'ज्ञो': '📚',
  'ज्ञौ': '👥',
  'त्रा': '🤝',
  'त्रि': '🐦',
  'त्री': '🌙',
  'त्रु': '🐺',
  'त्रू': '🐺',
  'त्रे': '🍃',
  'त्रै': '👦',
  'त्रो': '👦',
  'त्रौ': '👦',
  'थालं': '🍽️',
  'कथिता': '📖',
  'पृथुः': '⛰️',
  'थूत्कारः': '💨',
  'रथैः': '🛕',
  'रथो': '🏇',
  'रथौ': '🏇',
  'पक्षाः': '🪽',
  'पक्षिणः': '🐦',
  'ईक्षुः': '🎋',
  'ईक्षू': '🎋',
  'क्षेत्रे': '🌾',
  'पक्षैः': '🪽',
  'वृक्षो': '🌳',
  'वृक्षौ': '🌳',
  'संज्ञा': '🏷️',
  'यज्ञिकः': '🌼',
  'विज्ञानी': '🧠',
  'प्रज्ञुः': '😊',
  'प्रज्ञू': '👥',
  'विज्ञेयं': '🔎',
  'सर्वज्ञैः': '✨',
  'विज्ञो': '📚',
  'विज्ञौ': '👥',
  'मित्राणि': '🤝',
  'पत्रिणः': '🐦',
  'रात्री': '🌙',
  'शत्रुः': '🐺',
  'शत्रू': '🐺',
  'पत्रे': '🍃',
  'पुत्रैः': '👦',
  'पुत्रो': '👦',
  'पुत्रौ': '👦',
  'थलचरः': '🐾',
  'पृथुकः': '🐣',
  'थलपद्मम्': '🪷',
  'पथशिला': '🪨',
  'पृथुपर्णम्': '🍃',
  'थलकुसुमम्': '🌸',
  'सुपथम्': '🛤️',
  'पृथुफलम्': '🍎',
  'थलनीडम्': '🪺',
  'पथमृगः': '🦌',
  'अक्षोटः': '🥜',
  'ईक्षुदण्डः': '🎋',
  'पक्षिगणः': '🐦',
  'वृक्षवाटी': '🏞️',
  'नीलपक्षः': '🐦',
  'क्षुद्रखगः': '🐤',
  'ईक्षुक्षेत्रम्': '🌾',
  'रक्षावनम्': '🌲',
  'कक्षगुल्मः': '🌿',
  'दक्षिणवायुः': '💨',
  'यज्ञवृक्षः': '🌳',
  'यज्ञकुसुमम्': '🌺',
  'संज्ञातरुः': '🌳',
  'प्रज्ञापक्षी': '🦅',
  'विज्ञसरः': '🏞️',
  'अज्ञेयकन्दरः': '🕳️',
  'जिज्ञासाहंसः': '🦢',
  'सुज्ञमयूरः': '🦚',
  'परिज्ञातगिरिः': '⛰️',
  'आज्ञापवनः': '🌬️',
  'पत्रिगणः': '🐦',
  'सपत्रतरुः': '🌳',
  'त्रिदलपुष्पम्': '🌸',
  'रात्रिखगः': '🦉',
  'उत्पलपत्रम्': '🍃',
  'त्रिधारा': '💧',
  'मित्रवनम्': '🌲',
  'पत्रशयनम्': '🛏️',
  'अत्रिसरः': '🏞️',
  'गोत्रतरुः': '🌳',
  'आश्रयतरुः': '🌳',
  'श्रवणखगः': '🐦',
  'श्रीफलम्': '🥭',
  'श्रुतसरः': '🏞️',
  'श्रेष्ठगिरिः': '⛰️',
  'आश्रमवनम्': '🌲',
  'मिश्रपुष्पम्': '🌸',
  'श्रद्धालता': '🌿',
  'श्रोत्रमयूरः': '🦚',
  'आश्रयनीडम्': '🪺',
  'प्रभातसूर्यः': '🌅',
  'प्रियखगः': '🐦',
  'प्रीतिवनम्': '💚',
  'प्रसन्नसरः': '✨',
  'प्रपातझरः': '💧',
  'प्रफुल्लपुष्पम्': '🌺',
  'प्रशान्तगिरिः': '🏔️',
  'प्रचुरफलम्': '🍎',
  'प्रबलपवनः': '💨',
  'प्रभाचन्द्रः': '🌕',
  'प्रवालशिला': '🪸',
  'प्रसन्नमयूरः': '🦚',
  'प्रसारितपक्षः': '🪽',
  'प्रसन्नकमलम्': '🪷',
  'प्रपातशिला': '🪨',
  'प्रचुरपर्णम्': '🍃',
  'प्रीतिमधु': '🍯',
  'प्रभातपवनः': '🌬️',
  'प्रियमृगः': '🦌',
  'प्रसन्नहंसः': '🦢',
  'क्रीडामृगः': '🦌',
  'क्रुद्धसिंहः': '🦁',
  'क्रूरसर्पः': '🐍',
  'क्रौञ्चपक्षी': '🐦',
  'विक्रान्तगजः': '🐘',
  'चक्रवाकहंसः': '🦢',
  'वज्रशिला': '⚡',
  'क्रीडानीडम्': '🪺',
  'क्रान्तमार्गः': '🛤️',
  'सुक्रियखगः': '🐦',
  'क्रीडाशशकः': '🐇',
  'विक्रमसिंहः': '🦁',
  'क्रोधमेघः': '⛈️',
  'चक्रपुष्पम्': '🌼',
  'क्रीडाकन्दुकः': '⚽',
  'सुक्रूरसर्पः': '🐍',
  'क्रौञ्चनीडम्': '🪺',
  'आक्रान्तगिरिः': '⛰️',
  'प्रक्रान्तपथः': '🛤️',
  'श्रमखगः': '🐦',
  'श्रावणे': '🌧️',
  'आश्रितः': '🪺',
  'श्रीः': '✨',
  'श्रुतं': '👂',
  'श्रूयते': '👂',
  'श्रेष्ठं': '🏆',
  'मिश्रैः': '🎨',
  'श्रोता': '👂',
  'श्रौतं': '📿',
  'प्रातः': '🌅',
  'प्रियः': '💛',
  'प्रीतिः': '💗',
  'प्रुषन्ति': '💧',
  'प्रूषतः': '💧',
  'प्रेङ्खायां': '🎠',
  'प्रैषं': '📜',
  'प्रोक्तं': '🗣️',
  'प्रौढः': '🌳',
  'चक्राणि': '⚙️',
  'क्रिया': '⚡',
  'क्रीडति': '🎮',
  'क्रुद्धः': '😠',
  'क्रूरः': '🐍',
  'विक्रेयं': '🛒',
  'चक्रैः': '⚙️',
  'क्रोशति': '🐦',
  'ग्रामतरुः': '🌳',
  'ग्रीष्मसूर्यः': '☀️',
  'उग्रसिंहः': '🦁',
  'ग्रीवामृगः': '🦌',
  'अग्रिपक्षिणी': '🐦',
  'ग्रावमयूरः': '🦚',
  'उग्राशनिः': '⚡',
  'ग्रन्थिलता': '🌿',
  'संग्रहनीडम्': '🪺',
  'ग्रोष्ठधेनुः': '🐄',
  'द्रुमपुष्पम्': '🌸',
  'द्राक्षालता': '🍇',
  'अद्रिशिखरम्': '🏔️',
  'चन्द्रकान्तिः': '🌕',
  'समुद्रतटः': '🏖️',
  'द्रोणीसरः': '🏞️',
  'मधुद्रवः': '🍯',
  'रुद्रपुष्पम्': '🌺',
  'चन्द्रातपः': '🌙',
  'द्रुतमृगः': '🦌',
  'ब्रीहिक्षेत्रम्': '🌾',
  'ब्राहीपत्रम्': '🍃',
  'ब्रूतखगः': '🐦',
  'बृहद्द्रुमः': '🌳',
  'सब्रह्मवनम्': '🌲',
  'अब्रकमलम्': '🪷',
  'ब्रिन्दपुष्पम्': '💐',
  'उब्रौढफलम्': '🍎',
  'द्विरदगजः': '🐘',
  'द्वीपखगः': '🐦',
  'अद्वितीयपुष्पम्': '🌼',
  'द्वादशखगाः': '🐦',
  'द्वयसरः': '🏞️',
  'सुद्वीपवनम्': '🏝️',
  'द्विपक्षः': '🪽',
  'द्वितीयहंसः': '🦢',
  'सत्त्वमृगः': '🦌',
  'सत्त्वहंसः': '🦢',
  'महत्त्वगिरिः': '⛰️',
  'मधुरत्वम्': '🍯',
  'ग्रामे': '🏘️',
  'अग्रिमः': '🐦',
  'ग्रीष्मे': '☀️',
  'ग्रुञ्जति': '🐝',
  'ग्रूढबीजं': '🌱',
  'अग्रे': '🦚',
  'ग्रैवेयः': '📿',
  'ग्रोष्ठे': '🐄',
  'उग्रौ': '🦁',
  'द्राक्षा': '🍇',
  'अद्रिषु': '⛰️',
  'चन्द्रीका': '🌕',
  'द्रुमः': '🌳',
  'द्रूतः': '🦌',
  'चन्द्रे': '🌙',
  'समुद्रैः': '🌊',
  'द्रोण्यां': '🏞️',
  'उद्रौ': '🦦',
  'ब्राही': '🌿',
  'ब्रिन्दं': '💐',
  'ब्रीहिः': '🌾',
  'ब्रुवन्': '🗣️',
  'ब्रूते': '🗣️',
  'ब्रेधितः': '🌱',
  'सब्रैः': '🌸',
  'सब्रोढं': '🐘',
  'ब्रौढं': '🍎',
  'द्वा': '🐦',
  'द्विरदः': '🐘',
  'द्वीपे': '🏝️',
  'अद्वुतं': '✨',
  'द्वूर्जं': '🍃',
  'द्वे': '🌸',
  'द्वैप्यः': '🐊',
  'द्वयोः': '🪺',
  'द्वौ': '🐦',
  'पठित्वा': '📖',
  'त्विषि': '✨',
  'सत्त्वी': '🐄',
  'सत्त्वुः': '🦌',
  'मधुरत्वू': '🍯',
  'सत्त्वे': '🦢',
  'महत्त्वैः': '⛰️',
  'सत्त्वो': '🦌',
  'सत्त्वौ': '🦢',
  'हस्तपुष्पम्': '🌸',
  'हस्तिगजः': '🐘',
  'स्तुतिखगः': '🐦',
  'स्तूपगिरिः': '⛰️',
  'हस्तेकमलम्': '🪷',
  'प्रस्तोतृपक्षी': '🐦',
  'हस्तौपल्लवौ': '🌿',
  'वस्तुवनम्': '🌲',
  'स्वादुफलम्': '🍎',
  'स्वर्णखगः': '🐦',
  'स्वच्छसरः': '🏞️',
  'स्वेदबिन्दुः': '💧',
  'स्वैरमृगः': '🦌',
  'स्वोद्यानपुष्पम्': '🌼',
  'अस्वस्थपवनः': '💨',
  'स्वागतखगः': '🐦',
  'स्मितमुखम्': '😊',
  'स्मारकवृक्षः': '🌳',
  'स्मेरपद्मम्': '🪷',
  'विस्मयमेघः': '☁️',
  'स्मीरणलता': '🌿',
  'अस्मिन्वने': '🌲',
  'स्मृतिपुष्पम्': '🌺',
  'विस्मृतबीजम्': '🌱',
  'स्नानसरः': '🏞️',
  'स्निग्धपर्णम्': '🍃',
  'स्नेहमयूरः': '🦚',
  'प्रस्नुतदुग्धम्': '🥛',
  'स्नुषाकमलम्': '🪷',
  'स्नोतझरः': '💧',
  'स्नेहिलता': '🌿',
  'सुस्निग्धमृगः': '🦌',
  'वृष्टिजलम्': '🌧️',
  'अष्टदलम्': '🪷',
  'इष्टपुष्पम्': '🌸',
  'कष्टमार्गः': '🪨',
  'यष्टिवृक्षः': '🌳',
  'तुष्टखगः': '🐦',
  'सृष्टिकमलम्': '🪷',
  'अष्टशिखरम्': '🏔️',
  'हस्तात्': '✋',
  'हस्ती': '🐘',
  'स्तुतिं': '🙏',
  'स्तूपः': '🛕',
  'प्रस्तोता': '🎤',
  'स्वादु': '🍎',
  'स्विन्नः': '💦',
  'स्वीयं': '📖',
  'स्वुरति': '🐝',
  'स्वूतिः': '💨',
  'स्वेदेन': '💦',
  'स्वैः': '🌸',
  'स्वोत्साहः': '⭐',
  'स्वौ': '🐦',
  'स्मारकं': '🏛️',
  'स्मितं': '😊',
  'स्मीरणः': '💨',
  'विस्मुग्धः': '✨',
  'स्मूतिपत्रं': '📜',
  'स्मेरं': '😊',
  'अस्मै': '🍎',
  'विस्मयो': '😮',
  'स्मौक्तिकं': '🫧',
  'स्नानं': '🛁',
  'स्निग्धं': '🍃',
  'स्नीह्यति': '🐄',
  'स्नुषा': '👩',
  'प्रस्नुतं': '🥛',
  'स्नेहेन': '💕',
  'स्नैहिकं': '🫒',
  'स्नोतः': '💧',
  'स्नौते': '🐟',
  'इष्टा': '🙏',
  'इष्टी': '🔥',
  'तुष्टुः': '🐦',
  'तुष्टूरं': '🎺',
  'कष्टे': '🪨',
  'अष्टैः': '8️⃣',
  'इष्टो': '🛕',
  'अष्टौ': '8️⃣',
  'ह्रदजलम्': '🏞️',
  'ह्रस्वखगः': '🐦',
  'ह्रीमत्पद्मम्': '🪷',
  'ह्रुदयस्नेहः': '💕',
  'ह्रेपितमृगः': '🦌',
  'ह्रस्वतरुः': '🌳',
  'सुह्रदसरः': '🏞️',
  'ह्रासपवनः': '💨',
  'सह्यागिरिः': '⛰️',
  'ह्यस्तनपुष्पम्': '🥀',
  'सह्यवनम्': '🌲',
  'ह्युत्साहसिंहः': '🦁',
  'ह्योत्सवमयूरः': '🦚',
  'प्रियह्यखगः': '🐦',
  'ह्येयपथः': '🥾',
  'ह्यूतबीजम्': '🌱',
  'वस्त्रपुष्पम्': '🌸',
  'स्त्रीकमलम्': '🪷',
  'शस्त्रमेघः': '☁️',
  'तन्त्रिखगः': '🐦',
  'वस्त्रतरुः': '🌳',
  'सुस्त्रोतजलम्': '💧',
  'अस्त्रवनम्': '🌲',
  'वस्त्रपल्लवः': '🌿',
  'पङ्ककमलम्': '🪷',
  'अङ्कुरपत्रम्': '🍃',
  'शङ्खध्वनिः': '🐚',
  'अङ्कमृगः': '🦌',
  'पङ्किलजलम्': '💧',
  'शङ्कासिंहः': '🦁',
  'अङ्केशिशुः': '👶',
  'तुङ्कशिखरम्': '🏔️',
  'इच्छापुष्पम्': '🌸',
  'गच्छत्खगः': '🐦',
  'उच्छ्रिततरुः': '🌳',
  'मत्स्यच्छत्रम्': '🐟',
  'इच्छामयूरः': '🦚',
  'आच्छादितगिरिः': '⛰️',
  'उच्छिष्टफलम्': '🍎',
  'स्वच्छपवनः': '💨',
  'ह्रादात्': '🏞️',
  'ह्रस्वः': '🧒',
  'ह्रीमती': '👧',
  'ह्रुदये': '❤️',
  'ह्रूतः': '🔇',
  'ह्रेपते': '🥶',
  'मह्रैः': '🌸',
  'ह्रोडं': '🍎',
  'ह्रौद्रं': '☁️',
  'सह्याचलः': '⛰️',
  'ह्यिष्ठं': '🌸',
  'ह्यीनपत्रं': '🍃',
  'ह्युत्साहः': '⭐',
  'ह्यूतबीजं': '🌱',
  'ह्येयमार्गः': '🥾',
  'ह्यैः': '🐦',
  'ह्योत्सवे': '🎉',
  'ह्यौ': '🌸',
  'वस्त्राणि': '👕',
  'तन्त्रिणी': '🎻',
  'स्त्री': '👩',
  'शस्त्रुः': '⚔️',
  'शस्त्रू': '⚔️',
  'वस्त्रे': '👕',
  'वस्त्रैः': '👕',
  'शस्त्रोद्याने': '🌳',
  'वस्त्रौ': '👕',
  'पङ्कात्': '🪷',
  'अङ्कितं': '🍃',
  'शङ्की': '🦌',
  'पङ्कू': '💧',
  'अङ्के': '👶',
  'शङ्कैः': '🦁',
  'पङ्कोद्भवं': '🪷',
  'अङ्कौ': '✋',
  'इच्छा': '💭',
  'गच्छति': '🚶',
  'विच्छिन्नं': '🍃',
  'इच्छी': '🍎',
  'मत्स्यच्छुरा': '🐟',
  'च्छूतः': '🔇',
  'इच्छेयं': '📖',
  'इच्छैः': '🧘',
  'उच्छोषः': '🍃',
  'इच्छौ': '🍎',
  'वृत्तपथः': '🥾',
  'कृष्णलता': '🌿',
  'भक्तपुष्पम्': '🌸',
  'शक्तिसिंहः': '🦁',
  'भक्तिखगः': '🐦',
  'युक्तमार्गः': '🥾',
  'मुक्तपवनः': '💨',
  'सक्तमधु': '🍯',
  'रक्तकमलम्': '🪷',
  'व्यक्तचन्द्रः': '🌙',
  'अर्थतरुः': '🌳',
  'सार्थयात्रा': '🧭',
  'पार्थिवगिरिः': '⛰️',
  'समर्थमृगः': '🦌',
  'अनर्थमेघः': '☁️',
  'परार्थपुष्पम्': '🌺',
  'स्वार्थरहितः': '🧘',
  'निरर्थकपत्रम्': '🍃',
  'पूर्णचन्द्रः': '🌕',
  'वर्णखगः': '🦜',
  'कर्णमृगः': '🦌',
  'चूर्णपुष्पम्': '🌼',
  'सुवर्णकिरणः': '✨',
  'अपर्णतरुः': '🌳',
  'पर्णशय्या': '🍃',
  'निर्णयपथः': '🛤️',
  'तृष्णाहरी': '💧',
  'कृष्णमेघः': '☁️',
  'विष्णुपदम्': '🦶',
  'उष्णकिरणः': '☀️',
  'श्लक्ष्णपत्रम्': '🍃',
  'कृष्णसर्पः': '🐍',
  'शुष्णाभूमिः': '🏜️',
  'वर्ष्णिलता': '🌿',
  'पत्तीहरिता': '🍃',
  'उत्तिष्ठत्खगः': '🐦',
  'सत्तववृक्षः': '🌳',
  'उत्तुङ्गशिखरम्': '🏔️',
  'पत्तेकीटः': '🐛',
  'वृत्तफलम्': '🍎',
  'मत्तभ्रमरः': '🐝',
  'नित्तपवनः': '💨',
  'भक्ता': '🙏',
  'शक्तिः': '💪',
  'भक्ती': '🙏',
  'भक्तुं': '🙏',
  'भक्तू': '🙏',
  'भक्ते': '❤️',
  'भक्तैः': '🙏',
  'भक्तो': '🙏',
  'भक्तौ': '🙏',
  'अर्थात्': '💡',
  'अर्थिना': '🙋',
  'अर्थुं': '💡',
  'अर्थू': '💡',
  'पूर्णां': '🌕',
  'वर्णितं': '🎨',
  'पूर्णी': '🌕',
  'चूर्णुं': '🧂',
  'चूर्णू': '🧂',
  'पूर्णे': '🌕',
  'वर्णैः': '🎨',
  'पूर्णो': '🌕',
  'कृष्णिकं': '☁️',
  'कृष्णी': '🌑',
  'विष्णुं': '🕉️',
  'विष्णू': '🕉️',
  'कृष्णे': '🌲',
  'कृष्णैः': '☁️',
  'कृष्णो': '☁️',
  'कृष्णौ': '☁️',
  'सत्ता': '👑',
  'उत्तिष्ठति': '🌅',
  'पत्ती': '🍃',
  'उत्तूला': '🌸',
  'पत्ते': '🍃',
  'उत्तैः': '🌳',
  'पत्तो': '🍃',
  'पत्तौ': '🍃',
  'बुद्धपुष्पम्': '🌸',
  'वृद्धतरुः': '🌳',
  'शुद्धपवनः': '💨',
  'बुद्धिहंसः': '🦢',
  'सिद्धिगिरिः': '⛰️',
  'शुद्धसरः': '🏞️',
  'वृद्धसिंहः': '🦁',
  'बुद्धमृगः': '🦌',
  'लब्धफलम्': '🍎',
  'लब्धिपुष्पम्': '🌺',
  'उब्धमेघः': '☁️',
  'लब्धमधु': '🍯',
  'सम्बद्धलता': '🌿',
  'लब्धपल्लवः': '🍃',
  'उब्धबीजम्': '🌱',
  'लब्धकिरणः': '✨',
  'कुम्भसरः': '🏺',
  'शम्भुगिरिः': '⛰️',
  'गम्भीरसरः': '🏞️',
  'कुम्भपवनः': '💨',
  'शम्भुपुष्पम्': '🌸',
  'स्तम्भतरुः': '🌳',
  'कुम्भमत्स्यः': '🐟',
  'गम्भीरमेघः': '☁️',
  'सञ्जातपुष्पम्': '🌼',
  'पञ्जरखगः': '🐦',
  'मञ्जुगानम्': '🎵',
  'अञ्जलिपद्मम्': '🪷',
  'कुञ्जवनम्': '🌲',
  'मञ्जीरमयूरः': '🦚',
  'सञ्जीवबीजम्': '🌱',
  'मञ्जुलता': '🌿',
  'पञ्चदलम्': '🪷',
  'काञ्चनकिरणः': '☀️',
  'मञ्चखगः': '🐦',
  'पञ्चशिखरम्': '🏔️',
  'अञ्चलपवनः': '💨',
  'काञ्चीमार्गः': '🥾',
  'मुञ्चत्खगः': '🐦',
  'पञ्चवर्णखगः': '🦜',
  'बुद्धा': '🙏',
  'शुद्धुं': '💧',
  'वृद्धू': '👴',
  'बुद्धे': '❤️',
  'बुद्धैः': '🧘',
  'बुद्धो': '🧘',
  'बुद्धौ': '📖',
  'लब्धा': '📚',
  'लब्धिः': '🍎',
  'लब्धी': '💡',
  'लब्धुं': '🙋',
  'लब्धू': '✨',
  'लब्धे': '🍎',
  'लब्धैः': '🌺',
  'लब्धो': '💡',
  'लब्धौ': '🍎',
  'कुम्भात्': '🏺',
  'कुम्भिनि': '🏺',
  'गम्भीरा': '🏞️',
  'शम्भुं': '🕉️',
  'कुम्भू': '🏺',
  'कुम्भे': '💧',
  'कुम्भैः': '🏺',
  'शम्भोः': '🛕',
  'कुम्भौ': '🏺',
  'सञ्जातं': '🌸',
  'अञ्जितं': '👁️',
  'कुञ्जी': '🔑',
  'मञ्जू': '🎵',
  'मञ्जे': '🌳',
  'मञ्जैः': '🌺',
  'मञ्जो': '🎤',
  'मञ्जौ': '🐦',
  'पञ्चाशत्': '🐦',
  'अञ्चितं': '🙇',
  'काञ्ची': '🏙️',
  'मुञ्चति': '🕊️',
  'मुञ्चू': '🕊️',
  'मञ्चे': '🪑',
  'पञ्चैः': '🌸',
  'मञ्चो': '🪜',
  'मञ्चौ': '🪜',

  'उत्थानसूर्यः': '☀️',
  'उत्थितपवनः': '💨',
  'उत्थानकमलम्': '🪷',
  'उत्थिततरुः': '🌳',
  'उत्थानमेघः': '☁️',
  'उत्थानखगः': '🐦',
  'अश्वत्थपत्रम्': '🍃',
  'उत्थानगिरिः': '⛰️',
  'उद्दामपवनः': '💨',
  'उद्दीपकिरणः': '✨',
  'उद्दिष्टफलम्': '🍎',
  'उद्दाममेघः': '☁️',
  'उद्दीपप्रकाशः': '💡',
  'उद्दामसिंहः': '🦁',
  'उद्दिष्टमार्गः': '🥾',
  'बृहद्द्रुमपत्रम्': '🍃',
  'पिप्पलछाया': '🌳',
  'पिप्पलफलम्': '🍎',
  'पुप्पगन्धः': '🌸',
  'पुप्पभ्रमरः': '🐝',
  'पुप्पतरुः': '🌳',
  'पुप्पमाला': '🌺',
  'पुप्पपरागः': '✨',
  'पुप्पोद्यानम्': '🏡',
  'उच्चवृक्षः': '🌳',
  'उच्चशिखरम्': '🏔️',
  'उच्चमेघः': '☁️',
  'उच्चशाखायां': '🐦',
  'उच्चगिरिः': '⛰️',
  'उच्चपवनः': '💨',
  'उच्चनीडम्': '🪺',
  'उच्चैःस्वरः': '🔊',
  'फुल्लकमलम्': '🪷',
  'मल्लक्रीडा': '🤼',
  'पल्लीमार्गः': '🥾',
  'उल्लासपवनः': '💨',
  'फुल्लोद्यानम्': '🌸',
  'पल्लवकिरणः': '✨',
  'कल्लोलमेघः': '☁️',
  'भल्लूकगुहा': '🐻',
  'उत्थाय': '🙇',
  'उत्थितः': '☀️',
  'उत्थी': '✨',
  'उत्थुं': '🙋',
  'उत्थू': '✨',
  'उत्थे': '🐦',
  'उत्थैः': '🌸',
  'उत्थो': '😄',
  'उत्थौ': '🏃',
  'उद्दामः': '💨',
  'उद्दिष्टं': '🍎',
  'उद्दीपः': '🪔',
  'उद्दुं': '💧',
  'उद्दू': '✨',
  'उद्दे': '🦌',
  'उद्दैः': '🌺',
  'उद्दो': '🐘',
  'उद्दौ': '🐦',
  'पुप्पात्': '🌸',
  'पुप्पि': '🍯',
  'पुप्पी': '🌸',
  'पुप्पुं': '🙋',
  'पुप्पू': '🌸',
  'पुप्पे': '🐝',
  'पुप्पैः': '🌺',
  'पुप्पो': '🌼',
  'पुप्पौ': '🌸',
  'उच्चा': '🌿',
  'सच्चित्तं': '🧘',
  'उच्ची': '🌿',
  'उच्चुं': '🐦',
  'उच्चू': '✨',
  'उच्चे': '🐦',
  'उच्चैः': '🔊',
  'उच्चो': '🌳',
  'उच्चौ': '🌳',
  'मल्लाः': '🤼',
  'पल्ली': '🏘️',
  'मल्लुं': '👀',
  'फुल्ले': '🐝',
  'मल्लैः': '🤼',
  'मल्लौ': '🤼',
  'कीर्तिपुष्पम्': '🌸',
  'ऋतुपवनः': '💨',
  'वसन्तर्तुः': '🌷',
  'कर्ताखगः': '🐦',
  'कीर्तिगिरिः': '⛰️',
  'ऋतुमेघः': '☁️',
  'कर्तातरुः': '🌳',
  'कीर्तिमयूरः': '🦚',
  'अर्धचन्द्रः': '🌓',
  'वृद्धिपल्लवः': '🍃',
  'समृद्धवनम्': '🌲',
  'अर्धकिरणः': '✨',
  'वृद्धिमेघः': '☁️',
  'अर्धसरः': '🏞️',
  'समृद्धपुष्पम्': '🌺',
  'वृद्धिसिंहः': '🦁',
  'गर्भबीजम्': '🌱',
  'निर्भरजलम्': '💧',
  'गर्भकमलम्': '🪷',
  'निर्भरपवनः': '💨',
  'गर्भतरुः': '🌳',
  'गर्भपुष्पम्': '🌸',
  'निर्भरमेघः': '☁️',
  'गर्भमृगः': '🦌',
  'दुर्गगिरिः': '⛰️',
  'स्वर्गतारा': '⭐',
  'दुर्गशिखरम्': '🏔️',
  'स्वर्गपवनः': '💨',
  'दुर्गवनम्': '🌲',
  'स्वर्गखगः': '🐦',
  'दुर्गमेघः': '☁️',
  'स्वर्गकमलम्': '🪷',
  'धर्मतरुः': '🌳',
  'कर्मपुष्पम्': '🌼',
  'धर्मपवनः': '💨',
  'कर्मखगः': '🐦',
  'धर्मगिरिः': '⛰️',
  'कर्ममार्गः': '🥾',
  'धर्मसरः': '🏞️',
  'कर्ममेघः': '☁️',
  'कर्ता': '👦',
  'कीर्ती': '✨',
  'ऋतुः': '🌸',
  'ऋतू': '🍂',
  'कीर्तेः': '⭐',
  'कीर्तैः': '🏆',
  'कर्तो': '🛠️',
  'कर्तौ': '👥',
  'अर्धा': '🌓',
  'वृद्धिः': '🌱',
  'अर्धुं': '🍎',
  'अर्धू': '✨',
  'अर्धे': '☀️',
  'अर्धैः': '🌺',
  'अर्धो': '🌙',
  'अर्धौ': '🌓',
  'गर्भात्': '🌱',
  'निर्भरि': '💧',
  'गर्भी': '✨',
  'गर्भुं': '🌱',
  'गर्भू': '✨',
  'गर्भे': '🌱',
  'गर्भैः': '🌍',
  'गर्भो': '🌱',
  'गर्भौ': '✨',
  'स्वर्गि': '🐦',
  'दुर्गी': '✨',
  'स्वर्गुं': '👀',
  'स्वर्गू': '✨',
  'स्वर्गे': '⭐',
  'स्वर्गो': '☁️',
  'स्वर्गौ': '✨',
  'कर्मा': '🛠️',
  'धर्मि': '☮️',
  'धर्मी': '🙏',
  'कर्मुं': '🙋',
  'कर्मू': '✨',
  'धर्मे': '⚖️',
  'धर्मैः': '🕊️',
  'धर्मो': '🕉️',
  'धर्मौ': '✨',
  'अन्ना': '🍲',
  'पन्नगि': '🐍',
  'पन्नगी': '✨',
  'अन्नुं': '🥣',
  'अन्नू': '✨',
  'अन्ने': '🍚',
  'अन्नैः': '🥗',
  'अन्नो': '🍞',
  'अन्नौ': '✨',
  'सम्मानं': '🙏',
  'सम्मिलनं': '🤝',
  'सम्मी': '✨',
  'सम्मुखं': '👀',
  'सम्मू': '✨',
  'सम्मे': '😊',
  'सम्मैः': '👥',
  'सम्मोदः': '😄',
  'सम्मौ': '✨',
  'शय्या': '🛏️',
  'शय्यि': '😴',
  'शय्यी': '✨',
  'शय्युं': '🛏️',
  'शय्यू': '✨',
  'शय्ये': '😴',
  'शय्यैः': '🛏️',
  'शय्यो': '🛏️',
  'शय्यौ': '✨',
  'सर्रा': '🛤️',
  'तर्रि': '🐦',
  'तर्री': '✨',
  'सर्रुं': '👀',
  'सर्रू': '✨',
  'सर्रे': '🌸',
  'सर्रैः': '💨',
  'सर्रो': '🛤️',
  'सर्रौ': '✨',
  'सव्वा': '🏃',
  'सव्वि': '🏘️',
  'सव्वी': '✨',
  'सव्वुं': '🙋',
  'सव्वू': '✨',
  'सव्वे': '😊',
  'सव्वैः': '👥',
  'सव्वो': '✨',
  'सव्वौ': '✨',
  'अन्नपुष्पम्': '🌸',
  'अन्नतरुः': '🌳',
  'अन्नपवनः': '💨',
  'भिन्नपुष्पम्': '🌺',
  'अन्नमेघः': '☁️',
  'अन्नसरः': '🏞️',
  'भिन्नखगः': '🐦',
  'अन्नगिरिः': '⛰️',
  'सम्मानतरुः': '🌳',
  'सम्मुखपवनः': '💨',
  'सम्मतपुष्पम्': '🌼',
  'सम्मानगिरिः': '⛰️',
  'सम्मानकमलम्': '🪷',
  'सम्मुखखगः': '🐦',
  'सम्मानसरः': '🏞️',
  'सम्मतमेघः': '☁️',
  'शय्यापुष्पम्': '🌸',
  'शय्यापवनः': '💨',
  'शय्यातरुः': '🌳',
  'शय्यामेघः': '☁️',
  'शय्याकमलम्': '🪷',
  'शय्याखगः': '🐦',
  'शय्यागिरिः': '⛰️',
  'शय्यावनम्': '🌲',
  'सर्रपवनः': '💨',
  'तर्रपुष्पम्': '🌸',
  'सर्रतरुः': '🌳',
  'तर्रमेघः': '☁️',
  'सर्रगिरिः': '⛰️',
  'तर्रखगः': '🐦',
  'सर्रसरः': '🏞️',
  'तर्रवनम्': '🌲',
  'सव्वपवनः': '💨',
  'सव्वपुष्पम्': '🌼',
  'सव्वतरुः': '🌳',
  'सव्वमेघः': '☁️',
  'सव्वकमलम्': '🪷',
  'सव्वखगः': '🐦',
  'सव्वगिरिः': '🏔️',
  'सव्वसरः': '🏞️',
  'स्कन्धतरुः': '🌳',
  'स्कन्दपुष्पम्': '🌸',
  'स्कुरपवनः': '💨',
  'स्कन्धगिरिः': '⛰️',
  'स्कुरविद्युत्': '⚡',
  'स्कन्दखगः': '🐦',
  'स्कन्धवनम्': '🌲',
  'स्कुरकमलम्': '🪷',
  'स्पन्दपवनः': '💨',
  'स्पष्टगिरिः': '⛰️',
  'स्पृहापुष्पम्': '🌺',
  'स्पन्दमेघः': '☁️',
  'स्पष्टसरः': '🏞️',
  'स्पन्दखगः': '🐦',
  'स्पृहातरुः': '🌳',
  'स्पष्टकिरणः': '✨',
  'रत्नपुष्पम्': '💎',
  'यत्नखगः': '🐦',
  'रत्नसरः': '🏞️',
  'यत्नतरुः': '🌳',
  'रत्नमेघः': '☁️',
  'यत्नपवनः': '💨',
  'रत्नगिरिः': '🏔️',
  'यत्नकमलम्': '🪷',
  'चन्दनतरुः': '🌳',
  'निम्नसरः': '🏞️',
  'चन्दनगन्धः': '🪵',
  'निम्नमार्गः': '🥾',
  'चन्दनवनम्': '🌲',
  'निम्नमेघः': '☁️',
  'चन्दनपुष्पम्': '🌸',
  'निम्नखगः': '🐦',
  'कल्पतरुः': '🌴',
  'अल्पपुष्पम्': '🌼',
  'कल्पवनम्': '🌲',
  'अल्पपवनः': '💨',
  'कल्पमेघः': '☁️',
  'अल्पकमलम्': '🪷',
  'कल्पगिरिः': '⛰️',
  'अल्पसरः': '🏞️',
  'स्कान्दे': '🎉',
  'स्कितिं': '👀',
  'स्कीर्णं': '🍃',
  'स्कुरति': '⚡',
  'स्कूतिः': '💨',
  'आस्के': '🌸',
  'स्कैः': '🌺',
  'आस्को': '😄',
  'स्कौ': '✨',
  'स्पारं': '✨',
  'स्पितिं': '👂',
  'स्पीतिः': '🏠',
  'स्पुरति': '🪔',
  'स्पूतिः': '💨',
  'आस्पे': '🐦',
  'स्पैः': '🌸',
  'स्पोदः': '☁️',
  'स्पौ': '✨',
  'रत्ना': '💎',
  'यत्नि': '📖',
  'पत्नी': '👩',
  'यत्नुं': '💪',
  'रत्नू': '💎',
  'रत्ने': '💎',
  'रत्नैः': '💎',
  'यत्नो': '✅',
  'रत्नौ': '💎',
  'आद्ना': '🌸',
  'आद्नि': '🐦',
  'आद्नी': '✨',
  'आद्नुं': '👀',
  'आद्नू': '✨',
  'आद्ने': '💧',
  'आद्नैः': '💨',
  'आद्नो': '✨',
  'आद्नौ': '✨',
  'कल्पा': '🌿',
  'अल्पि': '🌼',
  'अल्पी': '✨',
  'कल्पुं': '🙋',
  'अल्पू': '✨',
  'कल्पे': '🌳',
  'अल्पैः': '🌺',
  'अल्पो': '🌳',
  'कल्पौ': '✨',
  'उत्कण्ठपवनः': '💨',
  'उत्कण्ठखगः': '🐦',
  'उत्कीर्णपत्रम्': '🍃',
  'उत्कण्ठमेघः': '☁️',
  'उत्कण्ठतरुः': '🌳',
  'उत्कण्ठकमलम्': '🪷',
  'उत्कण्ठगिरिः': '⛰️',
  'उत्कण्ठसरः': '🏞️',
  'उत्पातमेघः': '☁️',
  'उत्पितपुष्पम्': '🌸',
  'उत्पातपवनः': '💨',
  'उत्पितखगः': '🐦',
  'उत्पातगिरिः': '⛰️',
  'उत्पिततरुः': '🌳',
  'उत्पातसरः': '🏞️',
  'उत्पितकमलम्': '🪷',
  'आत्मतारुः': '🌳',
  'सत्मपुष्पम्': '🌼',
  'आत्मेपवनः': '💨',
  'आत्मखगः': '🐦',
  'आत्मगिरिः': '⛰️',
  'आत्मसरः': '🏞️',
  'सत्मकमलम्': '🪷',
  'आत्मवनम्': '🌲',
  'उद्गायनखगः': '🐦',
  'उद्गीतपवनः': '💨',
  'उद्गायनपुष्पम्': '🌸',
  'उद्गीतमेघः': '☁️',
  'उद्गायनतरुः': '🌳',
  'उद्गीतसरः': '🏞️',
  'उद्गायनगिरिः': '⛰️',
  'उद्गीतकमलम्': '🪷',
  'उद्बाष्पकिरणः': '💧',
  'उद्बोधपवनः': '💨',
  'उद्बाष्पमेघः': '☁️',
  'उद्बोधपुष्पम्': '🌺',
  'उद्बाष्पसरः': '🏞️',
  'उद्बोधतरुः': '🌳',
  'उद्बाष्पखगः': '🐦',
  'उद्बोधगिरिः': '⛰️',
  'उत्कासे': '😄',
  'उत्किरणं': '✨',
  'उत्कीर्णं': '🍃',
  'उत्कुं': '🐦',
  'उत्कू': '✨',
  'उत्के': '🌸',
  'उत्कैः': '🌺',
  'उत्को': '🏃',
  'उत्कौ': '✨',
  'उत्पातः': '⚡',
  'उत्पितं': '🌸',
  'उत्पी': '✨',
  'उत्पुं': '🙋',
  'उत्पू': '✨',
  'उत्पे': '🐦',
  'उत्पैः': '💨',
  'उत्पो': '✨',
  'उत्पौ': '✨',
  'आत्मा': '🧘',
  'सत्मि': '🏠',
  'आत्मी': '✨',
  'आत्मुं': '👀',
  'आत्मू': '✨',
  'आत्मे': '☮️',
  'आत्मैः': '👥',
  'आत्मो': '✨',
  'आत्मौ': '✨',
  'उद्गायति': '🎵',
  'उद्गितिं': '👂',
  'उद्गी': '✨',
  'उद्गुं': '🐦',
  'उद्गू': '✨',
  'उद्गे': '🌸',
  'उद्गैः': '🌺',
  'उद्गो': '✨',
  'उद्गौ': '✨',
  'उद्बाष्पं': '💧',
  'उद्बितिं': '👀',
  'उद्बी': '✨',
  'उद्बुं': '💧',
  'उद्बू': '✨',
  'उद्बे': '🐦',
  'उद्बैः': '💨',
  'उद्बो': '✨',
  'उद्बौ': '✨',
  'गङ्गापवनः': '💨',
  'सङ्गखगः': '🐦',
  'अङ्गपुष्पम्': '🌸',
  'सङ्गमेघः': '☁️',
  'गङ्गातरुः': '🌳',
  'सङ्गकमलम्': '🪷',
  'अङ्गगिरिः': '⛰️',
  'सङ्गसरः': '🏞️',
  'शङ्खपवनः': '💨',
  'शङ्खखगः': '🐦',
  'शङ्खपुष्पम्': '🌸',
  'शङ्खमेघः': '☁️',
  'शङ्खतरुः': '🌳',
  'शङ्खसरः': '🏞️',
  'शङ्खगिरिः': '⛰️',
  'शङ्खकमलम्': '🪷',
  'पट्टपवनः': '💨',
  'पट्टखगः': '🐦',
  'पट्टपुष्पम्': '🌺',
  'पट्टमेघः': '☁️',
  'पट्टतरुः': '🌳',
  'पट्टसरः': '🏞️',
  'पट्टगिरिः': '⛰️',
  'पट्टकमलम्': '🪷',
  'उड्डयनखगः': '🐦',
  'उड्डयनपवनः': '💨',
  'उड्डयनपुष्पम्': '🌸',
  'उड्डयनमेघः': '☁️',
  'उड्डयनतरुः': '🌳',
  'उड्डयनसरः': '🏞️',
  'उड्डयनगिरिः': '⛰️',
  'उड्डयनकमलम्': '🪷',
  'ब्बपवनः': '💨',
  'ब्बखगः': '🐦',
  'ब्बपुष्पम्': '🌼',
  'ब्बमेघः': '☁️',
  'ब्बतरुः': '🌳',
  'ब्बसरः': '🏞️',
  'ब्बगिरिः': '⛰️',
  'ब्बकमलम्': '🪷',
  'सङ्गि': '🐦',
  'अङ्गी': '✨',
  'सङ्गुं': '🙋',
  'सङ्गू': '✨',
  'सङ्गे': '🌸',
  'सङ्गैः': '💨',
  'सङ्गो': '✨',
  'सङ्गौ': '✨',
  'शङ्खा': '🐚',
  'शङ्खि': '🐦',
  'शङ्खी': '✨',
  'शङ्खुं': '👂',
  'शङ्खू': '✨',
  'शङ्खे': '🌸',
  'शङ्खैः': '💨',
  'शङ्खो': '🐚',
  'शङ्खौ': '✨',
  'पट्टा': '🧣',
  'पट्टि': '🐦',
  'पट्टी': '✨',
  'पट्टुं': '👀',
  'पट्टू': '✨',
  'पट्टे': '🌸',
  'पट्टैः': '🌺',
  'पट्टो': '✨',
  'पट्टौ': '✨',
  'उड्डा': '🐦',
  'उड्डि': '🐦',
  'उड्डी': '✨',
  'उड्डुं': '🐦',
  'उड्डू': '✨',
  'उड्डे': '🌸',
  'उड्डैः': '💨',
  'उड्डो': '✨',
  'उड्डौ': '✨',
  'ब्बा': '✨',
  'ब्बि': '🐦',
  'ब्बी': '✨',
  'ब्बुं': '👀',
  'ब्बू': '✨',
  'ब्बे': '🌸',
  'ब्बैः': '💨',
  'ब्बो': '✨',
  'ब्बौ': '✨',
  'अह्नपवनः': '💨',
  'अह्नखगः': '🐦',
  'अह्नपुष्पम्': '🌸',
  'अह्नमेघः': '☁️',
  'अह्नतरुः': '🌳',
  'अह्नसरः': '🏞️',
  'अह्नगिरिः': '⛰️',
  'अह्नकमलम्': '🪷',
  'ब्रह्मपवनः': '💨',
  'ब्रह्मखगः': '🐦',
  'ब्रह्मपुष्पम्': '🌺',
  'ब्रह्ममेघः': '☁️',
  'ब्रह्मतरुः': '🌳',
  'ब्रह्मसरः': '🏞️',
  'ब्रह्मगिरिः': '⛰️',
  'ब्रह्मकमलम्': '🪷',
  'च्जपवनः': '💨',
  'च्जखगः': '🐦',
  'च्जपुष्पम्': '🌼',
  'च्जमेघः': '☁️',
  'च्जतरुः': '🌳',
  'च्जसरः': '🏞️',
  'च्जगिरिः': '⛰️',
  'च्जकमलम्': '🪷',
  'स्वप्नपवनः': '💨',
  'स्वप्नखगः': '🐦',
  'स्वप्नपुष्पम्': '🌸',
  'स्वप्नमेघः': '☁️',
  'स्वप्नतरुः': '🌳',
  'स्वप्नसरः': '🏞️',
  'स्वप्नगिरिः': '⛰️',
  'स्वप्नकमलम्': '🪷',
  'नम्नपवनः': '💨',
  'नम्नखगः': '🐦',
  'नम्नपुष्पम्': '🌺',
  'नम्नमेघः': '☁️',
  'नम्नतरुः': '🌳',
  'नम्नसरः': '🏞️',
  'नम्नगिरिः': '⛰️',
  'नम्नकमलम्': '🪷',
  'अह्ना': '☀️',
  'ह्नि': '🐦',
  'ह्नी': '✨',
  'प्रह्नुं': '🙏',
  'ह्नू': '✨',
  'ह्ने': '🌸',
  'ह्नैः': '💨',
  'ह्नो': '✨',
  'ह्नौ': '✨',
  'ब्रह्मा': '🧘',
  'ह्मि': '🐦',
  'ह्मी': '✨',
  'ह्मुं': '👀',
  'ह्मू': '✨',
  'ह्मे': '🌸',
  'ह्मैः': '💨',
  'ह्मो': '✨',
  'ह्मौ': '✨',
  'च्जा': '✨',
  'च्जि': '🐦',
  'च्जी': '✨',
  'च्जुं': '👀',
  'च्जू': '✨',
  'च्जे': '🌸',
  'च्जैः': '💨',
  'च्जो': '✨',
  'च्जौ': '✨',
  'स्वप्नाः': '😴',
  'प्नि': '🐦',
  'प्नी': '✨',
  'प्नुं': '👀',
  'प्नू': '✨',
  'प्ने': '🌸',
  'प्नैः': '💨',
  'प्नो': '✨',
  'प्नौ': '✨',
  'नम्ना': '🙏',
  'म्नि': '🐦',
  'म्नी': '✨',
  'म्नुं': '👀',
  'म्नू': '✨',
  'म्ने': '🌸',
  'म्नैः': '💨',
  'म्नो': '✨',
  'म्नौ': '✨',
  'स्फुटपवनः': '💨',
  'स्फुटखगः': '🐦',
  'स्फुटपुष्पम्': '🌸',
  'स्फुटमेघः': '☁️',
  'स्फुटतरुः': '🌳',
  'स्फुटसरः': '🏞️',
  'स्फुटगिरिः': '⛰️',
  'स्फुटकमलम्': '🪷',
  'स्थलपवनः': '💨',
  'स्थलखगः': '🐦',
  'स्थलपुष्पम्': '🌺',
  'स्थलमेघः': '☁️',
  'स्थलतरुः': '🌳',
  'स्थलसरः': '🏞️',
  'स्थलगिरिः': '⛰️',
  'स्थलकमलम्': '🪷',
  'पश्चपवनः': '💨',
  'पश्चखगः': '🐦',
  'पश्चपुष्पम्': '🌼',
  'पश्चमेघः': '☁️',
  'पश्चतरुः': '🌳',
  'पश्चसरः': '🏞️',
  'पश्चगिरिः': '⛰️',
  'पश्चकमलम्': '🪷',
  'श्कपवनः': '💨',
  'श्कखगः': '🐦',
  'श्कपुष्पम्': '🌸',
  'श्कमेघः': '☁️',
  'श्कतरुः': '🌳',
  'श्कसरः': '🏞️',
  'श्कगिरिः': '⛰️',
  'श्ककमलम्': '🪷',
  'कल्कपवनः': '💨',
  'कल्कखगः': '🐦',
  'कल्कपुष्पम्': '🌺',
  'कल्कमेघः': '☁️',
  'कल्कतरुः': '🌳',
  'कल्कसरः': '🏞️',
  'कल्कगिरिः': '⛰️',
  'कल्ककमलम्': '🪷',
  'स्फाटिकं': '💎',
  'स्फि': '🐦',
  'स्फी': '✨',
  'स्फुटति': '🌸',
  'स्फू': '✨',
  'स्फे': '🌸',
  'स्फैः': '💨',
  'स्फो': '✨',
  'स्फौ': '✨',
  'स्थानं': '📍',
  'स्थी': '✨',
  'स्थुं': '👀',
  'स्थूलः': '🐘',
  'स्थे': '🌸',
  'स्थैः': '💨',
  'स्थो': '✨',
  'स्थौ': '✨',
  'पश्चात्': '🌅',
  'श्चि': '🐦',
  'श्ची': '✨',
  'श्चुं': '👀',
  'श्चू': '✨',
  'श्चे': '🌸',
  'श्चैः': '💨',
  'श्चो': '✨',
  'श्चौ': '✨',
  'श्का': '✨',
  'श्कि': '🐦',
  'श्की': '✨',
  'श्कुं': '👀',
  'श्कू': '✨',
  'श्के': '🌸',
  'श्कैः': '💨',
  'श्को': '✨',
  'श्कौ': '✨',
  'कल्का': '🎨',
  'ल्कि': '🐦',
  'ल्की': '✨',
  'ल्कुं': '👀',
  'ल्कू': '✨',
  'ल्के': '🌸',
  'ल्कैः': '💨',
  'ल्को': '✨',
  'ल्कौ': '✨',
  'सर्वपवनः': '💨',
  'सर्वखगः': '🐦',
  'सर्वपुष्पम्': '🌸',
  'सर्वमेघः': '☁️',
  'सर्वतरुः': '🌳',
  'सर्वसरः': '🏞️',
  'सर्वगिरिः': '⛰️',
  'सर्वकमलम्': '🪷',
  'सर्पपवनः': '💨',
  'सर्पखगः': '🐦',
  'सर्पपुष्पम्': '🌺',
  'सर्पमेघः': '☁️',
  'सर्पतरुः': '🌳',
  'सर्पसरः': '🏞️',
  'सर्पगिरिः': '⛰️',
  'सर्पकमलम्': '🪷',
  'र्लपवनः': '💨',
  'र्लखगः': '🐦',
  'र्लपुष्पम्': '🌼',
  'र्लमेघः': '☁️',
  'र्लतरुः': '🌳',
  'र्लसरः': '🏞️',
  'र्लगिरिः': '⛰️',
  'र्लकमलम्': '🪷',
  'गर्जपवनः': '💨',
  'गर्जखगः': '🐦',
  'गर्जपुष्पम्': '🌸',
  'गर्जमेघः': '☁️',
  'गर्जतरुः': '🌳',
  'गर्जसरः': '🏞️',
  'गर्जगिरिः': '⛰️',
  'गर्जकमलम्': '🪷',
  'अर्चपवनः': '💨',
  'अर्चखगः': '🐦',
  'अर्चपुष्पम्': '🌺',
  'अर्चमेघः': '☁️',
  'अर्चतरुः': '🌳',
  'अर्चसरः': '🏞️',
  'अर्चगिरिः': '⛰️',
  'अर्चकमलम्': '🪷',
  'र्वा': '✨',
  'र्वि': '🐦',
  'र्वी': '✨',
  'र्वु': '✨',
  'र्वू': '✨',
  'र्वे': '✨',
  'र्वै': '💨',
  'र्वो': '✨',
  'र्वौ': '✨',
  'र्पा': '✨',
  'र्पि': '🐦',
  'र्पी': '✨',
  'र्पु': '✨',
  'र्पू': '✨',
  'र्पे': '🌸',
  'र्पै': '💨',
  'र्पो': '✨',
  'र्पौ': '✨',
  'र्ला': '✨',
  'र्लि': '🐦',
  'र्ली': '✨',
  'र्लु': '✨',
  'र्लू': '✨',
  'र्ले': '🌸',
  'र्लै': '💨',
  'र्लो': '✨',
  'र्लौ': '✨',
  'र्जा': '✨',
  'र्जि': '🐦',
  'र्जी': '✨',
  'र्जु': '✨',
  'र्जू': '✨',
  'र्जे': '🌸',
  'र्जै': '💨',
  'र्जो': '✨',
  'र्जौ': '✨',
  'र्चा': '✨',
  'र्चि': '🐦',
  'र्ची': '✨',
  'र्चु': '✨',
  'र्चू': '✨',
  'र्चे': '🌸',
  'र्चै': '💨',
  'र्चो': '✨',
  'र्चौ': '✨',
  'सर्वा': '🌍',
  'पर्वि': '🐦',
  'र्वुं': '👀',
  'पूर्वे': '🌅',
  'र्वैः': '💨',
  'सर्पाः': '🐍',
  'र्पुं': '👀',
  'र्पैः': '💨',
  'र्लुं': '👀',
  'र्लैः': '💨',
  'गर्जा': '⛈️',
  'र्जुं': '👀',
  'र्जैः': '💨',
  'अर्चा': '🙏',
  'र्चुं': '👀',
  'र्चैः': '💨',
  'नन्दपवनः': '💨',
  'नन्दखगः': '🐦',
  'नन्दपुष्पम्': '🌸',
  'नन्दमेघः': '☁️',
  'नन्दतरुः': '🌳',
  'नन्दसरः': '🏞️',
  'नन्दगिरिः': '⛰️',
  'नन्दकमलम्': '🪷',
  'गन्धपवनः': '💨',
  'गन्धखगः': '🐦',
  'गन्धपुष्पम्': '🌺',
  'गन्धमेघः': '☁️',
  'गन्धतरुः': '🌳',
  'गन्धसरः': '🏞️',
  'गन्धगिरिः': '⛰️',
  'गन्धकमलम्': '🪷',
  'न्गपवनः': '💨',
  'न्गखगः': '🐦',
  'न्गपुष्पम्': '🌼',
  'न्गमेघः': '☁️',
  'न्गतरुः': '🌳',
  'न्गसरः': '🏞️',
  'न्गगिरिः': '⛰️',
  'न्गकमलम्': '🪷',
  'न्जपवनः': '💨',
  'न्जखगः': '🐦',
  'न्जपुष्पम्': '🌸',
  'न्जमेघः': '☁️',
  'न्जतरुः': '🌳',
  'न्जसरः': '🏞️',
  'न्जगिरिः': '⛰️',
  'न्जकमलम्': '🪷',
  'न्बपवनः': '💨',
  'न्बखगः': '🐦',
  'न्बपुष्पम्': '🌺',
  'न्बमेघः': '☁️',
  'न्बतरुः': '🌳',
  'न्बसरः': '🏞️',
  'न्बगिरिः': '⛰️',
  'न्बकमलम्': '🪷',
  'ल्गपवनः': '💨',
  'ल्गखगः': '🐦',
  'ल्गपुष्पम्': '🌼',
  'ल्गमेघः': '☁️',
  'ल्गतरुः': '🌳',
  'ल्गसरः': '🏞️',
  'ल्गगिरिः': '⛰️',
  'ल्गकमलम्': '🪷',
  'गुल्मपवनः': '💨',
  'गुल्मखगः': '🐦',
  'गुल्मपुष्पम्': '🌸',
  'गुल्ममेघः': '☁️',
  'गुल्मतरुः': '🌳',
  'गुल्मसरः': '🏞️',
  'गुल्मगिरिः': '⛰️',
  'गुल्मकमलम्': '🪷',
  'अश्वपवनः': '💨',
  'अश्वखगः': '🐦',
  'अश्वपुष्पम्': '🌺',
  'अश्वमेघः': '☁️',
  'अश्वतरुः': '🌳',
  'अश्वसरः': '🏞️',
  'अश्वगिरिः': '⛰️',
  'अश्वकमलम्': '🪷',
  'ष्वपवनः': '💨',
  'ष्वखगः': '🐦',
  'ष्वपुष्पम्': '🌼',
  'ष्वमेघः': '☁️',
  'ष्वतरुः': '🌳',
  'ष्वसरः': '🏞️',
  'ष्वगिरिः': '⛰️',
  'ष्वकमलम्': '🪷',
  'जिह्वपवनः': '💨',
  'जिह्वखगः': '🐦',
  'जिह्वपुष्पम्': '🌸',
  'जिह्वमेघः': '☁️',
  'जिह्वतरुः': '🌳',
  'जिह्वसरः': '🏞️',
  'जिह्वगिरिः': '⛰️',
  'जिह्वकमलम्': '🪷',
  'न्दा': '✨',
  'न्दि': '🐦',
  'न्दी': '✨',
  'न्दु': '✨',
  'न्दू': '✨',
  'न्दे': '🌸',
  'न्दै': '💨',
  'न्दो': '✨',
  'न्दौ': '✨',
  'न्धा': '✨',
  'न्धि': '🐦',
  'न्धी': '✨',
  'न्धु': '✨',
  'न्धू': '✨',
  'न्धे': '🌸',
  'न्धै': '💨',
  'न्धो': '✨',
  'न्धौ': '✨',
  'न्गा': '✨',
  'न्गि': '🐦',
  'न्गी': '✨',
  'न्गु': '✨',
  'न्गू': '✨',
  'न्गे': '🌸',
  'न्गै': '💨',
  'न्गो': '✨',
  'न्गौ': '✨',
  'न्जा': '✨',
  'न्जि': '🐦',
  'न्जी': '✨',
  'न्जु': '✨',
  'न्जू': '✨',
  'न्जे': '🌸',
  'न्जै': '💨',
  'न्जो': '✨',
  'न्जौ': '✨',
  'न्बा': '✨',
  'न्बि': '🐦',
  'न्बी': '✨',
  'न्बु': '✨',
  'न्बू': '✨',
  'न्बे': '🌸',
  'न्बै': '💨',
  'न्बो': '✨',
  'न्बौ': '✨',
  'ल्गा': '✨',
  'ल्गि': '🐦',
  'ल्गी': '✨',
  'ल्गु': '✨',
  'ल्गू': '✨',
  'ल्गे': '🌸',
  'ल्गै': '💨',
  'ल्गो': '✨',
  'ल्गौ': '✨',
  'ल्मा': '✨',
  'ल्मि': '🐦',
  'ल्मी': '✨',
  'ल्मु': '✨',
  'ल्मू': '✨',
  'ल्मे': '🌸',
  'ल्मै': '💨',
  'ल्मो': '✨',
  'ल्मौ': '✨',
  'श्वा': '✨',
  'श्वि': '🐦',
  'श्वी': '✨',
  'श्वु': '✨',
  'श्वू': '✨',
  'श्वे': '🌸',
  'श्वै': '💨',
  'श्वो': '✨',
  'श्वौ': '✨',
  'ष्वा': '✨',
  'ष्वि': '🐦',
  'ष्वी': '✨',
  'ष्वु': '✨',
  'ष्वू': '✨',
  'ष्वे': '🌸',
  'ष्वै': '💨',
  'ष्वो': '✨',
  'ष्वौ': '✨',
  'ह्वा': '✨',
  'ह्वि': '🐦',
  'ह्वी': '✨',
  'ह्वु': '✨',
  'ह्वू': '✨',
  'ह्वे': '🌸',
  'ह्वै': '💨',
  'ह्वो': '✨',
  'ह्वौ': '✨',
  'नन्दा': '⛰️',
  'न्दुं': '👀',
  'न्दैः': '💨',
  'गन्धाः': '🌺',
  'न्धुं': '👀',
  'न्धैः': '💨',
  'न्गुं': '👀',
  'न्गैः': '💨',
  'न्जुं': '👀',
  'न्जैः': '💨',
  'न्बुं': '👀',
  'न्बैः': '💨',
  'ल्गुं': '👀',
  'ल्गैः': '💨',
  'गुल्माः': '🌿',
  'ल्मुं': '👀',
  'ल्मैः': '💨',
  'अश्वाः': '🐴',
  'श्वुं': '👀',
  'श्वेतं': '🤍',
  'श्वैः': '💨',
  'ष्वुं': '👀',
  'ष्वैः': '💨',
  'ह्वुं': '👀',
  'ह्वैः': '💨',
  'मज्जपवनः': '💨',
  'मज्जखगः': '🐦',
  'मज्जपुष्पम्': '🌸',
  'मज्जमेघः': '☁️',
  'मज्जतरुः': '🌳',
  'मज्जसरः': '🏞️',
  'मज्जगिरिः': '⛰️',
  'मज्जकमलम्': '🪷',
  'ट्ठपवनः': '💨',
  'ट्ठखगः': '🐦',
  'ट्ठपुष्पम्': '🌺',
  'ट्ठमेघः': '☁️',
  'ट्ठतरुः': '🌳',
  'ट्ठसरः': '🏞️',
  'ट्ठगिरिः': '⛰️',
  'ट्ठकमलम्': '🪷',
  'ड्ढपवनः': '💨',
  'ड्ढखगः': '🐦',
  'ड्ढपुष्पम्': '🌼',
  'ड्ढमेघः': '☁️',
  'ड्ढतरुः': '🌳',
  'ड्ढसरः': '🏞️',
  'ड्ढगिरिः': '⛰️',
  'ड्ढकमलम्': '🪷',
  'क्कपवनः': '💨',
  'क्कखगः': '🐦',
  'क्कपुष्पम्': '🌸',
  'क्कमेघः': '☁️',
  'क्कतरुः': '🌳',
  'क्कसरः': '🏞️',
  'क्कगिरिः': '⛰️',
  'क्ककमलम्': '🪷',
  'ग्गपवनः': '💨',
  'ग्गखगः': '🐦',
  'ग्गपुष्पम्': '🌺',
  'ग्गमेघः': '☁️',
  'ग्गतरुः': '🌳',
  'ग्गसरः': '🏞️',
  'ग्गगिरिः': '⛰️',
  'ग्गकमलम्': '🪷',
  'कम्पपवनः': '💨',
  'कम्पखगः': '🐦',
  'कम्पपुष्पम्': '🌼',
  'कम्पमेघः': '☁️',
  'कम्पतरुः': '🌳',
  'कम्पसरः': '🏞️',
  'कम्पगिरिः': '⛰️',
  'कम्पकमलम्': '🪷',
  'अम्बपवनः': '💨',
  'अम्बखगः': '🐦',
  'अम्बपुष्पम्': '🌸',
  'अम्बमेघः': '☁️',
  'अम्बतरुः': '🌳',
  'अम्बसरः': '🏞️',
  'अम्बगिरिः': '⛰️',
  'अम्बकमलम्': '🪷',
  'वत्सपवनः': '💨',
  'वत्सखगः': '🐦',
  'वत्सपुष्पम्': '🌺',
  'वत्समेघः': '☁️',
  'वत्सतरुः': '🌳',
  'वत्ससरः': '🏞️',
  'वत्सगिरिः': '⛰️',
  'वत्सकमलम्': '🪷',
  'द्सपवनः': '💨',
  'द्सखगः': '🐦',
  'द्सपुष्पम्': '🌼',
  'द्समेघः': '☁️',
  'द्सतरुः': '🌳',
  'द्ससरः': '🏞️',
  'द्सगिरिः': '⛰️',
  'द्सकमलम्': '🪷',
  'ह्लादपवनः': '💨',
  'ह्लादखगः': '🐦',
  'ह्लादपुष्पम्': '🌸',
  'ह्लादमेघः': '☁️',
  'ह्लादतरुः': '🌳',
  'ह्लादसरः': '🏞️',
  'ह्लादगिरिः': '⛰️',
  'ह्लादकमलम्': '🪷',
  'ज्जा': '✨',
  'ज्जि': '🐦',
  'ज्जी': '✨',
  'ज्जु': '✨',
  'ज्जू': '✨',
  'ज्जे': '🌸',
  'ज्जै': '💨',
  'ज्जो': '✨',
  'ज्जौ': '✨',
  'ट्ठा': '✨',
  'ट्ठि': '🐦',
  'ट्ठी': '✨',
  'ट्ठु': '✨',
  'ट्ठू': '✨',
  'ट्ठे': '🌸',
  'ट्ठै': '💨',
  'ट्ठो': '✨',
  'ट्ठौ': '✨',
  'ड्ढा': '✨',
  'ड्ढि': '🐦',
  'ड्ढी': '✨',
  'ड्ढु': '✨',
  'ड्ढू': '✨',
  'ड्ढे': '🌸',
  'ड्ढै': '💨',
  'ड्ढो': '✨',
  'ड्ढौ': '✨',
  'क्का': '✨',
  'क्कि': '🐦',
  'क्की': '✨',
  'क्कु': '✨',
  'क्कू': '✨',
  'क्के': '🌸',
  'क्कै': '💨',
  'क्को': '✨',
  'क्कौ': '✨',
  'ग्गा': '✨',
  'ग्गि': '🐦',
  'ग्गी': '✨',
  'ग्गु': '✨',
  'ग्गू': '✨',
  'ग्गे': '🌸',
  'ग्गै': '💨',
  'ग्गो': '✨',
  'ग्गौ': '✨',
  'म्पा': '✨',
  'म्पि': '🐦',
  'म्पी': '✨',
  'म्पु': '✨',
  'म्पू': '✨',
  'म्पे': '🌸',
  'म्पै': '💨',
  'म्पो': '✨',
  'म्पौ': '✨',
  'म्बा': '✨',
  'म्बि': '🐦',
  'म्बी': '✨',
  'म्बु': '✨',
  'म्बू': '✨',
  'म्बे': '🌸',
  'म्बै': '💨',
  'म्बो': '✨',
  'म्बौ': '✨',
  'त्सा': '✨',
  'त्सि': '🐦',
  'त्सी': '✨',
  'त्सु': '✨',
  'त्सू': '✨',
  'त्से': '🌸',
  'त्सै': '💨',
  'त्सो': '✨',
  'त्सौ': '✨',
  'द्सा': '✨',
  'द्सि': '🐦',
  'द्सी': '✨',
  'द्सु': '✨',
  'द्सू': '✨',
  'द्से': '🌸',
  'द्सै': '💨',
  'द्सो': '✨',
  'द्सौ': '✨',
  'ह्ला': '✨',
  'ह्लि': '🐦',
  'ह्ली': '✨',
  'ह्लु': '✨',
  'ह्लू': '✨',
  'ह्ले': '🌸',
  'ह्लै': '💨',
  'ह्लो': '✨',
  'ह्लौ': '✨',
  'मज्जा': '🦴',
  'ज्जुं': '👀',
  'ज्जैः': '💨',
  'ट्ठुं': '👀',
  'ट्ठैः': '💨',
  'ड्ढुं': '👀',
  'ड्ढैः': '💨',
  'क्कुं': '👀',
  'क्कैः': '💨',
  'ग्गुं': '👀',
  'ग्गैः': '💨',
  'कम्पा': '🌍',
  'म्पुं': '👀',
  'म्पैः': '💨',
  'अम्बा': '👩',
  'म्बुं': '👀',
  'म्बैः': '💨',
  'वत्सा': '🐄',
  'त्सुं': '👀',
  'त्सैः': '💨',
  'द्सुं': '👀',
  'द्सैः': '💨',
  'ह्लादः': '😊',
  'ह्लुं': '👀',
  'ह्लैः': '💨',
  'त्यागपवनः': '💨',
  'त्यागखगः': '🐦',
  'त्यागपुष्पम्': '🌸',
  'त्यागमेघः': '☁️',
  'त्यागतरुः': '🌳',
  'त्यागसरः': '🏞️',
  'त्यागगिरिः': '⛰️',
  'त्यागकमलम्': '🪷',
  'विद्यापवनः': '💨',
  'विद्याखगः': '🐦',
  'विद्यापुष्पम्': '🌺',
  'विद्यामेघः': '☁️',
  'विद्यातरुः': '🌳',
  'विद्यासरः': '🏞️',
  'विद्यागिरिः': '⛰️',
  'विद्याकमलम्': '🪷',
  'व्याघ्रपवनः': '💨',
  'व्याघ्रखगः': '🐦',
  'व्याघ्रपुष्पम्': '🌼',
  'व्याघ्रमेघः': '☁️',
  'व्याघ्रतरुः': '🌳',
  'व्याघ्रसरः': '🏞️',
  'व्याघ्रगिरिः': '⛰️',
  'व्याघ्रकमलम्': '🪷',
  'श्यामपवनः': '💨',
  'श्यामखगः': '🐦',
  'श्यामपुष्पम्': '🌸',
  'श्याममेघः': '☁️',
  'श्यामतरुः': '🌳',
  'श्यामसरः': '🏞️',
  'श्यामगिरिः': '⛰️',
  'श्यामकमलम्': '🪷',
  'वाक्यपवनः': '💨',
  'वाक्यखगः': '🐦',
  'वाक्यपुष्पम्': '🌺',
  'वाक्यमेघः': '☁️',
  'वाक्यतरुः': '🌳',
  'वाक्यसरः': '🏞️',
  'वाक्यगिरिः': '⛰️',
  'वाक्यकमलम्': '🪷',
  'भाग्यपवनः': '💨',
  'भाग्यखगः': '🐦',
  'भाग्यपुष्पम्': '🌼',
  'भाग्यमेघः': '☁️',
  'भाग्यतरुः': '🌳',
  'भाग्यसरः': '🏞️',
  'भाग्यगिरिः': '⛰️',
  'भाग्यकमलम्': '🪷',
  'वाच्यपवनः': '💨',
  'वाच्यखगः': '🐦',
  'वाच्यपुष्पम्': '🌸',
  'वाच्यमेघः': '☁️',
  'वाच्यतरुः': '🌳',
  'वाच्यसरः': '🏞️',
  'वाच्यगिरिः': '⛰️',
  'वाच्यकमलम्': '🪷',
  'राज्यपवनः': '💨',
  'राज्यखगः': '🐦',
  'राज्यपुष्पम्': '🌺',
  'राज्यमेघः': '☁️',
  'राज्यतरुः': '🌳',
  'राज्यसरः': '🏞️',
  'राज्यगिरिः': '⛰️',
  'राज्यकमलम्': '🪷',
  'रूप्यपवनः': '💨',
  'रूप्यखगः': '🐦',
  'रूप्यपुष्पम्': '🌼',
  'रूप्यमेघः': '☁️',
  'रूप्यतरुः': '🌳',
  'रूप्यसरः': '🏞️',
  'रूप्यगिरिः': '⛰️',
  'रूप्यकमलम्': '🪷',
  'अभ्यासपवनः': '💨',
  'अभ्यासखगः': '🐦',
  'अभ्यासपुष्पम्': '🌸',
  'अभ्यासमेघः': '☁️',
  'अभ्यासतरुः': '🌳',
  'अभ्याससरः': '🏞️',
  'अभ्यासगिरिः': '⛰️',
  'अभ्यासकमलम्': '🪷',
  'त्या': '✨',
  'त्यि': '🐦',
  'त्यी': '✨',
  'त्यु': '✨',
  'त्यू': '✨',
  'त्ये': '🌸',
  'त्यै': '💨',
  'त्यो': '✨',
  'त्यौ': '✨',
  'द्या': '✨',
  'द्यि': '🐦',
  'द्यी': '✨',
  'द्यु': '✨',
  'द्यू': '✨',
  'द्ये': '🌸',
  'द्यै': '💨',
  'द्यो': '✨',
  'द्यौ': '✨',
  'व्या': '✨',
  'व्यि': '🐦',
  'व्यी': '✨',
  'व्यु': '✨',
  'व्यू': '✨',
  'व्ये': '🌸',
  'व्यै': '💨',
  'व्यो': '✨',
  'व्यौ': '✨',
  'श्या': '✨',
  'श्यि': '🐦',
  'श्यी': '✨',
  'श्यु': '✨',
  'श्यू': '✨',
  'श्ये': '🌸',
  'श्यै': '💨',
  'श्यो': '✨',
  'श्यौ': '✨',
  'क्या': '✨',
  'क्यि': '🐦',
  'क्यी': '✨',
  'क्यु': '✨',
  'क्यू': '✨',
  'क्ये': '🌸',
  'क्यै': '💨',
  'क्यो': '✨',
  'क्यौ': '✨',
  'ग्या': '✨',
  'ग्यि': '🐦',
  'ग्यी': '✨',
  'ग्यु': '✨',
  'ग्यू': '✨',
  'ग्ये': '🌸',
  'ग्यै': '💨',
  'ग्यो': '✨',
  'ग्यौ': '✨',
  'च्या': '✨',
  'च्यि': '🐦',
  'च्यी': '✨',
  'च्यु': '✨',
  'च्यू': '✨',
  'च्ये': '🌸',
  'च्यै': '💨',
  'च्यो': '✨',
  'च्यौ': '✨',
  'ज्या': '🏹',
  'ज्यि': '🐦',
  'ज्यी': '✨',
  'ज्यु': '✨',
  'ज्यू': '✨',
  'ज्ये': '🌸',
  'ज्यै': '💨',
  'ज्यो': '✨',
  'ज्यौ': '✨',
  'प्या': '✨',
  'प्यि': '🐦',
  'प्यी': '✨',
  'प्यु': '✨',
  'प्यू': '✨',
  'प्ये': '🌸',
  'प्यै': '💨',
  'प्यो': '✨',
  'प्यौ': '✨',
  'भ्या': '✨',
  'भ्यि': '🐦',
  'भ्यी': '✨',
  'भ्यु': '✨',
  'भ्यू': '✨',
  'भ्ये': '🌸',
  'भ्यै': '💨',
  'भ्यो': '✨',
  'भ्यौ': '✨',
  'त्यागः': '🙏',
  'त्युं': '👀',
  'त्यैः': '💨',
  'विद्या': '📚',
  'द्युं': '👀',
  'द्यैः': '💨',
  'व्युं': '👀',
  'व्यैः': '💨',
  'श्यामः': '🌑',
  'श्युं': '👀',
  'श्यैः': '💨',
  'क्युं': '👀',
  'क्यैः': '💨',
  'योग्या': '✅',
  'ग्युं': '👀',
  'ग्यैः': '💨',
  'च्युं': '👀',
  'च्यैः': '💨',
  'ज्युं': '👀',
  'ज्यैः': '💨',
  'प्युं': '👀',
  'प्यैः': '💨',
  'अभ्यासः': '📖',
  'भ्युं': '👀',
  'भ्यैः': '💨',
  'रम्यपवनः': '💨',
  'रम्यखगः': '🐦',
  'रम्यपुष्पम्': '🌸',
  'रम्यमेघः': '☁️',
  'रम्यतरुः': '🌳',
  'रम्यसरः': '🏞️',
  'रम्यगिरिः': '⛰️',
  'रम्यकमलम्': '🪷',
  'धन्यपवनः': '💨',
  'धन्यखगः': '🐦',
  'धन्यपुष्पम्': '🌺',
  'धन्यमेघः': '☁️',
  'धन्यतरुः': '🌳',
  'धन्यसरः': '🏞️',
  'धन्यगिरिः': '⛰️',
  'धन्यकमलम्': '🪷',
  'मूल्यपवनः': '💨',
  'मूल्यखगः': '🐦',
  'मूल्यपुष्पम्': '🌼',
  'मूल्यमेघः': '☁️',
  'मूल्यतरुः': '🌳',
  'मूल्यसरः': '🏞️',
  'मूल्यगिरिः': '⛰️',
  'मूल्यकमलम्': '🪷',
  'कार्यपवनः': '💨',
  'कार्यखगः': '🐦',
  'कार्यपुष्पम्': '🌸',
  'कार्यमेघः': '☁️',
  'कार्यतरुः': '🌳',
  'कार्यसरः': '🏞️',
  'कार्यगिरिः': '⛰️',
  'कार्यकमलम्': '🪷',
  'व्रतपवनः': '💨',
  'व्रतखगः': '🐦',
  'व्रतपुष्पम्': '🌺',
  'व्रतमेघः': '☁️',
  'व्रततरुः': '🌳',
  'व्रतसरः': '🏞️',
  'व्रतगिरिः': '⛰️',
  'व्रतकमलम्': '🪷',
  'शुक्लपवनः': '💨',
  'शुक्लखगः': '🐦',
  'शुक्लपुष्पम्': '🌼',
  'शुक्लमेघः': '☁️',
  'शुक्लतरुः': '🌳',
  'शुक्लसरः': '🏞️',
  'शुक्लगिरिः': '⛰️',
  'शुक्लकमलम्': '🪷',
  'ग्लानिपवनः': '💨',
  'ग्लानिखगः': '🐦',
  'ग्लानिपुष्पम्': '🌸',
  'ग्लानिमेघः': '☁️',
  'ग्लानितरुः': '🌳',
  'ग्लानिसरः': '🏞️',
  'ग्लानिगिरिः': '⛰️',
  'ग्लानिकमलम्': '🪷',
  'प्लवपवनः': '💨',
  'प्लवखगः': '🐦',
  'प्लवपुष्पम्': '🌺',
  'प्लवमेघः': '☁️',
  'प्लवतरुः': '🌳',
  'प्लवसरः': '🏞️',
  'प्लवगिरिः': '⛰️',
  'प्लवकमलम्': '🪷',
  'फ्लपवनः': '💨',
  'फ्लखगः': '🐦',
  'फ्लपुष्पम्': '🌼',
  'फ्लमेघः': '☁️',
  'फ्लतरुः': '🌳',
  'फ्लसरः': '🏞️',
  'फ्लगिरिः': '⛰️',
  'फ्लकमलम्': '🪷',
  'ब्लपवनः': '💨',
  'ब्लखगः': '🐦',
  'ब्लपुष्पम्': '🌸',
  'ब्लमेघः': '☁️',
  'ब्लतरुः': '🌳',
  'ब्लसरः': '🏞️',
  'ब्लगिरिः': '⛰️',
  'ब्लकमलम्': '🪷',
  'म्या': '✨',
  'म्यि': '🐦',
  'म्यी': '✨',
  'म्यु': '✨',
  'म्यू': '✨',
  'म्ये': '🌸',
  'म्यै': '💨',
  'म्यो': '✨',
  'म्यौ': '✨',
  'न्या': '✨',
  'न्यि': '🐦',
  'न्यी': '✨',
  'न्यु': '✨',
  'न्यू': '✨',
  'न्ये': '🌸',
  'न्यै': '💨',
  'न्यो': '✨',
  'न्यौ': '✨',
  'ल्या': '✨',
  'ल्यि': '🐦',
  'ल्यी': '✨',
  'ल्यु': '✨',
  'ल्यू': '✨',
  'ल्ये': '🌸',
  'ल्यै': '💨',
  'ल्यो': '✨',
  'ल्यौ': '✨',
  'र्या': '✨',
  'र्यि': '🐦',
  'र्यी': '✨',
  'र्यु': '✨',
  'र्यू': '✨',
  'र्ये': '🌸',
  'र्यै': '💨',
  'र्यो': '✨',
  'र्यौ': '✨',
  'व्रा': '✨',
  'व्रि': '🐦',
  'व्री': '✨',
  'व्रु': '✨',
  'व्रू': '✨',
  'व्रे': '🌸',
  'व्रै': '💨',
  'व्रो': '✨',
  'व्रौ': '✨',
  'क्ला': '✨',
  'क्लि': '🐦',
  'क्ली': '✨',
  'क्लु': '✨',
  'क्लू': '✨',
  'क्ले': '🌸',
  'क्लै': '💨',
  'क्लो': '✨',
  'क्लौ': '✨',
  'ग्ला': '✨',
  'ग्लि': '🐦',
  'ग्ली': '✨',
  'ग्लु': '✨',
  'ग्लू': '✨',
  'ग्ले': '🌸',
  'ग्लै': '💨',
  'ग्लो': '✨',
  'ग्लौ': '✨',
  'प्ला': '✨',
  'प्लि': '🐦',
  'प्ली': '✨',
  'प्लु': '✨',
  'प्लू': '✨',
  'प्ले': '🌸',
  'प्लै': '💨',
  'प्लो': '✨',
  'प्लौ': '✨',
  'फ्ला': '✨',
  'फ्लि': '🐦',
  'फ्ली': '✨',
  'फ्लु': '✨',
  'फ्लू': '✨',
  'फ्ले': '🌸',
  'फ्लै': '💨',
  'फ्लो': '✨',
  'फ्लौ': '✨',
  'ब्ला': '✨',
  'ब्लि': '🐦',
  'ब्ली': '✨',
  'ब्लु': '✨',
  'ब्लू': '✨',
  'ब्ले': '🌸',
  'ब्लै': '💨',
  'ब्लो': '✨',
  'ब्लौ': '✨',
  'रम्या': '🏞️',
  'म्युं': '👀',
  'म्यैः': '💨',
  'धन्या': '🙏',
  'न्युं': '👀',
  'न्यैः': '💨',
  'मूल्यं': '💰',
  'ल्युं': '👀',
  'ल्यैः': '💨',
  'कार्यं': '🛠️',
  'र्युं': '👀',
  'र्यैः': '💨',
  'व्रतं': '🕉️',
  'व्रुं': '👀',
  'व्रैः': '💨',
  'शुक्ला': '🌕',
  'क्लुं': '👀',
  'क्लैः': '💨',
  'ग्लानिः': '😴',
  'ग्लुं': '👀',
  'ग्लैः': '💨',
  'प्लवः': '🛶',
  'प्लुं': '👀',
  'प्लैः': '💨',
  'फ्लुं': '👀',
  'फ्लैः': '💨',
  'ब्लुं': '👀',
  'ब्लैः': '💨',
  'श्लोकपवनः': '💨',
  'श्लोकखगः': '🐦',
  'श्लोकपुष्पम्': '🌸',
  'श्लोकमेघः': '☁️',
  'श्लोकतरुः': '🌳',
  'श्लोकसरः': '🏞️',
  'श्लोकगिरिः': '⛰️',
  'श्लोककमलम्': '🪷',
  'स्लपवनः': '💨',
  'स्लखगः': '🐦',
  'स्लपुष्पम्': '🌺',
  'स्लमेघः': '☁️',
  'स्लतरुः': '🌳',
  'स्लसरः': '🏞️',
  'स्लगिरिः': '⛰️',
  'स्लकमलम्': '🪷',
  'त्लपवनः': '💨',
  'त्लखगः': '🐦',
  'त्लपुष्पम्': '🌼',
  'त्लमेघः': '☁️',
  'त्लतरुः': '🌳',
  'त्लसरः': '🏞️',
  'त्लगिरिः': '⛰️',
  'त्लकमलम्': '🪷',
  'ज्येष्ठपवनः': '💨',
  'ज्येष्ठखगः': '🐦',
  'ज्येष्ठपुष्पम्': '🌸',
  'ज्येष्ठमेघः': '☁️',
  'ज्येष्ठतरुः': '🌳',
  'ज्येष्ठसरः': '🏞️',
  'ज्येष्ठगिरिः': '⛰️',
  'ज्येष्ठकमलम्': '🪷',
  'ष्पपवनः': '💨',
  'ष्पखगः': '🐦',
  'ष्पपुष्पम्': '🌺',
  'ष्पमेघः': '☁️',
  'ष्पतरुः': '🌳',
  'ष्पसरः': '🏞️',
  'ष्पगिरिः': '⛰️',
  'ष्पकमलम्': '🪷',
  'ध्यानपवनः': '💨',
  'ध्यानखगः': '🐦',
  'ध्यानपुष्पम्': '🌼',
  'ध्यानमेघः': '☁️',
  'ध्यानतरुः': '🌳',
  'ध्यानसरः': '🏞️',
  'ध्यानगिरिः': '⛰️',
  'ध्यानकमलम्': '🪷',
  'पथ्यपवनः': '💨',
  'पथ्यखगः': '🐦',
  'पथ्यपुष्पम्': '🌸',
  'पथ्यमेघः': '☁️',
  'पथ्यतरुः': '🌳',
  'पथ्यसरः': '🏞️',
  'पथ्यगिरिः': '⛰️',
  'पथ्यकमलम्': '🪷',
  'फ्यपवनः': '💨',
  'फ्यखगः': '🐦',
  'फ्यपुष्पम्': '🌺',
  'फ्यमेघः': '☁️',
  'फ्यतरुः': '🌳',
  'फ्यसरः': '🏞️',
  'फ्यगिरिः': '⛰️',
  'फ्यकमलम्': '🪷',
  'मुख्यपवनः': '💨',
  'मुख्यखगः': '🐦',
  'मुख्यपुष्पम्': '🌼',
  'मुख्यमेघः': '☁️',
  'मुख्यतरुः': '🌳',
  'मुख्यसरः': '🏞️',
  'मुख्यगिरिः': '⛰️',
  'मुख्यकमलम्': '🪷',
  'घ्यपवनः': '💨',
  'घ्यखगः': '🐦',
  'घ्यपुष्पम्': '🌸',
  'घ्यमेघः': '☁️',
  'घ्यतरुः': '🌳',
  'घ्यसरः': '🏞️',
  'घ्यगिरिः': '⛰️',
  'घ्यकमलम्': '🪷',
  'श्ला': '✨',
  'श्लि': '🐦',
  'श्ली': '✨',
  'श्लु': '✨',
  'श्लू': '✨',
  'श्ले': '🌸',
  'श्लै': '💨',
  'श्लो': '✨',
  'श्लौ': '✨',
  'स्ला': '✨',
  'स्लि': '🐦',
  'स्ली': '✨',
  'स्लु': '✨',
  'स्लू': '✨',
  'स्ले': '🌸',
  'स्लै': '💨',
  'स्लो': '✨',
  'स्लौ': '✨',
  'त्ला': '✨',
  'त्लि': '🐦',
  'त्ली': '✨',
  'त्लु': '✨',
  'त्लू': '✨',
  'त्ले': '🌸',
  'त्लै': '💨',
  'त्लो': '✨',
  'त्लौ': '✨',
  'ष्ठा': '✨',
  'ष्ठि': '🐦',
  'ष्ठी': '✨',
  'ष्ठु': '✨',
  'ष्ठू': '✨',
  'ष्ठे': '🌸',
  'ष्ठै': '💨',
  'ष्ठो': '✨',
  'ष्ठौ': '✨',
  'ष्पा': '✨',
  'ष्पि': '🐦',
  'ष्पी': '✨',
  'ष्पु': '✨',
  'ष्पू': '✨',
  'ष्पे': '🌸',
  'ष्पै': '💨',
  'ष्पो': '✨',
  'ष्पौ': '✨',
  'ध्या': '✨',
  'ध्यि': '🐦',
  'ध्यी': '✨',
  'ध्यु': '✨',
  'ध्यू': '✨',
  'ध्ये': '🌸',
  'ध्यै': '💨',
  'ध्यो': '✨',
  'ध्यौ': '✨',
  'थ्या': '✨',
  'थ्यि': '🐦',
  'थ्यी': '✨',
  'थ्यु': '✨',
  'थ्यू': '✨',
  'थ्ये': '🌸',
  'थ्यै': '💨',
  'थ्यो': '✨',
  'थ्यौ': '✨',
  'फ्या': '✨',
  'फ्यि': '🐦',
  'फ्यी': '✨',
  'फ्यु': '✨',
  'फ्यू': '✨',
  'फ्ये': '🌸',
  'फ्यै': '💨',
  'फ्यो': '✨',
  'फ्यौ': '✨',
  'ख्या': '✨',
  'ख्यि': '🐦',
  'ख्यी': '✨',
  'ख्यु': '✨',
  'ख्यू': '✨',
  'ख्ये': '🌸',
  'ख्यै': '💨',
  'ख्यो': '✨',
  'ख्यौ': '✨',
  'घ्या': '✨',
  'घ्यि': '🐦',
  'घ्यी': '✨',
  'घ्यु': '✨',
  'घ्यू': '✨',
  'घ्ये': '🌸',
  'घ्यै': '💨',
  'घ्यो': '✨',
  'घ्यौ': '✨',
  'श्लाघ्यं': '👍',
  'श्लुं': '👀',
  'श्लैः': '💨',
  'स्लुं': '👀',
  'स्लैः': '💨',
  'त्लुं': '👀',
  'त्लैः': '💨',
  'श्रेष्ठा': '🥇',
  'ष्ठुं': '👀',
  'ष्ठैः': '💨',
  'ष्पुं': '👀',
  'ष्पैः': '💨',
  'ध्याने': '🧘',
  'ध्युं': '👀',
  'ध्यैः': '💨',
  'पथ्या': '🥗',
  'थ्युं': '👀',
  'थ्यैः': '💨',
  'फ्युं': '👀',
  'फ्यैः': '💨',
  'मुख्या': '⭐',
  'ख्युं': '👀',
  'ख्यैः': '💨',
  'घ्युं': '👀',
  'घ्यैः': '💨',
  'त्त्रपवनः': '💨',
  'त्त्रखगः': '🐦',
  'त्त्रपुष्पम्': '🌸',
  'त्त्रमेघः': '☁️',
  'त्त्रतरुः': '🌳',
  'त्त्रसरः': '🏞️',
  'त्त्रगिरिः': '⛰️',
  'त्त्रकमलम्': '🪷',
  'द्र्यपवनः': '💨',
  'द्र्यखगः': '🐦',
  'द्र्यपुष्पम्': '🌺',
  'द्र्यमेघः': '☁️',
  'द्र्यतरुः': '🌳',
  'द्र्यसरः': '🏞️',
  'द्र्यगिरिः': '⛰️',
  'द्र्यकमलम्': '🪷',
  'ह्र्यपवनः': '💨',
  'ह्र्यखगः': '🐦',
  'ह्र्यपुष्पम्': '🌼',
  'ह्र्यमेघः': '☁️',
  'ह्र्यतरुः': '🌳',
  'ह्र्यसरः': '🏞️',
  'ह्र्यगिरिः': '⛰️',
  'ह्र्यकमलम्': '🪷',
  'ञ्च्यपवनः': '💨',
  'ञ्च्यखगः': '🐦',
  'ञ्च्यपुष्पम्': '🌸',
  'ञ्च्यमेघः': '☁️',
  'ञ्च्यतरुः': '🌳',
  'ञ्च्यसरः': '🏞️',
  'ञ्च्यगिरिः': '⛰️',
  'ञ्च्यकमलम्': '🪷',
  'राष्ट्रपवनः': '🏳️',
  'राष्ट्रखगः': '🐦',
  'राष्ट्रपुष्पम्': '🌺',
  'राष्ट्रमेघः': '☁️',
  'राष्ट्रतरुः': '🌳',
  'राष्ट्रसरः': '🏞️',
  'राष्ट्रगिरिः': '⛰️',
  'राष्ट्रकमलम्': '🪷',
  'त्त्रा': '✨',
  'त्त्रि': '🐦',
  'त्त्री': '✨',
  'त्त्रु': '✨',
  'त्त्रू': '✨',
  'त्त्रे': '🌸',
  'त्त्रै': '💨',
  'त्त्रो': '✨',
  'त्त्रौ': '✨',
  'द्र्या': '✨',
  'द्र्यि': '🐦',
  'द्र्यी': '✨',
  'द्र्यु': '✨',
  'द्र्यू': '✨',
  'द्र्ये': '🌸',
  'द्र्यै': '💨',
  'द्र्यो': '✨',
  'द्र्यौ': '✨',
  'ह्र्या': '✨',
  'ह्र्यि': '🐦',
  'ह्र्यी': '✨',
  'ह्र्यु': '✨',
  'ह्र्यू': '✨',
  'ह्र्ये': '🌸',
  'ह्र्यै': '💨',
  'ह्र्यो': '✨',
  'ह्र्यौ': '✨',
  'ञ्च्या': '✨',
  'ञ्च्यि': '🐦',
  'ञ्च्यी': '✨',
  'ञ्च्यु': '✨',
  'ञ्च्यू': '✨',
  'ञ्च्ये': '🌸',
  'ञ्च्यै': '💨',
  'ञ्च्यो': '✨',
  'ञ्च्यौ': '✨',
  'ष्ट्रा': '✨',
  'ष्ट्रि': '🐦',
  'ष्ट्री': '✨',
  'ष्ट्रु': '✨',
  'ष्ट्रू': '✨',
  'ष्ट्रे': '🌸',
  'ष्ट्रै': '💨',
  'ष्ट्रो': '✨',
  'ष्ट्रौ': '✨',
  'त्त्रुं': '👀',
  'त्त्रैः': '💨',
  'द्र्युं': '👀',
  'द्र्यैः': '💨',
  'ह्र्युं': '👀',
  'ह्र्यैः': '💨',
  'ञ्च्युं': '👀',
  'ञ्च्यैः': '💨',
  'राष्ट्राणि': '🇮🇳',
  'ष्ट्रुं': '👀',
  'ष्ट्रैः': '💨',
  'क्ष्यपवनः': '💨',
  'क्ष्यखगः': '🐦',
  'क्ष्यपुष्पम्': '🌸',
  'क्ष्यमेघः': '☁️',
  'क्ष्यतरुः': '🌳',
  'क्ष्यसरः': '🏞️',
  'क्ष्यगिरिः': '⛰️',
  'क्ष्यकमलम्': '🪷',
  'ज्ञ्यपवनः': '💨',
  'ज्ञ्यखगः': '🐦',
  'ज्ञ्यपुष्पम्': '🌺',
  'ज्ञ्यमेघः': '☁️',
  'ज्ञ्यतरुः': '🌳',
  'ज्ञ्यसरः': '🏞️',
  'ज्ञ्यगिरिः': '⛰️',
  'ज्ञ्यकमलम्': '🪷',
  'त्र्यपवनः': '💨',
  'त्र्यखगः': '🐦',
  'त्र्यपुष्पम्': '🌼',
  'त्र्यमेघः': '☁️',
  'त्र्यतरुः': '🌳',
  'त्र्यसरः': '🏞️',
  'त्र्यगिरिः': '⛰️',
  'त्र्यकमलम्': '🪷',
  'श्र्यपवनः': '💨',
  'श्र्यखगः': '🐦',
  'श्र्यपुष्पम्': '🌸',
  'श्र्यमेघः': '☁️',
  'श्र्यतरुः': '🌳',
  'श्र्यसरः': '🏞️',
  'श्र्यगिरिः': '⛰️',
  'श्र्यकमलम्': '🪷',
  'प्र्यपवनः': '💨',
  'प्र्यखगः': '🐦',
  'प्र्यपुष्पम्': '🌺',
  'प्र्यमेघः': '☁️',
  'प्र्यतरुः': '🌳',
  'प्र्यसरः': '🏞️',
  'प्र्यगिरिः': '⛰️',
  'प्र्यकमलम्': '🪷',
  'क्ष्या': '✨',
  'क्ष्यि': '🐦',
  'क्ष्यी': '✨',
  'क्ष्यु': '✨',
  'क्ष्यू': '✨',
  'क्ष्ये': '🌸',
  'क्ष्यै': '💨',
  'क्ष्यो': '✨',
  'क्ष्यौ': '✨',
  'ज्ञ्या': '✨',
  'ज्ञ्यि': '🐦',
  'ज्ञ्यी': '✨',
  'ज्ञ्यु': '✨',
  'ज्ञ्यू': '✨',
  'ज्ञ्ये': '🌸',
  'ज्ञ्यै': '💨',
  'ज्ञ्यो': '✨',
  'ज्ञ्यौ': '✨',
  'त्र्या': '✨',
  'त्र्यि': '🐦',
  'त्र्यी': '✨',
  'त्र्यु': '✨',
  'त्र्यू': '✨',
  'त्र्ये': '🌸',
  'त्र्यै': '💨',
  'त्र्यो': '✨',
  'त्र्यौ': '✨',
  'श्र्या': '✨',
  'श्र्यि': '🐦',
  'श्र्यी': '✨',
  'श्र्यु': '✨',
  'श्र्यू': '✨',
  'श्र्ये': '🌸',
  'श्र्यै': '💨',
  'श्र्यो': '✨',
  'श्र्यौ': '✨',
  'प्र्या': '✨',
  'प्र्यि': '🐦',
  'प्र्यी': '✨',
  'प्र्यु': '✨',
  'प्र्यू': '✨',
  'प्र्ये': '🌸',
  'प्र्यै': '💨',
  'प्र्यो': '✨',
  'प्र्यौ': '✨',
  'क्ष्युं': '👀',
  'क्ष्यैः': '💨',
  'ज्ञ्युं': '👀',
  'ज्ञ्यैः': '💨',
  'त्र्युं': '👀',
  'त्र्यैः': '💨',
  'श्र्युं': '👀',
  'श्र्यैः': '💨',
  'प्र्युं': '👀',
  'प्र्यैः': '💨',
  'क्र्यपवनः': '💨',
  'क्र्यखगः': '🐦',
  'क्र्यपुष्पम्': '🌸',
  'क्र्यमेघः': '☁️',
  'क्र्यतरुः': '🌳',
  'क्र्यसरः': '🏞️',
  'क्र्यगिरिः': '⛰️',
  'क्र्यकमलम्': '🪷',
  'ग्र्यपवनः': '💨',
  'ग्र्यखगः': '🐦',
  'ग्र्यपुष्पम्': '🌺',
  'ग्र्यमेघः': '☁️',
  'ग्र्यतरुः': '🌳',
  'ग्र्यसरः': '🏞️',
  'ग्र्यगिरिः': '⛰️',
  'ग्र्यकमलम्': '🪷',
  'ब्र्यपवनः': '💨',
  'ब्र्यखगः': '🐦',
  'ब्र्यपुष्पम्': '🌼',
  'ब्र्यमेघः': '☁️',
  'ब्र्यतरुः': '🌳',
  'ब्र्यसरः': '🏞️',
  'ब्र्यगिरिः': '⛰️',
  'ब्र्यकमलम्': '🪷',
  'त्व्यपवनः': '💨',
  'त्व्यखगः': '🐦',
  'त्व्यपुष्पम्': '🌸',
  'त्व्यमेघः': '☁️',
  'त्व्यतरुः': '🌳',
  'त्व्यसरः': '🏞️',
  'त्व्यगिरिः': '⛰️',
  'त्व्यकमलम्': '🪷',
  'स्त्यपवनः': '💨',
  'स्त्यखगः': '🐦',
  'स्त्यपुष्पम्': '🌺',
  'स्त्यमेघः': '☁️',
  'स्त्यतरुः': '🌳',
  'स्त्यसरः': '🏞️',
  'स्त्यगिरिः': '⛰️',
  'स्त्यकमलम्': '🪷',
  'क्र्या': '✨',
  'क्र्यि': '🐦',
  'क्र्यी': '✨',
  'क्र्यु': '✨',
  'क्र्यू': '✨',
  'क्र्ये': '🌸',
  'क्र्यै': '💨',
  'क्र्यो': '✨',
  'क्र्यौ': '✨',
  'ग्र्या': '✨',
  'ग्र्यि': '🐦',
  'ग्र्यी': '✨',
  'ग्र्यु': '✨',
  'ग्र्यू': '✨',
  'ग्र्ये': '🌸',
  'ग्र्यै': '💨',
  'ग्र्यो': '✨',
  'ग्र्यौ': '✨',
  'ब्र्या': '✨',
  'ब्र्यि': '🐦',
  'ब्र्यी': '✨',
  'ब्र्यु': '✨',
  'ब्र्यू': '✨',
  'ब्र्ये': '🌸',
  'ब्र्यै': '💨',
  'ब्र्यो': '✨',
  'ब्र्यौ': '✨',
  'त्व्या': '✨',
  'त्व्यि': '🐦',
  'त्व्यी': '✨',
  'त्व्यु': '✨',
  'त्व्यू': '✨',
  'त्व्ये': '🌸',
  'त्व्यै': '💨',
  'त्व्यो': '✨',
  'त्व्यौ': '✨',
  'स्त्या': '✨',
  'स्त्यि': '🐦',
  'स्त्यी': '✨',
  'स्त्यु': '✨',
  'स्त्यू': '✨',
  'स्त्ये': '🌸',
  'स्त्यै': '💨',
  'स्त्यो': '✨',
  'स्त्यौ': '✨',
  'क्र्युं': '👀',
  'क्र्यैः': '💨',
  'ग्र्युं': '👀',
  'ग्र्यैः': '💨',
  'ब्र्युं': '👀',
  'ब्र्यैः': '💨',
  'त्व्युं': '👀',
  'त्व्यैः': '💨',
  'स्त्युं': '👀',
  'स्त्यैः': '💨',
  'म्र्यपवनः': '💨',
  'म्र्यखगः': '🐦',
  'म्र्यपुष्पम्': '🌸',
  'म्र्यमेघः': '☁️',
  'म्र्यतरुः': '🌳',
  'म्र्यसरः': '🏞️',
  'म्र्यगिरिः': '⛰️',
  'म्र्यकमलम्': '🪷',
  'न्र्यपवनः': '💨',
  'न्र्यखगः': '🐦',
  'न्र्यपुष्पम्': '🌺',
  'न्र्यमेघः': '☁️',
  'न्र्यतरुः': '🌳',
  'न्र्यसरः': '🏞️',
  'न्र्यगिरिः': '⛰️',
  'न्र्यकमलम्': '🪷',
  'स्र्यपवनः': '💨',
  'स्र्यखगः': '🐦',
  'स्र्यपुष्पम्': '🌼',
  'स्र्यमेघः': '☁️',
  'स्र्यतरुः': '🌳',
  'स्र्यसरः': '🏞️',
  'स्र्यगिरिः': '⛰️',
  'स्र्यकमलम्': '🪷',
  'ब्यपवनः': '💨',
  'ब्यखगः': '🐦',
  'ब्यपुष्पम्': '🌸',
  'ब्यमेघः': '☁️',
  'ब्यतरुः': '🌳',
  'ब्यसरः': '🏞️',
  'ब्यगिरिः': '⛰️',
  'ब्यकमलम्': '🪷',
  'ष्यपवनः': '💨',
  'ष्यखगः': '🐦',
  'ष्यपुष्पम्': '🌺',
  'ष्यमेघः': '☁️',
  'ष्यतरुः': '🌳',
  'ष्यसरः': '🏞️',
  'ष्यगिरिः': '⛰️',
  'ष्यकमलम्': '🪷',
  'म्र्या': '✨',
  'म्र्यि': '🐦',
  'म्र्यी': '✨',
  'म्र्यु': '✨',
  'म्र्यू': '✨',
  'म्र्ये': '🌸',
  'म्र्यै': '💨',
  'म्र्यो': '✨',
  'म्र्यौ': '✨',
  'न्र्या': '✨',
  'न्र्यि': '🐦',
  'न्र्यी': '✨',
  'न्र्यु': '✨',
  'न्र्यू': '✨',
  'न्र्ये': '🌸',
  'न्र्यै': '💨',
  'न्र्यो': '✨',
  'न्र्यौ': '✨',
  'स्र्या': '✨',
  'स्र्यि': '🐦',
  'स्र्यी': '✨',
  'स्र्यु': '✨',
  'स्र्यू': '✨',
  'स्र्ये': '🌸',
  'स्र्यै': '💨',
  'स्र्यो': '✨',
  'स्र्यौ': '✨',
  'ब्या': '✨',
  'ब्यि': '🐦',
  'ब्यी': '✨',
  'ब्यु': '✨',
  'ब्यू': '✨',
  'ब्ये': '🌸',
  'ब्यै': '💨',
  'ब्यो': '✨',
  'ब्यौ': '✨',
  'ष्या': '✨',
  'ष्यि': '🐦',
  'ष्यी': '✨',
  'ष्यु': '✨',
  'ष्यू': '✨',
  'ष्ये': '🌸',
  'ष्यै': '💨',
  'ष्यो': '✨',
  'ष्यौ': '✨',
  'म्र्युं': '👀',
  'म्र्यैः': '💨',
  'न्र्युं': '👀',
  'न्र्यैः': '💨',
  'स्र्युं': '👀',
  'स्र्यैः': '💨',
  'ब्युं': '👀',
  'ब्यैः': '💨',
  'ष्युं': '👀',
  'ष्यैः': '💨',
  'स्व्यपवनः': '💨',
  'स्व्यखगः': '🐦',
  'स्व्यपुष्पम्': '🌸',
  'स्व्यमेघः': '☁️',
  'स्व्यतरुः': '🌳',
  'स्व्यसरः': '🏞️',
  'स्व्यगिरिः': '⛰️',
  'स्व्यकमलम्': '🪷',
  'स्म्यपवनः': '💨',
  'स्म्यखगः': '🐦',
  'स्म्यपुष्पम्': '🌺',
  'स्म्यमेघः': '☁️',
  'स्म्यतरुः': '🌳',
  'स्म्यसरः': '🏞️',
  'स्म्यगिरिः': '⛰️',
  'स्म्यकमलम्': '🪷',
  'स्न्यपवनः': '💨',
  'स्न्यखगः': '🐦',
  'स्न्यपुष्पम्': '🌼',
  'स्न्यमेघः': '☁️',
  'स्न्यतरुः': '🌳',
  'स्न्यसरः': '🏞️',
  'स्न्यगिरिः': '⛰️',
  'स्न्यकमलम्': '🪷',
  'ह्व्यपवनः': '💨',
  'ह्व्यखगः': '🐦',
  'ह्व्यपुष्पम्': '🌸',
  'ह्व्यमेघः': '☁️',
  'ह्व्यतरुः': '🌳',
  'ह्व्यसरः': '🏞️',
  'ह्व्यगिरिः': '⛰️',
  'ह्व्यकमलम्': '🪷',
  'ष्ट्यपवनः': '💨',
  'ष्ट्यखगः': '🐦',
  'ष्ट्यपुष्पम्': '🌺',
  'ष्ट्यमेघः': '☁️',
  'ष्ट्यतरुः': '🌳',
  'ष्ट्यसरः': '🏞️',
  'ष्ट्यगिरिः': '⛰️',
  'ष्ट्यकमलम्': '🪷',
  'स्व्या': '✨',
  'स्व्यि': '🐦',
  'स्व्यी': '✨',
  'स्व्यु': '✨',
  'स्व्यू': '✨',
  'स्व्ये': '🌸',
  'स्व्यै': '💨',
  'स्व्यो': '✨',
  'स्व्यौ': '✨',
  'स्म्या': '✨',
  'स्म्यि': '🐦',
  'स्म्यी': '✨',
  'स्म्यु': '✨',
  'स्म्यू': '✨',
  'स्म्ये': '🌸',
  'स्म्यै': '💨',
  'स्म्यो': '✨',
  'स्म्यौ': '✨',
  'स्न्या': '✨',
  'स्न्यि': '🐦',
  'स्न्यी': '✨',
  'स्न्यु': '✨',
  'स्न्यू': '✨',
  'स्न्ये': '🌸',
  'स्न्यै': '💨',
  'स्न्यो': '✨',
  'स्न्यौ': '✨',
  'ह्व्या': '✨',
  'ह्व्यि': '🐦',
  'ह्व्यी': '✨',
  'ह्व्यु': '✨',
  'ह्व्यू': '✨',
  'ह्व्ये': '🌸',
  'ह्व्यै': '💨',
  'ह्व्यो': '✨',
  'ह्व्यौ': '✨',
  'ष्ट्या': '✨',
  'ष्ट्यि': '🐦',
  'ष्ट्यी': '✨',
  'ष्ट्यु': '✨',
  'ष्ट्यू': '✨',
  'ष्ट्ये': '🌸',
  'ष्ट्यै': '💨',
  'ष्ट्यो': '✨',
  'ष्ट्यौ': '✨',
  'स्व्युं': '👀',
  'स्व्यैः': '💨',
  'स्म्युं': '👀',
  'स्म्यैः': '💨',
  'स्न्युं': '👀',
  'स्न्यैः': '💨',
  'ह्व्युं': '👀',
  'ह्व्यैः': '💨',
  'ष्ट्युं': '👀',
  'ष्ट्यैः': '💨',
  'झ्यपवनः': '💨',
  'झ्यखगः': '🐦',
  'झ्यपुष्पम्': '🌸',
  'झ्यमेघः': '☁️',
  'झ्यतरुः': '🌳',
  'झ्यसरः': '🏞️',
  'झ्यगिरिः': '⛰️',
  'झ्यकमलम्': '🪷',
  'ट्यपवनः': '💨',
  'ट्यखगः': '🐦',
  'ट्यपुष्पम्': '🌺',
  'ट्यमेघः': '☁️',
  'ट्यतरुः': '🌳',
  'ट्यसरः': '🏞️',
  'ट्यगिरिः': '⛰️',
  'ट्यकमलम्': '🪷',
  'ठ्यपवनः': '💨',
  'ठ्यखगः': '🐦',
  'ठ्यपुष्पम्': '🌼',
  'ठ्यमेघः': '☁️',
  'ठ्यतरुः': '🌳',
  'ठ्यसरः': '🏞️',
  'ठ्यगिरिः': '⛰️',
  'ठ्यकमलम्': '🪷',
  'ड्यपवनः': '💨',
  'ड्यखगः': '🐦',
  'ड्यपुष्पम्': '🌸',
  'ड्यमेघः': '☁️',
  'ड्यतरुः': '🌳',
  'ड्यसरः': '🏞️',
  'ड्यगिरिः': '⛰️',
  'ड्यकमलम्': '🪷',
  'ढ्यपवनः': '💨',
  'ढ्यखगः': '🐦',
  'ढ्यपुष्पम्': '🌺',
  'ढ्यमेघः': '☁️',
  'ढ्यतरुः': '🌳',
  'ढ्यसरः': '🏞️',
  'ढ्यगिरिः': '⛰️',
  'ढ्यकमलम्': '🪷',
  'झ्या': '✨',
  'झ्यि': '🐦',
  'झ्यी': '✨',
  'झ्यु': '✨',
  'झ्यू': '✨',
  'झ्ये': '🌸',
  'झ्यै': '💨',
  'झ्यो': '✨',
  'झ्यौ': '✨',
  'ट्या': '✨',
  'ट्यि': '🐦',
  'ट्यी': '✨',
  'ट्यु': '✨',
  'ट्यू': '✨',
  'ट्ये': '🌸',
  'ट्यै': '💨',
  'ट्यो': '✨',
  'ट्यौ': '✨',
  'ठ्या': '✨',
  'ठ्यि': '🐦',
  'ठ्यी': '✨',
  'ठ्यु': '✨',
  'ठ्यू': '✨',
  'ठ्ये': '🌸',
  'ठ्यै': '💨',
  'ठ्यो': '✨',
  'ठ्यौ': '✨',
  'ड्या': '✨',
  'ड्यि': '🐦',
  'ड्यी': '✨',
  'ड्यु': '✨',
  'ड्यू': '✨',
  'ड्ये': '🌸',
  'ड्यै': '💨',
  'ड्यो': '✨',
  'ड्यौ': '✨',
  'ढ्या': '✨',
  'ढ्यि': '🐦',
  'ढ्यी': '✨',
  'ढ्यु': '✨',
  'ढ्यू': '✨',
  'ढ्ये': '🌸',
  'ढ्यै': '💨',
  'ढ्यो': '✨',
  'ढ्यौ': '✨',
  'झ्युं': '👀',
  'झ्यैः': '💨',
  'ट्युं': '👀',
  'ट्यैः': '💨',
  'ठ्युं': '👀',
  'ठ्यैः': '💨',
  'ड्युं': '👀',
  'ड्यैः': '💨',
  'ढ्युं': '👀',
  'ढ्यैः': '💨',
  'ण्यपवनः': '💨',
  'ण्यखगः': '🐦',
  'ण्यपुष्पम्': '🌸',
  'ण्यमेघः': '☁️',
  'ण्यतरुः': '🌳',
  'ण्यसरः': '🏞️',
  'ण्यगिरिः': '⛰️',
  'ण्यकमलम्': '🪷',
  'क्ल्यपवनः': '💨',
  'क्ल्यखगः': '🐦',
  'क्ल्यपुष्पम्': '🌺',
  'क्ल्यमेघः': '☁️',
  'क्ल्यतरुः': '🌳',
  'क्ल्यसरः': '🏞️',
  'क्ल्यगिरिः': '⛰️',
  'क्ल्यकमलम्': '🪷',
  'ग्ल्यपवनः': '💨',
  'ग्ल्यखगः': '🐦',
  'ग्ल्यपुष्पम्': '🌼',
  'ग्ल्यमेघः': '☁️',
  'ग्ल्यतरुः': '🌳',
  'ग्ल्यसरः': '🏞️',
  'ग्ल्यगिरिः': '⛰️',
  'ग्ल्यकमलम्': '🪷',
  'प्ल्यपवनः': '💨',
  'प्ल्यखगः': '🐦',
  'प्ल्यपुष्पम्': '🌸',
  'प्ल्यमेघः': '☁️',
  'प्ल्यतरुः': '🌳',
  'प्ल्यसरः': '🏞️',
  'प्ल्यगिरिः': '⛰️',
  'प्ल्यकमलम्': '🪷',
  'म्ल्यपवनः': '💨',
  'म्ल्यखगः': '🐦',
  'म्ल्यपुष्पम्': '🌺',
  'म्ल्यमेघः': '☁️',
  'म्ल्यतरुः': '🌳',
  'म्ल्यसरः': '🏞️',
  'म्ल्यगिरिः': '⛰️',
  'म्ल्यकमलम्': '🪷',
  'ण्या': '✨',
  'ण्यि': '🐦',
  'ण्यी': '✨',
  'ण्यु': '✨',
  'ण्यू': '✨',
  'ण्ये': '🌸',
  'ण्यै': '💨',
  'ण्यो': '✨',
  'ण्यौ': '✨',
  'क्ल्या': '✨',
  'क्ल्यि': '🐦',
  'क्ल्यी': '✨',
  'क्ल्यु': '✨',
  'क्ल्यू': '✨',
  'क्ल्ये': '🌸',
  'क्ल्यै': '💨',
  'क्ल्यो': '✨',
  'क्ल्यौ': '✨',
  'ग्ल्या': '✨',
  'ग्ल्यि': '🐦',
  'ग्ल्यी': '✨',
  'ग्ल्यु': '✨',
  'ग्ल्यू': '✨',
  'ग्ल्ये': '🌸',
  'ग्ल्यै': '💨',
  'ग्ल्यो': '✨',
  'ग्ल्यौ': '✨',
  'प्ल्या': '✨',
  'प्ल्यि': '🐦',
  'प्ल्यी': '✨',
  'प्ल्यु': '✨',
  'प्ल्यू': '✨',
  'प्ल्ये': '🌸',
  'प्ल्यै': '💨',
  'प्ल्यो': '✨',
  'प्ल्यौ': '✨',
  'म्ल्या': '✨',
  'म्ल्यि': '🐦',
  'म्ल्यी': '✨',
  'म्ल्यु': '✨',
  'म्ल्यू': '✨',
  'म्ल्ये': '🌸',
  'म्ल्यै': '💨',
  'म्ल्यो': '✨',
  'म्ल्यौ': '✨',
  'ण्युं': '👀',
  'ण्यैः': '💨',
  'क्ल्युं': '👀',
  'क्ल्यैः': '💨',
  'ग्ल्युं': '👀',
  'ग्ल्यैः': '💨',
  'प्ल्युं': '👀',
  'प्ल्यैः': '💨',
  'म्ल्युं': '👀',
  'म्ल्यैः': '💨',
  'स्ल्यपवनः': '💨',
  'स्ल्यखगः': '🐦',
  'स्ल्यपुष्पम्': '🌸',
  'स्ल्यमेघः': '☁️',
  'स्ल्यतरुः': '🌳',
  'स्ल्यसरः': '🏞️',
  'स्ल्यगिरिः': '⛰️',
  'स्ल्यकमलम्': '🪷',
  'श्ल्यपवनः': '💨',
  'श्ल्यखगः': '🐦',
  'श्ल्यपुष्पम्': '🌺',
  'श्ल्यमेघः': '☁️',
  'श्ल्यतरुः': '🌳',
  'श्ल्यसरः': '🏞️',
  'श्ल्यगिरिः': '⛰️',
  'श्ल्यकमलम्': '🪷',
  'ष्ठ्यपवनः': '💨',
  'ष्ठ्यखगः': '🐦',
  'ष्ठ्यपुष्पम्': '🌼',
  'ष्ठ्यमेघः': '☁️',
  'ष्ठ्यतरुः': '🌳',
  'ष्ठ्यसरः': '🏞️',
  'ष्ठ्यगिरिः': '⛰️',
  'ष्ठ्यकमलम्': '🪷',
  'फ्ल्यपवनः': '💨',
  'फ्ल्यखगः': '🐦',
  'फ्ल्यपुष्पम्': '🌸',
  'फ्ल्यमेघः': '☁️',
  'फ्ल्यतरुः': '🌳',
  'फ्ल्यसरः': '🏞️',
  'फ्ल्यगिरिः': '⛰️',
  'फ्ल्यकमलम्': '🪷',
  'त्ल्यपवनः': '💨',
  'त्ल्यखगः': '🐦',
  'त्ल्यपुष्पम्': '🌺',
  'त्ल्यमेघः': '☁️',
  'त्ल्यतरुः': '🌳',
  'त्ल्यसरः': '🏞️',
  'त्ल्यगिरिः': '⛰️',
  'त्ल्यकमलम्': '🪷',
  'स्ल्या': '✨',
  'स्ल्यि': '🐦',
  'स्ल्यी': '✨',
  'स्ल्यु': '✨',
  'स्ल्यू': '✨',
  'स्ल्ये': '🌸',
  'स्ल्यै': '💨',
  'स्ल्यो': '✨',
  'स्ल्यौ': '✨',
  'श्ल्या': '✨',
  'श्ल्यि': '🐦',
  'श्ल्यी': '✨',
  'श्ल्यु': '✨',
  'श्ल्यू': '✨',
  'श्ल्ये': '🌸',
  'श्ल्यै': '💨',
  'श्ल्यो': '✨',
  'श्ल्यौ': '✨',
  'ष्ठ्या': '✨',
  'ष्ठ्यि': '🐦',
  'ष्ठ्यी': '✨',
  'ष्ठ्यु': '✨',
  'ष्ठ्यू': '✨',
  'ष्ठ्ये': '🌸',
  'ष्ठ्यै': '💨',
  'ष्ठ्यो': '✨',
  'ष्ठ्यौ': '✨',
  'फ्ल्या': '✨',
  'फ्ल्यि': '🐦',
  'फ्ल्यी': '✨',
  'फ्ल्यु': '✨',
  'फ्ल्यू': '✨',
  'फ्ल्ये': '🌸',
  'फ्ल्यै': '💨',
  'फ्ल्यो': '✨',
  'फ्ल्यौ': '✨',
  'त्ल्या': '✨',
  'त्ल्यि': '🐦',
  'त्ल्यी': '✨',
  'त्ल्यु': '✨',
  'त्ल्यू': '✨',
  'त्ल्ये': '🌸',
  'त्ल्यै': '💨',
  'त्ल्यो': '✨',
  'त्ल्यौ': '✨',
  'स्ल्युं': '👀',
  'स्ल्यैः': '💨',
  'श्ल्युं': '👀',
  'श्ल्यैः': '💨',
  'ष्ठ्युं': '👀',
  'ष्ठ्यैः': '💨',
  'फ्ल्युं': '👀',
  'फ्ल्यैः': '💨',
  'त्ल्युं': '👀',
  'त्ल्यैः': '💨',
  'ब्ल्यपवनः': '💨',
  'ब्ल्यखगः': '🐦',
  'ब्ल्यपुष्पम्': '🌸',
  'ब्ल्यमेघः': '☁️',
  'ब्ल्यतरुः': '🌳',
  'ब्ल्यसरः': '🏞️',
  'ब्ल्यगिरिः': '⛰️',
  'ब्ल्यकमलम्': '🪷',
  'ह्ल्यपवनः': '💨',
  'ह्ल्यखगः': '🐦',
  'ह्ल्यपुष्पम्': '🌺',
  'ह्ल्यमेघः': '☁️',
  'ह्ल्यतरुः': '🌳',
  'ह्ल्यसरः': '🏞️',
  'ह्ल्यगिरिः': '⛰️',
  'ह्ल्यकमलम्': '🪷',
  'ज्र्यपवनः': '💨',
  'ज्र्यखगः': '🐦',
  'ज्र्यपुष्पम्': '🌼',
  'ज्र्यमेघः': '☁️',
  'ज्र्यतरुः': '🌳',
  'ज्र्यसरः': '🏞️',
  'ज्र्यगिरिः': '⛰️',
  'ज्र्यकमलम्': '🪷',
  'ध्र्यपवनः': '💨',
  'ध्र्यखगः': '🐦',
  'ध्र्यपुष्पम्': '🌸',
  'ध्र्यमेघः': '☁️',
  'ध्र्यतरुः': '🌳',
  'ध्र्यसरः': '🏞️',
  'ध्र्यगिरिः': '⛰️',
  'ध्र्यकमलम्': '🪷',
  'भ्र्यपवनः': '💨',
  'भ्र्यखगः': '🐦',
  'भ्र्यपुष्पम्': '🌺',
  'भ्र्यमेघः': '☁️',
  'भ्र्यतरुः': '🌳',
  'भ्र्यसरः': '🏞️',
  'भ्र्यगिरिः': '⛰️',
  'भ्र्यकमलम्': '🪷',
  'ब्ल्या': '✨',
  'ब्ल्यि': '🐦',
  'ब्ल्यी': '✨',
  'ब्ल्यु': '✨',
  'ब्ल्यू': '✨',
  'ब्ल्ये': '🌸',
  'ब्ल्यै': '💨',
  'ब्ल्यो': '✨',
  'ब्ल्यौ': '✨',
  'ह्ल्या': '✨',
  'ह्ल्यि': '🐦',
  'ह्ल्यी': '✨',
  'ह्ल्यु': '✨',
  'ह्ल्यू': '✨',
  'ह्ल्ये': '🌸',
  'ह्ल्यै': '💨',
  'ह्ल्यो': '✨',
  'ह्ल्यौ': '✨',
  'ज्र्या': '✨',
  'ज्र्यि': '🐦',
  'ज्र्यी': '✨',
  'ज्र्यु': '✨',
  'ज्र्यू': '✨',
  'ज्र्ये': '🌸',
  'ज्र्यै': '💨',
  'ज्र्यो': '✨',
  'ज्र्यौ': '✨',
  'ध्र्या': '✨',
  'ध्र्यि': '🐦',
  'ध्र्यी': '✨',
  'ध्र्यु': '✨',
  'ध्र्यू': '✨',
  'ध्र्ये': '🌸',
  'ध्र्यै': '💨',
  'ध्र्यो': '✨',
  'ध्र्यौ': '✨',
  'भ्र्या': '✨',
  'भ्र्यि': '🐦',
  'भ्र्यी': '✨',
  'भ्र्यु': '✨',
  'भ्र्यू': '✨',
  'भ्र्ये': '🌸',
  'भ्र्यै': '💨',
  'भ्र्यो': '✨',
  'भ्र्यौ': '✨',
  'ब्ल्युं': '👀',
  'ब्ल्यैः': '💨',
  'ह्ल्युं': '👀',
  'ह्ल्यैः': '💨',
  'ज्र्युं': '👀',
  'ज्र्यैः': '💨',
  'ध्र्युं': '👀',
  'ध्र्यैः': '💨',
  'भ्र्युं': '👀',
  'भ्र्यैः': '💨',
  'च्र्यपवनः': '💨',
  'च्र्यखगः': '🐦',
  'च्र्यपुष्पम्': '🌸',
  'च्र्यमेघः': '☁️',
  'च्र्यतरुः': '🌳',
  'च्र्यसरः': '🏞️',
  'च्र्यगिरिः': '⛰️',
  'च्र्यकमलम्': '🪷',
  'ख्र्यपवनः': '💨',
  'ख्र्यखगः': '🐦',
  'ख्र्यपुष्पम्': '🌺',
  'ख्र्यमेघः': '☁️',
  'ख्र्यतरुः': '🌳',
  'ख्र्यसरः': '🏞️',
  'ख्र्यगिरिः': '⛰️',
  'ख्र्यकमलम्': '🪷',
  'थ्र्यपवनः': '💨',
  'थ्र्यखगः': '🐦',
  'थ्र्यपुष्पम्': '🌼',
  'थ्र्यमेघः': '☁️',
  'थ्र्यतरुः': '🌳',
  'थ्र्यसरः': '🏞️',
  'थ्र्यगिरिः': '⛰️',
  'थ्र्यकमलम्': '🪷',
  'फ्र्यपवनः': '💨',
  'फ्र्यखगः': '🐦',
  'फ्र्यपुष्पम्': '🌸',
  'फ्र्यमेघः': '☁️',
  'फ्र्यतरुः': '🌳',
  'फ्र्यसरः': '🏞️',
  'फ्र्यगिरिः': '⛰️',
  'फ्र्यकमलम्': '🪷',
  'व्र्यपवनः': '💨',
  'व्र्यखगः': '🐦',
  'व्र्यपुष्पम्': '🌺',
  'व्र्यमेघः': '☁️',
  'व्र्यतरुः': '🌳',
  'व्र्यसरः': '🏞️',
  'व्र्यगिरिः': '⛰️',
  'व्र्यकमलम्': '🪷',
  'च्र्या': '✨',
  'च्र्यि': '🐦',
  'च्र्यी': '✨',
  'च्र्यु': '✨',
  'च्र्यू': '✨',
  'च्र्ये': '🌸',
  'च्र्यै': '💨',
  'च्र्यो': '✨',
  'च्र्यौ': '✨',
  'ख्र्या': '✨',
  'ख्र्यि': '🐦',
  'ख्र्यी': '✨',
  'ख्र्यु': '✨',
  'ख्र्यू': '✨',
  'ख्र्ये': '🌸',
  'ख्र्यै': '💨',
  'ख्र्यो': '✨',
  'ख्र्यौ': '✨',
  'थ्र्या': '✨',
  'थ्र्यि': '🐦',
  'थ्र्यी': '✨',
  'थ्र्यु': '✨',
  'थ्र्यू': '✨',
  'थ्र्ये': '🌸',
  'थ्र्यै': '💨',
  'थ्र्यो': '✨',
  'थ्र्यौ': '✨',
  'फ्र्या': '✨',
  'फ्र्यि': '🐦',
  'फ्र्यी': '✨',
  'फ्र्यु': '✨',
  'फ्र्यू': '✨',
  'फ्र्ये': '🌸',
  'फ्र्यै': '💨',
  'फ्र्यो': '✨',
  'फ्र्यौ': '✨',
  'व्र्या': '✨',
  'व्र्यि': '🐦',
  'व्र्यी': '✨',
  'व्र्यु': '✨',
  'व्र्यू': '✨',
  'व्र्ये': '🌸',
  'व्र्यै': '💨',
  'व्र्यो': '✨',
  'व्र्यौ': '✨',
  'च्र्युं': '👀',
  'च्र्यैः': '💨',
  'ख्र्युं': '👀',
  'ख्र्यैः': '💨',
  'थ्र्युं': '👀',
  'थ्र्यैः': '💨',
  'फ्र्युं': '👀',
  'फ्र्यैः': '💨',
  'व्र्युं': '👀',
  'व्र्यैः': '💨',
  'घ्र्यपवनः': '💨',
  'घ्र्यखगः': '🐦',
  'घ्र्यपुष्पम्': '🌸',
  'घ्र्यमेघः': '☁️',
  'घ्र्यतरुः': '🌳',
  'घ्र्यसरः': '🏞️',
  'घ्र्यगिरिः': '⛰️',
  'घ्र्यकमलम्': '🪷',
  'झ्र्यपवनः': '💨',
  'झ्र्यखगः': '🐦',
  'झ्र्यपुष्पम्': '🌺',
  'झ्र्यमेघः': '☁️',
  'झ्र्यतरुः': '🌳',
  'झ्र्यसरः': '🏞️',
  'झ्र्यगिरिः': '⛰️',
  'झ्र्यकमलम्': '🪷',
  'ट्र्यपवनः': '💨',
  'ट्र्यखगः': '🐦',
  'ट्र्यपुष्पम्': '🌼',
  'ट्र्यमेघः': '☁️',
  'ट्र्यतरुः': '🌳',
  'ट्र्यसरः': '🏞️',
  'ट्र्यगिरिः': '⛰️',
  'ट्र्यकमलम्': '🪷',
  'ड्र्यपवनः': '💨',
  'ड्र्यखगः': '🐦',
  'ड्र्यपुष्पम्': '🌸',
  'ड्र्यमेघः': '☁️',
  'ड्र्यतरुः': '🌳',
  'ड्र्यसरः': '🏞️',
  'ड्र्यगिरिः': '⛰️',
  'ड्र्यकमलम्': '🪷',
  'ढ्र्यपवनः': '💨',
  'ढ्र्यखगः': '🐦',
  'ढ्र्यपुष्पम्': '🌺',
  'ढ्र्यमेघः': '☁️',
  'ढ्र्यतरुः': '🌳',
  'ढ्र्यसरः': '🏞️',
  'ढ्र्यगिरिः': '⛰️',
  'ढ्र्यकमलम्': '🪷',
  'घ्र्या': '✨',
  'घ्र्यि': '🐦',
  'घ्र्यी': '✨',
  'घ्र्यु': '✨',
  'घ्र्यू': '✨',
  'घ्र्ये': '🌸',
  'घ्र्यै': '💨',
  'घ्र्यो': '✨',
  'घ्र्यौ': '✨',
  'झ्र्या': '✨',
  'झ्र्यि': '🐦',
  'झ्र्यी': '✨',
  'झ्र्यु': '✨',
  'झ्र्यू': '✨',
  'झ्र्ये': '🌸',
  'झ्र्यै': '💨',
  'झ्र्यो': '✨',
  'झ्र्यौ': '✨',
  'ट्र्या': '✨',
  'ट्र्यि': '🐦',
  'ट्र्यी': '✨',
  'ट्र्यु': '✨',
  'ट्र्यू': '✨',
  'ट्र्ये': '🌸',
  'ट्र्यै': '💨',
  'ट्र्यो': '✨',
  'ट्र्यौ': '✨',
  'ड्र्या': '✨',
  'ड्र्यि': '🐦',
  'ड्र्यी': '✨',
  'ड्र्यु': '✨',
  'ड्र्यू': '✨',
  'ड्र्ये': '🌸',
  'ड्र्यै': '💨',
  'ड्र्यो': '✨',
  'ड्र्यौ': '✨',
  'ढ्र्या': '✨',
  'ढ्र्यि': '🐦',
  'ढ्र्यी': '✨',
  'ढ्र्यु': '✨',
  'ढ्र्यू': '✨',
  'ढ्र्ये': '🌸',
  'ढ्र्यै': '💨',
  'ढ्र्यो': '✨',
  'ढ्र्यौ': '✨',
  'घ्र्युं': '👀',
  'घ्र्यैः': '💨',
  'झ्र्युं': '👀',
  'झ्र्यैः': '💨',
  'ट्र्युं': '👀',
  'ट्र्यैः': '💨',
  'ड्र्युं': '👀',
  'ड्र्यैः': '💨',
  'ढ्र्युं': '👀',
  'ढ्र्यैः': '💨',
  'ञ्यपवनः': '💨',
  'ञ्यखगः': '🐦',
  'ञ्यपुष्पम्': '🌸',
  'ञ्यमेघः': '☁️',
  'ञ्यतरुः': '🌳',
  'ञ्यसरः': '🏞️',
  'ञ्यगिरिः': '⛰️',
  'ञ्यकमलम्': '🪷',
  'छ्यपवनः': '💨',
  'छ्यखगः': '🐦',
  'छ्यपुष्पम्': '🌺',
  'छ्यमेघः': '☁️',
  'छ्यतरुः': '🌳',
  'छ्यसरः': '🏞️',
  'छ्यगिरिः': '⛰️',
  'छ्यकमलम्': '🪷',
  'ज्ज्यपवनः': '💨',
  'ज्ज्यखगः': '🐦',
  'ज्ज्यपुष्पम्': '🌼',
  'ज्ज्यमेघः': '☁️',
  'ज्ज्यतरुः': '🌳',
  'ज्ज्यसरः': '🏞️',
  'ज्ज्यगिरिः': '⛰️',
  'ज्ज्यकमलम्': '🪷',
  'ट्ट्यपवनः': '💨',
  'ट्ट्यखगः': '🐦',
  'ट्ट्यपुष्पम्': '🌸',
  'ट्ट्यमेघः': '☁️',
  'ट्ट्यतरुः': '🌳',
  'ट्ट्यसरः': '🏞️',
  'ट्ट्यगिरिः': '⛰️',
  'ट्ट्यकमलम्': '🪷',
  'ड्ड्यपवनः': '💨',
  'ड्ड्यखगः': '🐦',
  'ड्ड्यपुष्पम्': '🌺',
  'ड्ड्यमेघः': '☁️',
  'ड्ड्यतरुः': '🌳',
  'ड्ड्यसरः': '🏞️',
  'ड्ड्यगिरिः': '⛰️',
  'ड्ड्यकमलम्': '🪷',
  'ञ्या': '✨',
  'ञ्यि': '🐦',
  'ञ्यी': '✨',
  'ञ्यु': '✨',
  'ञ्यू': '✨',
  'ञ्ये': '🌸',
  'ञ्यै': '💨',
  'ञ्यो': '✨',
  'ञ्यौ': '✨',
  'छ्या': '✨',
  'छ्यि': '🐦',
  'छ्यी': '✨',
  'छ्यु': '✨',
  'छ्यू': '✨',
  'छ्ये': '🌸',
  'छ्यै': '💨',
  'छ्यो': '✨',
  'छ्यौ': '✨',
  'ज्ज्या': '✨',
  'ज्ज्यि': '🐦',
  'ज्ज्यी': '✨',
  'ज्ज्यु': '✨',
  'ज्ज्यू': '✨',
  'ज्ज्ये': '🌸',
  'ज्ज्यै': '💨',
  'ज्ज्यो': '✨',
  'ज्ज्यौ': '✨',
  'ट्ट्या': '✨',
  'ट्ट्यि': '🐦',
  'ट्ट्यी': '✨',
  'ट्ट्यु': '✨',
  'ट्ट्यू': '✨',
  'ट्ट्ये': '🌸',
  'ट्ट्यै': '💨',
  'ट्ट्यो': '✨',
  'ट्ट्यौ': '✨',
  'ड्ड्या': '✨',
  'ड्ड्यि': '🐦',
  'ड्ड्यी': '✨',
  'ड्ड्यु': '✨',
  'ड्ड्यू': '✨',
  'ड्ड्ये': '🌸',
  'ड्ड्यै': '💨',
  'ड्ड्यो': '✨',
  'ड्ड्यौ': '✨',
  'ञ्युं': '👀',
  'ञ्यैः': '💨',
  'छ्युं': '👀',
  'छ्यैः': '💨',
  'ज्ज्युं': '👀',
  'ज्ज्यैः': '💨',
  'ट्ट्युं': '👀',
  'ट्ट्यैः': '💨',
  'ड्ड्युं': '👀',
  'ड्ड्यैः': '💨',
  'ब्ब्यपवनः': '💨',
  'ब्ब्यखगः': '🐦',
  'ब्ब्यपुष्पम्': '🌸',
  'ब्ब्यमेघः': '☁️',
  'ब्ब्यतरुः': '🌳',
  'ब्ब्यसरः': '🏞️',
  'ब्ब्यगिरिः': '⛰️',
  'ब्ब्यकमलम्': '🪷',
  'ग्ग्यपवनः': '💨',
  'ग्ग्यखगः': '🐦',
  'ग्ग्यपुष्पम्': '🌺',
  'ग्ग्यमेघः': '☁️',
  'ग्ग्यतरुः': '🌳',
  'ग्ग्यसरः': '🏞️',
  'ग्ग्यगिरिः': '⛰️',
  'ग्ग्यकमलम्': '🪷',
  'क्क्यपवनः': '💨',
  'क्क्यखगः': '🐦',
  'क्क्यपुष्पम्': '🌼',
  'क्क्यमेघः': '☁️',
  'क्क्यतरुः': '🌳',
  'क्क्यसरः': '🏞️',
  'क्क्यगिरिः': '⛰️',
  'क्क्यकमलम्': '🪷',
  'प्प्यपवनः': '💨',
  'प्प्यखगः': '🐦',
  'प्प्यपुष्पम्': '🌸',
  'प्प्यमेघः': '☁️',
  'प्प्यतरुः': '🌳',
  'प्प्यसरः': '🏞️',
  'प्प्यगिरिः': '⛰️',
  'प्प्यकमलम्': '🪷',
  'च्च्यपवनः': '💨',
  'च्च्यखगः': '🐦',
  'च्च्यपुष्पम्': '🌺',
  'च्च्यमेघः': '☁️',
  'च्च्यतरुः': '🌳',
  'च्च्यसरः': '🏞️',
  'च्च्यगिरिः': '⛰️',
  'च्च्यकमलम्': '🪷',
  'ब्ब्या': '✨',
  'ब्ब्यि': '🐦',
  'ब्ब्यी': '✨',
  'ब्ब्यु': '✨',
  'ब्ब्यू': '✨',
  'ब्ब्ये': '🌸',
  'ब्ब्यै': '💨',
  'ब्ब्यो': '✨',
  'ब्ब्यौ': '✨',
  'ग्ग्या': '✨',
  'ग्ग्यि': '🐦',
  'ग्ग्यी': '✨',
  'ग्ग्यु': '✨',
  'ग्ग्यू': '✨',
  'ग्ग्ये': '🌸',
  'ग्ग्यै': '💨',
  'ग्ग्यो': '✨',
  'ग्ग्यौ': '✨',
  'क्क्या': '✨',
  'क्क्यि': '🐦',
  'क्क्यी': '✨',
  'क्क्यु': '✨',
  'क्क्यू': '✨',
  'क्क्ये': '🌸',
  'क्क्यै': '💨',
  'क्क्यो': '✨',
  'क्क्यौ': '✨',
  'प्प्या': '✨',
  'प्प्यि': '🐦',
  'प्प्यी': '✨',
  'प्प्यु': '✨',
  'प्प्यू': '✨',
  'प्प्ये': '🌸',
  'प्प्यै': '💨',
  'प्प्यो': '✨',
  'प्प्यौ': '✨',
  'च्च्या': '✨',
  'च्च्यि': '🐦',
  'च्च्यी': '✨',
  'च्च्यु': '✨',
  'च्च्यू': '✨',
  'च्च्ये': '🌸',
  'च्च्यै': '💨',
  'च्च्यो': '✨',
  'च्च्यौ': '✨',
  'ब्ब्युं': '👀',
  'ब्ब्यैः': '💨',
  'ग्ग्युं': '👀',
  'ग्ग्यैः': '💨',
  'क्क्युं': '👀',
  'क्क्यैः': '💨',
  'प्प्युं': '👀',
  'प्प्यैः': '💨',
  'च्च्युं': '👀',
  'च्च्यैः': '💨',
  'ल्ल्यपवनः': '💨',
  'ल्ल्यखगः': '🐦',
  'ल्ल्यपुष्पम्': '🌸',
  'ल्ल्यमेघः': '☁️',
  'ल्ल्यतरुः': '🌳',
  'ल्ल्यसरः': '🏞️',
  'ल्ल्यगिरिः': '⛰️',
  'ल्ल्यकमलम्': '🪷',
  'म्म्यपवनः': '💨',
  'म्म्यखगः': '🐦',
  'म्म्यपुष्पम्': '🌺',
  'म्म्यमेघः': '☁️',
  'म्म्यतरुः': '🌳',
  'म्म्यसरः': '🏞️',
  'म्म्यगिरिः': '⛰️',
  'म्म्यकमलम्': '🪷',
  'न्न्यपवनः': '💨',
  'न्न्यखगः': '🐦',
  'न्न्यपुष्पम्': '🌼',
  'न्न्यमेघः': '☁️',
  'न्न्यतरुः': '🌳',
  'न्न्यसरः': '🏞️',
  'न्न्यगिरिः': '⛰️',
  'न्न्यकमलम्': '🪷',
  'र्र्यपवनः': '💨',
  'र्र्यखगः': '🐦',
  'र्र्यपुष्पम्': '🌸',
  'र्र्यमेघः': '☁️',
  'र्र्यतरुः': '🌳',
  'र्र्यसरः': '🏞️',
  'र्र्यगिरिः': '⛰️',
  'र्र्यकमलम्': '🪷',
  'व्व्यपवनः': '💨',
  'व्व्यखगः': '🐦',
  'व्व्यपुष्पम्': '🌺',
  'व्व्यमेघः': '☁️',
  'व्व्यतरुः': '🌳',
  'व्व्यसरः': '🏞️',
  'व्व्यगिरिः': '⛰️',
  'व्व्यकमलम्': '🪷',
  'ल्ल्या': '✨',
  'ल्ल्यि': '🐦',
  'ल्ल्यी': '✨',
  'ल्ल्यु': '✨',
  'ल्ल्यू': '✨',
  'ल्ल्ये': '🌸',
  'ल्ल्यै': '💨',
  'ल्ल्यो': '✨',
  'ल्ल्यौ': '✨',
  'म्म्या': '✨',
  'म्म्यि': '🐦',
  'म्म्यी': '✨',
  'म्म्यु': '✨',
  'म्म्यू': '✨',
  'म्म्ये': '🌸',
  'म्म्यै': '💨',
  'म्म्यो': '✨',
  'म्म्यौ': '✨',
  'न्न्या': '✨',
  'न्न्यि': '🐦',
  'न्न्यी': '✨',
  'न्न्यु': '✨',
  'न्न्यू': '✨',
  'न्न्ये': '🌸',
  'न्न्यै': '💨',
  'न्न्यो': '✨',
  'न्न्यौ': '✨',
  'र्र्या': '✨',
  'र्र्यि': '🐦',
  'र्र्यी': '✨',
  'र्र्यु': '✨',
  'र्र्यू': '✨',
  'र्र्ये': '🌸',
  'र्र्यै': '💨',
  'र्र्यो': '✨',
  'र्र्यौ': '✨',
  'व्व्या': '✨',
  'व्व्यि': '🐦',
  'व्व्यी': '✨',
  'व्व्यु': '✨',
  'व्व्यू': '✨',
  'व्व्ये': '🌸',
  'व्व्यै': '💨',
  'व्व्यो': '✨',
  'व्व्यौ': '✨',
  'ल्ल्युं': '👀',
  'ल्ल्यैः': '💨',
  'म्म्युं': '👀',
  'म्म्यैः': '💨',
  'न्न्युं': '👀',
  'न्न्यैः': '💨',
  'र्र्युं': '👀',
  'र्र्यैः': '💨',
  'व्व्युं': '👀',
  'व्व्यैः': '💨',
  'स्क्यपवनः': '💨',
  'स्क्यखगः': '🐦',
  'स्क्यपुष्पम्': '🌸',
  'स्क्यमेघः': '☁️',
  'स्क्यतरुः': '🌳',
  'स्क्यसरः': '🏞️',
  'स्क्यगिरिः': '⛰️',
  'स्क्यकमलम्': '🪷',
  'स्प्यपवनः': '💨',
  'स्प्यखगः': '🐦',
  'स्प्यपुष्पम्': '🌺',
  'स्प्यमेघः': '☁️',
  'स्प्यतरुः': '🌳',
  'स्प्यसरः': '🏞️',
  'स्प्यगिरिः': '⛰️',
  'स्प्यकमलम्': '🪷',
  'स्थ्यपवनः': '💨',
  'स्थ्यखगः': '🐦',
  'स्थ्यपुष्पम्': '🌼',
  'स्थ्यमेघः': '☁️',
  'स्थ्यतरुः': '🌳',
  'स्थ्यसरः': '🏞️',
  'स्थ्यगिरिः': '⛰️',
  'स्थ्यकमलम्': '🪷',
  'श्च्यपवनः': '💨',
  'श्च्यखगः': '🐦',
  'श्च्यपुष्पम्': '🌸',
  'श्च्यमेघः': '☁️',
  'श्च्यतरुः': '🌳',
  'श्च्यसरः': '🏞️',
  'श्च्यगिरिः': '⛰️',
  'श्च्यकमलम्': '🪷',
  'श्क्यपवनः': '💨',
  'श्क्यखगः': '🐦',
  'श्क्यपुष्पम्': '🌺',
  'श्क्यमेघः': '☁️',
  'श्क्यतरुः': '🌳',
  'श्क्यसरः': '🏞️',
  'श्क्यगिरिः': '⛰️',
  'श्क्यकमलम्': '🪷',
  'स्क्या': '✨',
  'स्क्यि': '🐦',
  'स्क्यी': '✨',
  'स्क्यु': '✨',
  'स्क्यू': '✨',
  'स्क्ये': '🌸',
  'स्क्यै': '💨',
  'स्क्यो': '✨',
  'स्क्यौ': '✨',
  'स्प्या': '✨',
  'स्प्यि': '🐦',
  'स्प्यी': '✨',
  'स्प्यु': '✨',
  'स्प्यू': '✨',
  'स्प्ये': '🌸',
  'स्प्यै': '💨',
  'स्प्यो': '✨',
  'स्प्यौ': '✨',
  'स्थ्या': '✨',
  'स्थ्यि': '🐦',
  'स्थ्यी': '✨',
  'स्थ्यु': '✨',
  'स्थ्यू': '✨',
  'स्थ्ये': '🌸',
  'स्थ्यै': '💨',
  'स्थ्यो': '✨',
  'स्थ्यौ': '✨',
  'श्च्या': '✨',
  'श्च्यि': '🐦',
  'श्च्यी': '✨',
  'श्च्यु': '✨',
  'श्च्यू': '✨',
  'श्च्ये': '🌸',
  'श्च्यै': '💨',
  'श्च्यो': '✨',
  'श्च्यौ': '✨',
  'श्क्या': '✨',
  'श्क्यि': '🐦',
  'श्क्यी': '✨',
  'श्क्यु': '✨',
  'श्क्यू': '✨',
  'श्क्ये': '🌸',
  'श्क्यै': '💨',
  'श्क्यो': '✨',
  'श्क्यौ': '✨',
  'स्क्युं': '👀',
  'स्क्यैः': '💨',
  'स्प्युं': '👀',
  'स्प्यैः': '💨',
  'स्थ्युं': '👀',
  'स्थ्यैः': '💨',
  'श्च्युं': '👀',
  'श्च्यैः': '💨',
  'श्क्युं': '👀',
  'श्क्यैः': '💨',
  'यानम्': '🚗',
  'माया': '🪄',
  'व्यायामः': '🏃',
  'मयि': '🙋',
  'जयिन्': '🏆',
  'यायी': '🚶',
  'शायी': '🛏️',
  'युवकः': '👦',
  'युद्धम्': '⚔️',
  'आयुः': '⏳',
  'यूयम्': '👥',
  'यृ': '✨',
  'येन': '👉',
  'सत्येन': '✅',
  'नयैः': '🧭',
  'कवयैः': '📜',
  'योद्धा': '🛡️',
  'प्रयोगः': '🧪',
  'यौवनम्': '🌱',
  'यौगिकम्': '🧘',
  'स्वयं': '🪞',
  'उदयं': '🌅',
  'नयं': '🧭',
  'समयः': '⏰',
  'उदयः': '🌅',
  'विनयः': '🙇',
  'श्री': '✨',
  'तरी': '⛵',
  'रुचिः': '😋',
  'अरुणः': '🌄',
  'रूपम्': '🪞',
  'आरूढः': '🧗',
  'स्वरूपम्': '🪞',
  'रृ': '✨',
  'रेखा': '📏',
  'रैवतः': '👑',
  'रोदनम्': '😢',
  'विरोधः': '🚫',
  'रौद्रः': '😤',
  'नरं': '🧑',
  'शरं': '🏹',
  'स्वरं': '🎵',
  'सुरः': '🛕',
  'शाला': '🏫',
  'मलिनम्': '🧽',
  'लिखितम्': '✍️',
  'काली': '🌑',
  'पाली': '📚',
  'लुब्धः': '🤑',
  'लुप्तम्': '🫥',
  'लुलायः': '🐃',
  'लेपः': '🧴',
  'कलैः': '🎨',
  'लोहः': '⚙️',
  'लौकिकः': '🌍',
  'लौहम्': '⚙️',
  'फलं': '🍎',
  'बलं': '💪',
  'मलं': '🫧',
  'कालः': '⏰',
  'नलः': '👑',
  'कविः': '📝',
  'वीरः': '🦸',
  'वीणा': '🪕',
  'वीचिः': '🌊',
  'वु': '✨',
  'वू': '✨',
  'वृद्धः': '👴',
  'वेला': '🏖️',
  'वैराग्यम्': '🕊️',
  'वैभवम्': '💎',
  'वो': '✨',
  'वौ': '✨',
  'एवं': '👆',
  'नवं': '🆕',
  'सर्वं': '🌐',
  'भवः': '🌱',
  'जीवः': '❤️',
  'ल्क्या': '✨',
  'ल्क्यि': '🐦',
  'ल्क्यी': '✨',
  'ल्क्यु': '✨',
  'ल्क्यू': '✨',
  'ल्क्ये': '🌸',
  'ल्क्यै': '💨',
  'ल्क्यो': '✨',
  'ल्क्यौ': '✨',
  'न्द्या': '✨',
  'न्द्यि': '🐦',
  'न्द्यी': '✨',
  'न्द्यु': '✨',
  'न्द्यू': '✨',
  'न्द्ये': '🌸',
  'न्द्यै': '💨',
  'न्द्यो': '✨',
  'न्द्यौ': '✨',
  'न्ध्या': '✨',
  'न्ध्यि': '🐦',
  'न्ध्यी': '✨',
  'न्ध्यु': '✨',
  'न्ध्यू': '✨',
  'न्ध्ये': '🌸',
  'न्ध्यै': '💨',
  'न्ध्यो': '✨',
  'न्ध्यौ': '✨',
  'ङ्घ्या': '✨',
  'ङ्घ्यि': '🐦',
  'ङ्घ्यी': '✨',
  'ङ्घ्यु': '✨',
  'ङ्घ्यू': '✨',
  'ङ्घ्ये': '🌸',
  'ङ्घ्यै': '💨',
  'ङ्घ्यो': '✨',
  'ङ्घ्यौ': '✨',
  'त्क्या': '✨',
  'त्क्यि': '🐦',
  'त्क्यी': '✨',
  'त्क्यु': '✨',
  'त्क्यू': '✨',
  'त्क्ये': '🌸',
  'त्क्यै': '💨',
  'त्क्यो': '✨',
  'त्क्यौ': '✨',
  'त्प्या': '✨',
  'त्प्यि': '🐦',
  'त्प्यी': '✨',
  'त्प्यु': '✨',
  'त्प्यू': '✨',
  'त्प्ये': '🌸',
  'त्प्यै': '💨',
  'त्प्यो': '✨',
  'त्प्यौ': '✨',
  'त्म्या': '✨',
  'त्म्यि': '🐦',
  'त्म्यी': '✨',
  'त्म्यु': '✨',
  'त्म्यू': '✨',
  'त्म्ये': '🌸',
  'त्म्यै': '💨',
  'त्म्यो': '✨',
  'त्म्यौ': '✨',
  'द्ग्या': '✨',
  'द्ग्यि': '🐦',
  'द्ग्यी': '✨',
  'द्ग्यु': '✨',
  'द्ग्यू': '✨',
  'द्ग्ये': '🌸',
  'द्ग्यै': '💨',
  'द्ग्यो': '✨',
  'द्ग्यौ': '✨',
  'द्ब्या': '✨',
  'द्ब्यि': '🐦',
  'द्ब्यी': '✨',
  'द्ब्यु': '✨',
  'द्ब्यू': '✨',
  'द्ब्ये': '🌸',
  'द्ब्यै': '💨',
  'द्ब्यो': '✨',
  'द्ब्यौ': '✨',
  'ह्न्या': '✨',
  'ह्न्यि': '🐦',
  'ह्न्यी': '✨',
  'ह्न्यु': '✨',
  'ह्न्यू': '✨',
  'ह्न्ये': '🌸',
  'ह्न्यै': '💨',
  'ह्न्यो': '✨',
  'ह्न्यौ': '✨',
  'वल्क्यतरुः': '🌳',
  'वल्क्यपवनः': '💨',
  'वल्क्यखगः': '🐦',
  'वल्क्यपुष्पम्': '🌺',
  'वल्क्यमेघः': '☁️',
  'वल्क्यसरः': '🏞️',
  'वल्क्यगिरिः': '⛰️',
  'नद्यपवनः': '💨',
  'नद्यसरः': '🏞️',
  'नद्यमेघः': '☁️',
  'नद्यतरुः': '🌳',
  'नद्यकमलम्': '🪷',
  'नद्यखगः': '🐦',
  'नद्यगिरिः': '⛰️',
  'सन्ध्यामेघः': '☁️',
  'सन्ध्यापवनः': '💨',
  'सन्ध्याखगः': '🐦',
  'सन्ध्याकमलम्': '🪷',
  'विन्ध्यतरुः': '🌳',
  'विन्ध्यसिंहः': '🦁',
  'सन्ध्यासरः': '🏞️',
  'अलङ्घ्यगिरिः': '⛰️',
  'अलङ्घ्यसरः': '🏞️',
  'अलङ्घ्यवनम्': '🌲',
  'लङ्घ्यतरुः': '🌳',
  'लङ्घ्यमार्गः': '🌿',
  'अलङ्घ्यमेघः': '☁️',
  'अलङ्घ्यसिंहः': '🦁',
  'शरत्क्यमेघः': '☁️',
  'शरत्क्यपुष्पम्': '🌺',
  'शरत्क्यपवनः': '💨',
  'शरत्क्यकमलम्': '🪷',
  'शरत्क्यसरः': '🏞️',
  'शरत्क्यखगः': '🐦',
  'शरत्क्यतरुः': '🌳',
  'जगत्प्यापवनः': '💨',
  'जगत्प्यामेघः': '☁️',
  'जगत्प्यासरः': '🏞️',
  'जगत्प्यातरुः': '🌳',
  'जगत्प्याकमलम्': '🪷',
  'जगत्प्याखगः': '🐦',
  'जगत्प्यागिरिः': '⛰️',
  'महात्म्यतरुः': '🌳',
  'महात्म्यपवनः': '💨',
  'महात्म्यखगः': '🐦',
  'महात्म्यमेघः': '☁️',
  'महात्म्यकमलम्': '🪷',
  'महात्म्यसरः': '🏞️',
  'महात्म्यगिरिः': '⛰️',
  'मुद्ग्यतरुः': '🌳',
  'मुद्ग्यपुष्पम्': '🌺',
  'मुद्ग्यकमलम्': '🪷',
  'मुद्ग्यसरः': '🏞️',
  'मुद्ग्यखगः': '🐦',
  'मुद्ग्यपवनः': '💨',
  'मुद्ग्यमेघः': '☁️',
  'उद्ब्यथपवनः': '💨',
  'उद्ब्यथतरुः': '🌳',
  'उद्ब्यथखगः': '🐦',
  'उद्ब्यथमेघः': '☁️',
  'उद्ब्यथसरः': '🏞️',
  'उद्ब्यथगिरिः': '⛰️',
  'उद्ब्यथकमलम्': '🪷',
  'वाह्न्यगिरिः': '⛰️',
  'वाह्न्यपवनः': '💨',
  'वाह्न्यमेघः': '☁️',
  'वाह्न्यतरुः': '🌳',
  'वाह्न्यसरः': '🏞️',
  'वाह्न्यखगः': '🐦',
  'वाह्न्यपुष्पम्': '🌺',
  'ह्म्या': '✨',
  'ह्म्यि': '🐦',
  'ह्म्यी': '✨',
  'ह्म्यु': '✨',
  'ह्म्यू': '✨',
  'ह्म्ये': '🌸',
  'ह्म्यै': '💨',
  'ह्म्यो': '✨',
  'ह्म्यौ': '✨',
  'म्प्या': '✨',
  'म्प्यि': '🐦',
  'म्प्यी': '✨',
  'म्प्यु': '✨',
  'म्प्यू': '✨',
  'म्प्ये': '🌸',
  'म्प्यै': '💨',
  'म्प्यो': '✨',
  'म्प्यौ': '✨',
  'म्ब्या': '✨',
  'म्ब्यि': '🐦',
  'म्ब्यी': '✨',
  'म्ब्यु': '✨',
  'म्ब्यू': '✨',
  'म्ब्ये': '🌸',
  'म्ब्यै': '💨',
  'म्ब्यो': '✨',
  'म्ब्यौ': '✨',
  'त्स्या': '✨',
  'त्स्यि': '🐦',
  'त्स्यी': '✨',
  'त्स्यु': '✨',
  'त्स्यू': '✨',
  'त्स्ये': '🌸',
  'त्स्यै': '💨',
  'त्स्यो': '✨',
  'त्स्यौ': '✨',
  'द्स्या': '✨',
  'द्स्यि': '🐦',
  'द्स्यी': '✨',
  'द्स्यु': '✨',
  'द्स्यू': '✨',
  'द्स्ये': '🌸',
  'द्स्यै': '💨',
  'द्स्यो': '✨',
  'द्स्यौ': '✨',
  'ब्राह्म्यपवनः': '💨',
  'ब्राह्म्यमेघः': '☁️',
  'ब्राह्म्यसरः': '🏞️',
  'ब्राह्म्यतरुः': '🌳',
  'ब्राह्म्यकमलम्': '🪷',
  'ब्राह्म्यखगः': '🐦',
  'ब्राह्म्यगिरिः': '⛰️',
  'कम्प्यतरुः': '🌳',
  'कम्प्यपवनः': '💨',
  'कम्प्यखगः': '🐦',
  'कम्प्यमेघः': '☁️',
  'कम्प्यकमलम्': '🪷',
  'कम्प्यसरः': '🏞️',
  'कम्प्यगिरिः': '⛰️',
  'चुम्ब्यपवनः': '💨',
  'चुम्ब्यपुष्पम्': '🌺',
  'चुम्ब्यकमलम्': '🪷',
  'चुम्ब्यसरः': '🏞️',
  'चुम्ब्यखगः': '🐦',
  'चुम्ब्यतरुः': '🌳',
  'चुम्ब्यमेघः': '☁️',
  'मत्स्यसरः': '🏞️',
  'मत्स्यखगः': '🐦',
  'मत्स्यकमलम्': '🪷',
  'मत्स्यपवनः': '💨',
  'मत्स्यतरुः': '🌳',
  'मत्स्यमेघः': '☁️',
  'मत्स्यगिरिः': '⛰️',
  'विशद्स्यमेघः': '☁️',
  'विशद्स्यपुष्पम्': '🌺',
  'विशद्स्यपवनः': '💨',
  'विशद्स्यकमलम्': '🪷',
  'विशद्स्यसरः': '🏞️',
  'विशद्स्यखगः': '🐦',
  'विशद्स्यतरुः': '🌳',
  'ष्व्या': '✨',
  'ष्व्यि': '🐦',
  'ष्व्यी': '✨',
  'ष्व्यु': '✨',
  'ष्व्यू': '✨',
  'ष्व्ये': '🌸',
  'ष्व्यै': '💨',
  'ष्व्यो': '✨',
  'ष्व्यौ': '✨',
  'श्व्या': '✨',
  'श्व्यि': '🐦',
  'श्व्यी': '✨',
  'श्व्यु': '✨',
  'श्व्यू': '✨',
  'श्व्ये': '🌸',
  'श्व्यै': '💨',
  'श्व्यो': '✨',
  'श्व्यौ': '✨',
  'ल्ग्या': '✨',
  'ल्ग्यि': '🐦',
  'ल्ग्यी': '✨',
  'ल्ग्यु': '✨',
  'ल्ग्यू': '✨',
  'ल्ग्ये': '🌸',
  'ल्ग्यै': '💨',
  'ल्ग्यो': '✨',
  'ल्ग्यौ': '✨',
  'ल्म्या': '✨',
  'ल्म्यि': '🐦',
  'ल्म्यी': '✨',
  'ल्म्यु': '✨',
  'ल्म्यू': '✨',
  'ल्म्ये': '🌸',
  'ल्म्यै': '💨',
  'ल्म्यो': '✨',
  'ल्म्यौ': '✨',
  'प्रह्ल्यपवनः': '💨',
  'प्रह्ल्यसरः': '🏞️',
  'प्रह्ल्यमेघः': '☁️',
  'प्रह्ल्यतरुः': '🌳',
  'प्रह्ल्यकमलम्': '🪷',
  'प्रह्ल्यखगः': '🐦',
  'प्रह्ल्यगिरिः': '⛰️',
  'धनुष्व्यमेघः': '☁️',
  'धनुष्व्यपुष्पम्': '🌺',
  'धनुष्व्यपवनः': '💨',
  'धनुष्व्यसरः': '🏞️',
  'धनुष्व्यतरुः': '🌳',
  'धनुष्व्यखगः': '🐦',
  'धनुष्व्यकमलम्': '🪷',
  'अश्व्यपवनः': '💨',
  'अश्व्यमेघः': '☁️',
  'अश्व्यसरः': '🏞️',
  'अश्व्यतरुः': '🌳',
  'अश्व्यखगः': '🐦',
  'अश्व्यसिंहः': '🦁',
  'अश्व्यपुष्पम्': '🌺',
  'वल्ग्यखगः': '🐦',
  'वल्ग्यसिंहः': '🦁',
  'वल्ग्यपवनः': '💨',
  'वल्ग्यतरुः': '🌳',
  'वल्ग्यसरः': '🏞️',
  'वल्ग्यपुष्पम्': '🌺',
  'वल्ग्यमेघः': '☁️',
  'गुल्म्यतरुः': '🌳',
  'गुल्म्यपुष्पम्': '🌺',
  'गुल्म्यसरः': '🏞️',
  'गुल्म्यखगः': '🐦',
  'गुल्म्यपवनः': '💨',
  'गुल्म्यकमलम्': '🪷',
  'गुल्म्यगिरिः': '⛰️',
  'र्क्या': '✨',
  'र्क्यि': '🐦',
  'र्क्यी': '✨',
  'र्क्यु': '✨',
  'र्क्यू': '✨',
  'र्क्ये': '🌸',
  'र्क्यै': '💨',
  'र्क्यो': '✨',
  'र्क्यौ': '✨',
  'र्प्या': '✨',
  'र्प्यि': '🐦',
  'र्प्यी': '✨',
  'र्प्यु': '✨',
  'र्प्यू': '✨',
  'र्प्ये': '🌸',
  'र्प्यै': '💨',
  'र्प्यो': '✨',
  'र्प्यौ': '✨',
  'र्त्या': '✨',
  'र्त्यि': '🐦',
  'र्त्यी': '✨',
  'र्त्यु': '✨',
  'र्त्यू': '✨',
  'र्त्ये': '🌸',
  'र्त्यै': '💨',
  'र्त्यो': '✨',
  'र्त्यौ': '✨',
  'र्ध्या': '✨',
  'र्ध्यि': '🐦',
  'र्ध्यी': '✨',
  'र्ध्यु': '✨',
  'र्ध्यू': '✨',
  'र्ध्ये': '🌸',
  'र्ध्यै': '💨',
  'र्ध्यो': '✨',
  'र्ध्यौ': '✨',
  'न्ज्या': '✨',
  'न्ज्यि': '🐦',
  'न्ज्यी': '✨',
  'न्ज्यु': '✨',
  'न्ज्यू': '✨',
  'न्ज्ये': '🌸',
  'न्ज्यै': '💨',
  'न्ज्यो': '✨',
  'न्ज्यौ': '✨',
  'अर्क्यपवनः': '💨',
  'अर्क्यमेघः': '☁️',
  'अर्क्यतरुः': '🌳',
  'अर्क्यपुष्पम्': '🌺',
  'अर्क्यसरः': '🏞️',
  'अर्क्यखगः': '🐦',
  'अर्क्यगिरिः': '⛰️',
  'सर्प्यसरः': '🏞️',
  'सर्प्यपवनः': '💨',
  'सर्प्यतरुः': '🌳',
  'सर्प्यखगः': '🐦',
  'सर्प्यमेघः': '☁️',
  'सर्प्यपुष्पम्': '🌺',
  'सर्प्यगिरिः': '⛰️',
  'मर्त्यतरुः': '🌳',
  'मर्त्यपवनः': '💨',
  'मर्त्यखगः': '🐦',
  'मर्त्यमेघः': '☁️',
  'मर्त्यकमलम्': '🪷',
  'मर्त्यसरः': '🏞️',
  'मर्त्यगिरिः': '⛰️',
  'वर्ध्यतरुः': '🌳',
  'वर्ध्यपुष्पम्': '🌺',
  'वर्ध्यकमलम्': '🪷',
  'वर्ध्यसरः': '🏞️',
  'वर्ध्यखगः': '🐦',
  'वर्ध्यपवनः': '💨',
  'वर्ध्यमेघः': '☁️',
  'रञ्ज्यपुष्पम्': '🌺',
  'रञ्ज्यकमलम्': '🪷',
  'रञ्ज्यपवनः': '💨',
  'रञ्ज्यमेघः': '☁️',
  'रञ्ज्यसरः': '🏞️',
  'रञ्ज्यखगः': '🐦',
  'रञ्ज्यतरुः': '🌳',
  'र्व्या': '✨',
  'र्व्यि': '🐦',
  'र्व्यी': '✨',
  'र्व्यु': '✨',
  'र्व्यू': '✨',
  'र्व्ये': '🌸',
  'र्व्यै': '💨',
  'र्व्यो': '✨',
  'र्व्यौ': '✨',
  'र्भ्या': '✨',
  'र्भ्यि': '🐦',
  'र्भ्यी': '✨',
  'र्भ्यु': '✨',
  'र्भ्यू': '✨',
  'र्भ्ये': '🌸',
  'र्भ्यै': '💨',
  'र्भ्यो': '✨',
  'र्भ्यौ': '✨',
  'र्ग्या': '✨',
  'र्ग्यि': '🐦',
  'र्ग्यी': '✨',
  'र्ग्यु': '✨',
  'र्ग्यू': '✨',
  'र्ग्ये': '🌸',
  'र्ग्यै': '💨',
  'र्ग्यो': '✨',
  'र्ग्यौ': '✨',
  'र्म्या': '✨',
  'र्म्यि': '🐦',
  'र्म्यी': '✨',
  'र्म्यु': '✨',
  'र्म्यू': '✨',
  'र्म्ये': '🌸',
  'र्म्यै': '💨',
  'र्म्यो': '✨',
  'र्म्यौ': '✨',
  'न्ब्या': '✨',
  'न्ब्यि': '🐦',
  'न्ब्यी': '✨',
  'न्ब्यु': '✨',
  'न्ब्यू': '✨',
  'न्ब्ये': '🌸',
  'न्ब्यै': '💨',
  'न्ब्यो': '✨',
  'न्ब्यौ': '✨',
  'तान्ब्यथयति': '💨',
  'पूर्व्यतरुः': '🌳',
  'पूर्व्यपवनः': '💨',
  'पूर्व्यखगः': '🐦',
  'पूर्व्यमेघः': '☁️',
  'पूर्व्यकमलम्': '🪷',
  'पूर्व्यसरः': '🏞️',
  'पूर्व्यगिरिः': '⛰️',
  'गर्भ्यसरः': '🏞️',
  'गर्भ्यतरुः': '🌳',
  'गर्भ्यपुष्पम्': '🌺',
  'गर्भ्यकमलम्': '🪷',
  'गर्भ्यखगः': '🐦',
  'गर्भ्यपवनः': '💨',
  'गर्भ्यमेघः': '☁️',
  'वर्ग्यतरुः': '🌳',
  'वर्ग्यपुष्पम्': '🌺',
  'वर्ग्यकमलम्': '🪷',
  'वर्ग्यखगः': '🐦',
  'वर्ग्यपवनः': '💨',
  'वर्ग्यमेघः': '☁️',
  'वर्ग्यगिरिः': '⛰️',
  'हर्म्यतरुः': '🌳',
  'हर्म्यपवनः': '💨',
  'हर्म्यखगः': '🐦',
  'हर्म्यकमलम्': '🪷',
  'हर्म्यसरः': '🏞️',
  'हर्म्यमेघः': '☁️',
  'हर्म्यपुष्पम्': '🌺',
  'र्ज्या': '✨',
  'र्ज्यि': '✨',
  'र्ज्यी': '✨',
  'र्ज्यु': '✨',
  'र्ज्यू': '✨',
  'र्ज्ये': '✨',
  'र्ज्यै': '✨',
  'र्ज्यो': '✨',
  'र्ज्यौ': '✨',
  'र्च्या': '✨',
  'र्च्यि': '✨',
  'र्च्यी': '✨',
  'र्च्यु': '✨',
  'र्च्यू': '✨',
  'र्च्ये': '✨',
  'र्च्यै': '✨',
  'र्च्यो': '✨',
  'र्च्यौ': '✨',
  'र्ष्या': '✨',
  'र्ष्यि': '✨',
  'र्ष्यी': '✨',
  'र्ष्यु': '✨',
  'र्ष्यू': '✨',
  'र्ष्ये': '✨',
  'र्ष्यै': '✨',
  'र्ष्यो': '✨',
  'र्ष्यौ': '✨',
  'र्ह्या': '✨',
  'र्ह्यि': '✨',
  'र्ह्यी': '✨',
  'र्ह्यु': '✨',
  'र्ह्यू': '✨',
  'र्ह्ये': '✨',
  'र्ह्यै': '✨',
  'र्ह्यो': '✨',
  'र्ह्यौ': '✨',
  'द्म्या': '✨',
  'द्म्यि': '✨',
  'द्म्यी': '✨',
  'द्म्यु': '✨',
  'द्म्यू': '✨',
  'द्म्ये': '✨',
  'द्म्यै': '✨',
  'द्म्यो': '✨',
  'द्म्यौ': '✨',
  'ङ्क्या': '✨',
  'ङ्क्यि': '✨',
  'ङ्क्यी': '✨',
  'ङ्क्यु': '✨',
  'ङ्क्यू': '✨',
  'ङ्क्ये': '✨',
  'ङ्क्यै': '✨',
  'ङ्क्यो': '✨',
  'ङ्क्यौ': '✨',
  'ब्ज्या': '✨',
  'ब्ज्यि': '✨',
  'ब्ज्यी': '✨',
  'ब्ज्यु': '✨',
  'ब्ज्यू': '✨',
  'ब्ज्ये': '✨',
  'ब्ज्यै': '✨',
  'ब्ज्यो': '✨',
  'ब्ज्यौ': '✨',
  'क्ष्म्या': '✨',
  'क्ष्म्यि': '✨',
  'क्ष्म्यी': '✨',
  'क्ष्म्यु': '✨',
  'क्ष्म्यू': '✨',
  'क्ष्म्ये': '✨',
  'क्ष्म्यै': '✨',
  'क्ष्म्यो': '✨',
  'क्ष्म्यौ': '✨',
  'क्व्या': '✨',
  'क्व्यि': '✨',
  'क्व्यी': '✨',
  'क्व्यु': '✨',
  'क्व्यू': '✨',
  'क्व्ये': '✨',
  'क्व्यै': '✨',
  'क्व्यो': '✨',
  'क्व्यौ': '✨',
  'ङ्ग्या': '✨',
  'ङ्ग्यि': '✨',
  'ङ्ग्यी': '✨',
  'ङ्ग्यु': '✨',
  'ङ्ग्यू': '✨',
  'ङ्ग्ये': '✨',
  'ङ्ग्यै': '✨',
  'ङ्ग्यो': '✨',
  'ङ्ग्यौ': '✨',
  'ऊर्ज्यपवनः': '💨',
  'ऊर्ज्यमेघः': '☁️',
  'ऊर्ज्यसरः': '🏞️',
  'ऊर्ज्यतरुः': '🌳',
  'ऊर्ज्यखगः': '🐦',
  'ऊर्ज्यसिंहः': '🦁',
  'ऊर्ज्यगिरिः': '⛰️',
  'अर्च्यपुष्पम्': '🌺',
  'अर्च्यकमलम्': '🪷',
  'अर्च्यतरुः': '🌳',
  'अर्च्यपवनः': '💨',
  'अर्च्यसरः': '🏞️',
  'अर्च्यखगः': '🐦',
  'अर्च्यमेघः': '☁️',
  'वर्ष्यमेघः': '☁️',
  'वर्ष्यपवनः': '💨',
  'वर्ष्यसरः': '🏞️',
  'वर्ष्यतरुः': '🌳',
  'वर्ष्यपुष्पम्': '🌺',
  'वर्ष्यखगः': '🐦',
  'वर्ष्यगिरिः': '⛰️',
  'अर्ह्यसरः': '🏞️',
  'अर्ह्यपवनः': '💨',
  'अर्ह्यतरुः': '🌳',
  'अर्ह्यपुष्पम्': '🌺',
  'अर्ह्यकमलम्': '🪷',
  'अर्ह्यखगः': '🐦',
  'अर्ह्यमेघः': '☁️',
  'पद्म्यपुष्पम्': '🌺',
  'पद्म्यसरः': '🏞️',
  'पद्म्यतरुः': '🌳',
  'पद्म्यखगः': '🐦',
  'पद्म्यपवनः': '💨',
  'पद्म्यमेघः': '☁️',
  'पद्म्यगिरिः': '⛰️',
  'पङ्क्यकमलम्': '🪷',
  'पङ्क्यसरः': '🏞️',
  'पङ्क्यतरुः': '🌳',
  'पङ्क्यखगः': '🐦',
  'पङ्क्यपुष्पम्': '🌺',
  'पङ्क्यपवनः': '💨',
  'पङ्क्यमेघः': '☁️',
  'अब्ज्यसरः': '🏞️',
  'अब्ज्यकमलम्': '🪷',
  'अब्ज्यपुष्पम्': '🌺',
  'अब्ज्यखगः': '🐦',
  'अब्ज्यतरुः': '🌳',
  'अब्ज्यपवनः': '💨',
  'अब्ज्यमेघः': '☁️',
  'लक्ष्म्यतरुः': '🌳',
  'लक्ष्म्यपुष्पम्': '🌺',
  'लक्ष्म्यकमलम्': '🪷',
  'लक्ष्म्यसरः': '🏞️',
  'लक्ष्म्यखगः': '🐦',
  'लक्ष्म्यपवनः': '💨',
  'लक्ष्म्यगिरिः': '⛰️',
  'पक्व्यफले': '🍎',
  'पक्व्यतरुः': '🌳',
  'पक्व्यपुष्पम्': '🌺',
  'पक्व्यकमलम्': '🪷',
  'पक्व्यखगः': '🐦',
  'पक्व्यपवनः': '💨',
  'पक्व्यसरः': '🏞️',
  'सङ्ग्यतरुः': '🌳',
  'सङ्ग्यपुष्पम्': '🌺',
  'सङ्ग्यकमलम्': '🪷',
  'सङ्ग्यखगः': '🐦',
  'सङ्ग्यपवनः': '💨',
  'सङ्ग्यमेघः': '☁️',
  'सङ्ग्यगिरिः': '⛰️',
  'ग्म्या': '✨',
  'ग्म्यि': '✨',
  'ग्म्यी': '✨',
  'ग्म्यु': '✨',
  'ग्म्यू': '✨',
  'ग्म्ये': '✨',
  'ग्म्यै': '✨',
  'ग्म्यो': '✨',
  'ग्म्यौ': '✨',
  'ष्म्या': '✨',
  'ष्म्यि': '✨',
  'ष्म्यी': '✨',
  'ष्म्यु': '✨',
  'ष्म्यू': '✨',
  'ष्म्ये': '✨',
  'ष्म्यै': '✨',
  'ष्म्यो': '✨',
  'ष्म्यौ': '✨',
  'ब्ध्या': '✨',
  'ब्ध्यि': '✨',
  'ब्ध्यी': '✨',
  'ब्ध्यु': '✨',
  'ब्ध्यू': '✨',
  'ब्ध्ये': '✨',
  'ब्ध्यै': '✨',
  'ब्ध्यो': '✨',
  'ब्ध्यौ': '✨',
  'ष्प्या': '✨',
  'ष्प्यि': '✨',
  'ष्प्यी': '✨',
  'ष्प्यु': '✨',
  'ष्प्यू': '✨',
  'ष्प्ये': '✨',
  'ष्प्यै': '✨',
  'ष्प्यो': '✨',
  'ष्प्यौ': '✨',
  'त्त्या': '✨',
  'त्त्यि': '✨',
  'त्त्यी': '✨',
  'त्त्यु': '✨',
  'त्त्यू': '✨',
  'त्त्ये': '✨',
  'त्त्यै': '✨',
  'त्त्यो': '✨',
  'त्त्यौ': '✨',
  'युग्म्यतरुः': '🌳',
  'युग्म्यपुष्पम्': '🌺',
  'युग्म्यकमलम्': '🪷',
  'युग्म्यखगः': '🐦',
  'युग्म्यपवनः': '💨',
  'युग्म्यसरः': '🏞️',
  'युग्म्यगिरिः': '⛰️',
  'शुष्म्यपवनः': '💨',
  'शुष्म्यमेघः': '☁️',
  'शुष्म्यतरुः': '🌳',
  'शुष्म्यगिरिः': '⛰️',
  'शुष्म्यमार्गः': '🛤️',
  'शुष्म्यसरः': '🏞️',
  'शुष्म्यवनम्': '🌲',
  'लब्ध्यगिरिः': '⛰️',
  'लब्ध्यसरः': '🏞️',
  'लब्ध्यतरुः': '🌳',
  'लब्ध्यखगः': '🐦',
  'लब्ध्यपुष्पम्': '🌺',
  'लब्ध्यपवनः': '💨',
  'लब्ध्यमेघः': '☁️',
  'पुष्प्यतरुः': '🌳',
  'पुष्प्यपुष्पम्': '🌺',
  'पुष्प्यकमलम्': '🪷',
  'पुष्प्यसरः': '🏞️',
  'पुष्प्यखगः': '🐦',
  'पुष्प्यपवनः': '💨',
  'पुष्प्यमेघः': '☁️',
  'सत्त्यतरुः': '🌳',
  'सत्त्यपुष्पम्': '🌺',
  'सत्त्यकमलम्': '🪷',
  'सत्त्यसरः': '🏞️',
  'सत्त्यखगः': '🐦',
  'सत्त्यपवनः': '💨',
  'सत्त्यमेघः': '☁️',
  'र्ल्या': '✨',
  'र्ल्यि': '✨',
  'र्ल्यी': '✨',
  'र्ल्यु': '✨',
  'र्ल्यू': '✨',
  'र्ल्ये': '✨',
  'र्ल्यै': '✨',
  'र्ल्यो': '✨',
  'र्ल्यौ': '✨',
  'द्द्या': '✨',
  'द्द्यि': '✨',
  'द्द्यी': '✨',
  'द्द्यु': '✨',
  'द्द्यू': '✨',
  'द्द्ये': '✨',
  'द्द्यै': '✨',
  'द्द्यो': '✨',
  'द्द्यौ': '✨',
  'द्भ्या': '✨',
  'द्भ्यि': '✨',
  'द्भ्यी': '✨',
  'द्भ्यु': '✨',
  'द्भ्यू': '✨',
  'द्भ्ये': '✨',
  'द्भ्यै': '✨',
  'द्भ्यो': '✨',
  'द्भ्यौ': '✨',
  'ठ्ठ्या': '✨',
  'ठ्ठ्यि': '✨',
  'ठ्ठ्यी': '✨',
  'ठ्ठ्यु': '✨',
  'ठ्ठ्यू': '✨',
  'ठ्ठ्ये': '✨',
  'ठ्ठ्यै': '✨',
  'ठ्ठ्यो': '✨',
  'ठ्ठ्यौ': '✨',
  'ड्ढ्या': '✨',
  'ड्ढ्यि': '✨',
  'ड्ढ्यी': '✨',
  'ड्ढ्यु': '✨',
  'ड्ढ्यू': '✨',
  'ड्ढ्ये': '✨',
  'ड्ढ्यै': '✨',
  'ड्ढ्यो': '✨',
  'ड्ढ्यौ': '✨',
  'आर्ल्यपवनः': '💨',
  'आर्ल्यतरुः': '🌳',
  'आर्ल्यखगः': '🐦',
  'आर्ल्यपुष्पम्': '🌺',
  'आर्ल्यकमलम्': '🪷',
  'आर्ल्यसरः': '🏞️',
  'आर्ल्यमेघः': '☁️',
  'उद्द्यसूर्यः': '☀️',
  'उद्द्यमेघः': '☁️',
  'उद्द्यपवनः': '💨',
  'उद्द्यसरः': '🏞️',
  'उद्द्यतरुः': '🌳',
  'उद्द्यखगः': '🐦',
  'उद्द्यकमलम्': '🪷',
  'उद्भ्यखगः': '🐦',
  'उद्भ्यमेघः': '☁️',
  'उद्भ्यपवनः': '💨',
  'उद्भ्यतरुः': '🌳',
  'उद्भ्यपुष्पम्': '🌺',
  'उद्भ्यसरः': '🏞️',
  'उद्भ्यगिरिः': '⛰️',
  'मठ्ठ्यपवनः': '💨',
  'मठ्ठ्यतरुः': '🌳',
  'मठ्ठ्यखगः': '🐦',
  'मठ्ठ्यसरः': '🏞️',
  'मठ्ठ्यपुष्पम्': '🌺',
  'मठ्ठ्यकमलम्': '🪷',
  'मठ्ठ्यमेघः': '☁️',
  'गूड्ढ्यवनम्': '🌲',
  'गूड्ढ्यसरः': '🏞️',
  'गूड्ढ्यमार्गः': '🛤️',
  'गूड्ढ्यतरुः': '🌳',
  'गूड्ढ्यपुष्पम्': '🌺',
  'गूड्ढ्यपवनः': '💨',
  'गूड्ढ्यमेघः': '☁️',
  'ट्ठ्या': '✨',
  'ट्ठ्यि': '✨',
  'ट्ठ्यी': '✨',
  'ट्ठ्यु': '✨',
  'ट्ठ्यू': '✨',
  'ट्ठ्ये': '✨',
  'ट्ठ्यै': '✨',
  'ट्ठ्यो': '✨',
  'ट्ठ्यौ': '✨',
  'त्थ्या': '✨',
  'त्थ्यि': '✨',
  'त्थ्यी': '✨',
  'त्थ्यु': '✨',
  'त्थ्यू': '✨',
  'त्थ्ये': '✨',
  'त्थ्यै': '✨',
  'त्थ्यो': '✨',
  'त्थ्यौ': '✨',
  'ञ्ज्या': '✨',
  'ञ्ज्यि': '✨',
  'ञ्ज्यी': '✨',
  'ञ्ज्यु': '✨',
  'ञ्ज्यू': '✨',
  'ञ्ज्ये': '✨',
  'ञ्ज्यै': '✨',
  'ञ्ज्यो': '✨',
  'ञ्ज्यौ': '✨',
  'प्स्या': '✨',
  'प्स्यि': '✨',
  'प्स्यी': '✨',
  'प्स्यु': '✨',
  'प्स्यू': '✨',
  'प्स्ये': '✨',
  'प्स्यै': '✨',
  'प्स्यो': '✨',
  'प्स्यौ': '✨',
  'ग्ध्या': '✨',
  'ग्ध्यि': '✨',
  'ग्ध्यी': '✨',
  'ग्ध्यु': '✨',
  'ग्ध्यू': '✨',
  'ग्ध्ये': '✨',
  'ग्ध्यै': '✨',
  'ग्ध्यो': '✨',
  'ग्ध्यौ': '✨',
  'पट्ठ्यतरुः': '🌳',
  'पट्ठ्यपवनः': '💨',
  'पट्ठ्यखगः': '🐦',
  'पट्ठ्यसरः': '🏞️',
  'पट्ठ्यकमलम्': '🪷',
  'पट्ठ्यमेघः': '☁️',
  'पट्ठ्यगिरिः': '⛰️',
  'उत्थ्यमेघः': '☁️',
  'उत्थ्यपवनः': '💨',
  'उत्थ्यसरः': '🏞️',
  'उत्थ्यतरुः': '🌳',
  'उत्थ्यखगः': '🐦',
  'उत्थ्यपुष्पम्': '🌺',
  'उत्थ्यगिरिः': '⛰️',
  'भञ्ज्यतरुः': '🌳',
  'भञ्ज्यपुष्पम्': '🌺',
  'भञ्ज्यकमलम्': '🪷',
  'भञ्ज्यपवनः': '💨',
  'भञ्ज्यखगः': '🐦',
  'भञ्ज्यसरः': '🏞️',
  'भञ्ज्यमेघः': '☁️',
  'आप्स्यतरुः': '🌳',
  'आप्स्यपुष्पम्': '🌺',
  'आप्स्यकमलम्': '🪷',
  'आप्स्यसरः': '🏞️',
  'आप्स्यखगः': '🐦',
  'आप्स्यपवनः': '💨',
  'आप्स्यमेघः': '☁️',
  'मौग्ध्यपुष्पम्': '🌺',
  'मौग्ध्यकमलम्': '🪷',
  'मौग्ध्यसरः': '🏞️',
  'मौग्ध्यखगः': '🐦',
  'मौग्ध्यपवनः': '💨',
  'मौग्ध्यतरुः': '🌳',
  'मौग्ध्यमेघः': '☁️',
  'ह्स्या': '✨',
  'ह्स्यि': '✨',
  'ह्स्यी': '✨',
  'ह्स्यु': '✨',
  'ह्स्यू': '✨',
  'ह्स्ये': '✨',
  'ह्स्यै': '✨',
  'ह्स्यो': '✨',
  'ह्स्यौ': '✨',
  'ज्भ्या': '✨',
  'ज्भ्यि': '✨',
  'ज्भ्यी': '✨',
  'ज्भ्यु': '✨',
  'ज्भ्यू': '✨',
  'ज्भ्ये': '✨',
  'ज्भ्यै': '✨',
  'ज्भ्यो': '✨',
  'ज्भ्यौ': '✨',
  'स्क्र्या': '✨',
  'स्क्र्यि': '✨',
  'स्क्र्यी': '✨',
  'स्क्र्यु': '✨',
  'स्क्र्यू': '✨',
  'स्क्र्ये': '✨',
  'स्क्र्यै': '✨',
  'स्क्र्यो': '✨',
  'स्क्र्यौ': '✨',
  'ष्क्र्या': '✨',
  'ष्क्र्यि': '✨',
  'ष्क्र्यी': '✨',
  'ष्क्र्यु': '✨',
  'ष्क्र्यू': '✨',
  'ष्क्र्ये': '✨',
  'ष्क्र्यै': '✨',
  'ष्क्र्यो': '✨',
  'ष्क्र्यौ': '✨',
  'ज्म्या': '✨',
  'ज्म्यि': '✨',
  'ज्म्यी': '✨',
  'ज्म्यु': '✨',
  'ज्म्यू': '✨',
  'ज्म्ये': '✨',
  'ज्म्यै': '✨',
  'ज्म्यो': '✨',
  'ज्म्यौ': '✨',
  'न्स्या': '✨',
  'न्स्यि': '✨',
  'न्स्यी': '✨',
  'न्स्यु': '✨',
  'न्स्यू': '✨',
  'न्स्ये': '✨',
  'न्स्यै': '✨',
  'न्स्यो': '✨',
  'न्स्यौ': '✨',
  'क्म्या': '✨',
  'क्म्यि': '✨',
  'क्म्यी': '✨',
  'क्म्यु': '✨',
  'क्म्यू': '✨',
  'क्म्ये': '✨',
  'क्म्यै': '✨',
  'क्म्यो': '✨',
  'क्म्यौ': '✨',
  'ल्भ्या': '✨',
  'ल्भ्यि': '✨',
  'ल्भ्यी': '✨',
  'ल्भ्यु': '✨',
  'ल्भ्यू': '✨',
  'ल्भ्ये': '✨',
  'ल्भ्यै': '✨',
  'ल्भ्यो': '✨',
  'ल्भ्यौ': '✨',
  'व्स्या': '✨',
  'व्स्यि': '✨',
  'व्स्यी': '✨',
  'व्स्यु': '✨',
  'व्स्यू': '✨',
  'व्स्ये': '✨',
  'व्स्यै': '✨',
  'व्स्यो': '✨',
  'व्स्यौ': '✨',
  'न्भ्या': '✨',
  'न्भ्यि': '✨',
  'न्भ्यी': '✨',
  'न्भ्यु': '✨',
  'न्भ्यू': '✨',
  'न्भ्ये': '✨',
  'न्भ्यै': '✨',
  'न्भ्यो': '✨',
  'न्भ्यौ': '✨',
  'आह्स्यपवनः': '💨',
  'आह्स्यखगः': '🐦',
  'आह्स्यतरुः': '🌳',
  'आह्स्यपुष्पम्': '🌺',
  'आह्स्यकमलम्': '🪷',
  'आह्स्यसरः': '🏞️',
  'आह्स्यमेघः': '☁️',
  'उज्भ्यमेघः': '☁️',
  'उज्भ्यगिरिः': '⛰️',
  'उज्भ्यतरुः': '🌳',
  'उज्भ्यपवनः': '💨',
  'उज्भ्यसरः': '🏞️',
  'उज्भ्यखगः': '🐦',
  'उज्भ्यपुष्पम्': '🌺',
  'संस्क्र्यतरुः': '🌳',
  'संस्क्र्यपवनः': '💨',
  'संस्क्र्यसरः': '🏞️',
  'संस्क्र्यपुष्पम्': '🌺',
  'संस्क्र्यकमलम्': '🪷',
  'संस्क्र्यखगः': '🐦',
  'संस्क्र्यमेघः': '☁️',
  'निष्क्र्यखगः': '🐦',
  'निष्क्र्यपवनः': '💨',
  'निष्क्र्यसिंहः': '🌳',
  'निष्क्र्यमेघः': '☁️',
  'निष्क्र्यसरः': '🏞️',
  'निष्क्र्यतरुः': '🌳',
  'निष्क्र्यपुष्पम्': '🌺',
  'युज्म्यसरः': '🏞️',
  'युज्म्यतरुः': '🌳',
  'युज्म्यपुष्पम्': '🌺',
  'युज्म्यकमलम्': '🪷',
  'युज्म्यखगः': '🐦',
  'युज्म्यपवनः': '💨',
  'युज्म्यमेघः': '☁️',
  'हन्स्यपवनः': '💨',
  'हन्स्यमेघः': '☁️',
  'हन्स्यसिंहः': '🌳',
  'हन्स्यतरुः': '🌳',
  'हन्स्यपुष्पम्': '🌺',
  'हन्स्यसरः': '🏞️',
  'हन्स्यखगः': '🐦',
  'रुक्म्यसूर्यः': '☀️',
  'रुक्म्यतरुः': '🌳',
  'रुक्म्यपुष्पम्': '🌺',
  'रुक्म्यकमलम्': '🪷',
  'रुक्म्यसरः': '🏞️',
  'रुक्म्यखगः': '🐦',
  'रुक्म्यमेघः': '☁️',
  'विल्भ्यतरुः': '🌳',
  'विल्भ्यवनम्': '🌲',
  'विल्भ्यपुष्पम्': '🌺',
  'विल्भ्यसरः': '🏞️',
  'विल्भ्यखगः': '🐦',
  'विल्भ्यपवनः': '💨',
  'विल्भ्यमेघः': '☁️',
  'दिव्स्यपवनः': '💨',
  'दिव्स्यमेघः': '☁️',
  'दिव्स्यसूर्यः': '☀️',
  'दिव्स्यसरः': '🏞️',
  'दिव्स्यतरुः': '🌳',
  'दिव्स्यखगः': '🐦',
  'दिव्स्यकमलम्': '🪷',
  'स्तन्भ्यपवनः': '💨',
  'स्तन्भ्यमेघः': '☁️',
  'स्तन्भ्यसरः': '🏞️',
  'स्तन्भ्यतरुः': '🌳',
  'स्तन्भ्यखगः': '🐦',
  'स्तन्भ्यपुष्पम्': '🌺',
  'स्तन्भ्यगिरिः': '⛰️',
  'ण्ह्या': '✨',
  'ण्ह्यि': '✨',
  'ण्ह्यी': '✨',
  'ण्ह्यु': '✨',
  'ण्ह्यू': '✨',
  'ण्ह्ये': '✨',
  'ण्ह्यै': '✨',
  'ण्ह्यो': '✨',
  'ण्ह्यौ': '✨',
  'द्भ्र्या': '✨',
  'द्भ्र्यि': '✨',
  'द्भ्र्यी': '✨',
  'द्भ्र्यु': '✨',
  'द्भ्र्यू': '✨',
  'द्भ्र्ये': '✨',
  'द्भ्र्यै': '✨',
  'द्भ्र्यो': '✨',
  'द्भ्र्यौ': '✨',
  'ष्भ्या': '✨',
  'ष्भ्यि': '✨',
  'ष्भ्यी': '✨',
  'ष्भ्यु': '✨',
  'ष्भ्यू': '✨',
  'ष्भ्ये': '✨',
  'ष्भ्यै': '✨',
  'ष्भ्यो': '✨',
  'ष्भ्यौ': '✨',
  'ह्भ्या': '✨',
  'ह्भ्यि': '✨',
  'ह्भ्यी': '✨',
  'ह्भ्यु': '✨',
  'ह्भ्यू': '✨',
  'ह्भ्ये': '✨',
  'ह्भ्यै': '✨',
  'ह्भ्यो': '✨',
  'ह्भ्यौ': '✨',
  'ब्स्या': '✨',
  'ब्स्यि': '✨',
  'ब्स्यी': '✨',
  'ब्स्यु': '✨',
  'ब्स्यू': '✨',
  'ब्स्ये': '✨',
  'ब्स्यै': '✨',
  'ब्स्यो': '✨',
  'ब्स्यौ': '✨',
  'च्म्या': '✨',
  'च्म्यि': '✨',
  'च्म्यी': '✨',
  'च्म्यु': '✨',
  'च्म्यू': '✨',
  'च्म्ये': '✨',
  'च्म्यै': '✨',
  'च्म्यो': '✨',
  'च्म्यौ': '✨',
  'ल्स्या': '✨',
  'ल्स्यि': '✨',
  'ल्स्यी': '✨',
  'ल्स्यु': '✨',
  'ल्स्यू': '✨',
  'ल्स्ये': '✨',
  'ल्स्यै': '✨',
  'ल्स्यो': '✨',
  'ल्स्यौ': '✨',
  'ग्न्या': '✨',
  'ग्न्यि': '✨',
  'ग्न्यी': '✨',
  'ग्न्यु': '✨',
  'ग्न्यू': '✨',
  'ग्न्ये': '✨',
  'ग्न्यै': '✨',
  'ग्न्यो': '✨',
  'ग्न्यौ': '✨',
  'प्म्या': '✨',
  'प्म्यि': '✨',
  'प्म्यी': '✨',
  'प्म्यु': '✨',
  'प्म्यू': '✨',
  'प्म्ये': '✨',
  'प्म्यै': '✨',
  'प्म्यो': '✨',
  'प्म्यौ': '✨',
  'ब्म्या': '✨',
  'ब्म्यि': '✨',
  'ब्म्यी': '✨',
  'ब्म्यु': '✨',
  'ब्म्यू': '✨',
  'ब्म्ये': '✨',
  'ब्म्यै': '✨',
  'ब्म्यो': '✨',
  'ब्म्यौ': '✨',
  'प्रण्ह्यपवनः': '💨',
  'प्रण्ह्यतरुः': '🌳',
  'प्रण्ह्यखगः': '🐦',
  'प्रण्ह्यमेघः': '☁️',
  'प्रण्ह्यसरः': '🏞️',
  'प्रण्ह्यपुष्पम्': '🌺',
  'प्रण्ह्यगिरिः': '⛰️',
  'उद्भ्र्यपवनः': '💨',
  'उद्भ्र्यमेघः': '☁️',
  'उद्भ्र्यसरः': '🏞️',
  'उद्भ्र्यतरुः': '🌳',
  'उद्भ्र्यखगः': '🐦',
  'उद्भ्र्यसिंहः': '🦁',
  'उद्भ्र्यपुष्पम्': '🌺',
  'निष्भ्यतरुः': '🌳',
  'निष्भ्यवनम्': '🌲',
  'निष्भ्यपवनः': '💨',
  'निष्भ्यगिरिः': '⛰️',
  'निष्भ्यमार्गः': '🛤️',
  'निष्भ्यमेघः': '☁️',
  'निष्भ्यसरः': '🏞️',
  'आह्भ्यपवनः': '💨',
  'आह्भ्यखगः': '🐦',
  'आह्भ्यमेघः': '☁️',
  'आह्भ्यसरः': '🏞️',
  'आह्भ्यतरुः': '🌳',
  'आह्भ्यकमलम्': '🪷',
  'आह्भ्यगिरिः': '⛰️',
  'शुब्स्यसूर्यः': '✨',
  'शुब्स्यपुष्पम्': '🌺',
  'शुब्स्यकमलम्': '🪷',
  'शुब्स्यसरः': '🏞️',
  'शुब्स्यपवनः': '💨',
  'शुब्स्यमेघः': '☁️',
  'शुब्स्यतरुः': '🌳',
  'उच्म्यगिरिः': '⛰️',
  'उच्म्यतरुः': '🌳',
  'उच्म्यमेघः': '☁️',
  'उच्म्यखगः': '🐦',
  'उच्म्यपवनः': '💨',
  'उच्म्यसरः': '🏞️',
  'उच्म्यपुष्पम्': '🌺',
  'फल्स्यतरुः': '🌳',
  'फल्स्यपुष्पम्': '🌺',
  'फल्स्यपवनः': '💨',
  'फल्स्यसरः': '🏞️',
  'फल्स्यखगः': '🐦',
  'फल्स्यमेघः': '☁️',
  'फल्स्यकमलम्': '🪷',
  'अग्न्यगिरिः': '⛰️',
  'अग्न्यपवनः': '💨',
  'अग्न्यमेघः': '☁️',
  'अग्न्यतरुः': '🌳',
  'अग्न्यसरः': '🏞️',
  'अग्न्यपुष्पम्': '🌺',
  'अग्न्यखगः': '🐦',
  'सुप्म्यखगः': '🐦',
  'सुप्म्यसिंहः': '🦁',
  'सुप्म्यपवनः': '💨',
  'सुप्म्यसरः': '🏞️',
  'सुप्म्यकमलम्': '🪷',
  'सुप्म्यतरुः': '🌳',
  'सुप्म्यमेघः': '☁️',
  'शुब्म्यसूर्यः': '✨',
  'शुब्म्यपुष्पम्': '🌺',
  'शुब्म्यकमलम्': '🪷',
  'शुब्म्यसरः': '🏞️',
  'शुब्म्यपवनः': '💨',
  'शुब्म्यमेघः': '☁️',
  'शुब्म्यतरुः': '🌳',
  'ण्म्या': '✨',
  'ण्म्यि': '✨',
  'ण्म्यी': '✨',
  'ण्म्यु': '✨',
  'ण्म्यू': '✨',
  'ण्म्ये': '✨',
  'ण्म्यै': '✨',
  'ण्म्यो': '✨',
  'ण्म्यौ': '✨',
  'म्भ्या': '✨',
  'म्भ्यि': '✨',
  'म्भ्यी': '✨',
  'म्भ्यु': '✨',
  'म्भ्यू': '✨',
  'म्भ्ये': '✨',
  'म्भ्यै': '✨',
  'म्भ्यो': '✨',
  'म्भ्यौ': '✨',
  'ह्ण्या': '✨',
  'ह्ण्यि': '✨',
  'ह्ण्यी': '✨',
  'ह्ण्यु': '✨',
  'ह्ण्यू': '✨',
  'ह्ण्ये': '✨',
  'ह्ण्यै': '✨',
  'ह्ण्यो': '✨',
  'ह्ण्यौ': '✨',
  'त्स्न्या': '✨',
  'त्स्न्यि': '✨',
  'त्स्न्यी': '✨',
  'त्स्न्यु': '✨',
  'त्स्न्यू': '✨',
  'त्स्न्ये': '✨',
  'त्स्न्यै': '✨',
  'त्स्न्यो': '✨',
  'त्स्न्यौ': '✨',
  'र्ण्या': '✨',
  'र्ण्यि': '✨',
  'र्ण्यी': '✨',
  'र्ण्यु': '✨',
  'र्ण्यू': '✨',
  'र्ण्ये': '✨',
  'र्ण्यै': '✨',
  'र्ण्यो': '✨',
  'र्ण्यौ': '✨',
  'ष्ण्या': '✨',
  'ष्ण्यि': '✨',
  'ष्ण्यी': '✨',
  'ष्ण्यु': '✨',
  'ष्ण्यू': '✨',
  'ष्ण्ये': '✨',
  'ष्ण्यै': '✨',
  'ष्ण्यो': '✨',
  'ष्ण्यौ': '✨',
  'त्त्र्या': '✨',
  'त्त्र्यि': '✨',
  'त्त्र्यी': '✨',
  'त्त्र्यु': '✨',
  'त्त्र्यू': '✨',
  'त्त्र्ये': '✨',
  'त्त्र्यै': '✨',
  'त्त्र्यो': '✨',
  'त्त्र्यौ': '✨',
  'ग्ध्र्या': '✨',
  'ग्ध्र्यि': '✨',
  'ग्ध्र्यी': '✨',
  'ग्ध्र्यु': '✨',
  'ग्ध्र्यू': '✨',
  'ग्ध्र्ये': '✨',
  'ग्ध्र्यै': '✨',
  'ग्ध्र्यो': '✨',
  'ग्ध्र्यौ': '✨',
  'ब्ध्र्या': '✨',
  'ब्ध्र्यि': '✨',
  'ब्ध्र्यी': '✨',
  'ब्ध्र्यु': '✨',
  'ब्ध्र्यू': '✨',
  'ब्ध्र्ये': '✨',
  'ब्ध्र्यै': '✨',
  'ब्ध्र्यो': '✨',
  'ब्ध्र्यौ': '✨',
  'त्क्र्या': '✨',
  'त्क्र्यि': '✨',
  'त्क्र्यी': '✨',
  'त्क्र्यु': '✨',
  'त्क्र्यू': '✨',
  'त्क्र्ये': '✨',
  'त्क्र्यै': '✨',
  'त्क्र्यो': '✨',
  'त्क्र्यौ': '✨',
  'प्रण्म्यपवनः': '💨',
  'प्रण्म्यतरुः': '🌳',
  'प्रण्म्यखगः': '🐦',
  'प्रण्म्यमेघः': '☁️',
  'प्रण्म्यसरः': '🏞️',
  'प्रण्म्यपुष्पम्': '🌺',
  'प्रण्म्यगिरिः': '⛰️',
  'सम्भ्यमेघः': '☁️',
  'सम्भ्यखगः': '🐦',
  'सम्भ्यपवनः': '💨',
  'सम्भ्यसरः': '🏞️',
  'सम्भ्यतरुः': '🌳',
  'सम्भ्यपुष्पम्': '🌺',
  'सम्भ्यगिरिः': '⛰️',
  'अह्ण्यपवनः': '💨',
  'अह्ण्यमेघः': '☁️',
  'अह्ण्यसूर्यः': '☀️',
  'अह्ण्यसरः': '🏞️',
  'अह्ण्यतरुः': '🌳',
  'अह्ण्यखगः': '🐦',
  'अह्ण्यकमलम्': '🪷',
  'उत्स्न्यमेघः': '☁️',
  'उत्स्न्यपवनः': '💨',
  'उत्स्न्यसरः': '🏞️',
  'उत्स्न्यतरुः': '🌳',
  'उत्स्न्यखगः': '🐦',
  'उत्स्न्यपुष्पम्': '🌺',
  'उत्स्न्यगिरिः': '⛰️',
  'पूर्ण्यचन्द्रः': '🌙',
  'पूर्ण्यसरः': '🏞️',
  'पूर्ण्यपुष्पम्': '🌺',
  'पूर्ण्यकमलम्': '🪷',
  'पूर्ण्यखगः': '🐦',
  'पूर्ण्यपवनः': '💨',
  'पूर्ण्यतरुः': '🌳',
  'कृष्ण्यमेघः': '☁️',
  'कृष्ण्यपवनः': '💨',
  'कृष्ण्यसरः': '🏞️',
  'कृष्ण्यतरुः': '🌳',
  'कृष्ण्यखगः': '🐦',
  'कृष्ण्यवनम्': '🌲',
  'कृष्ण्यसिंहः': '🦁',
  'सत्त्र्यतरुः': '🌳',
  'सत्त्र्यपुष्पम्': '🌺',
  'सत्त्र्यकमलम्': '🪷',
  'सत्त्र्यखगः': '🐦',
  'सत्त्र्यपवनः': '💨',
  'सत्त्र्यमेघः': '☁️',
  'सत्त्र्यगिरिः': '⛰️',
  'दुग्ध्र्यमेघः': '☁️',
  'दुग्ध्र्यपुष्पम्': '🌺',
  'दुग्ध्र्यपवनः': '💨',
  'दुग्ध्र्यकमलम्': '🪷',
  'दुग्ध्र्यसरः': '🏞️',
  'दुग्ध्र्यखगः': '🐦',
  'दुग्ध्र्यतरुः': '🌳',
  'लब्ध्र्यगिरिः': '⛰️',
  'लब्ध्र्यसरः': '🏞️',
  'लब्ध्र्यतरुः': '🌳',
  'लब्ध्र्यखगः': '🐦',
  'लब्ध्र्यपुष्पम्': '🌺',
  'लब्ध्र्यपवनः': '💨',
  'लब्ध्र्यमेघः': '☁️',
  'उत्क्र्यखगः': '🐦',
  'उत्क्र्यमेघः': '☁️',
  'उत्क्र्यपवनः': '💨',
  'उत्क्र्यतरुः': '🌳',
  'उत्क्र्यपुष्पम्': '🌺',
  'उत्क्र्यसरः': '🏞️',
  'उत्क्र्यगिरिः': '⛰️',
  "म्प्र्या": "✨",
  "म्प्र्यि": "✨",
  "म्प्र्यी": "✨",
  "म्प्र्यु": "✨",
  "म्प्र्यू": "✨",
  "म्प्र्ये": "✨",
  "म्प्र्यै": "✨",
  "म्प्र्यो": "✨",
  "म्प्र्यौ": "✨",
  "त्प्र्या": "✨",
  "त्प्र्यि": "✨",
  "त्प्र्यी": "✨",
  "त्प्र्यु": "✨",
  "त्प्र्यू": "✨",
  "त्प्र्ये": "✨",
  "त्प्र्यै": "✨",
  "त्प्र्यो": "✨",
  "त्प्र्यौ": "✨",
  "द्प्र्या": "✨",
  "द्प्र्यि": "✨",
  "द्प्र्यी": "✨",
  "द्प्र्यु": "✨",
  "द्प्र्यू": "✨",
  "द्प्र्ये": "✨",
  "द्प्र्यै": "✨",
  "द्प्र्यो": "✨",
  "द्प्र्यौ": "✨",
  "ष्प्र्या": "✨",
  "ष्प्र्यि": "✨",
  "ष्प्र्यी": "✨",
  "ष्प्र्यु": "✨",
  "ष्प्र्यू": "✨",
  "ष्प्र्ये": "✨",
  "ष्प्र्यै": "✨",
  "ष्प्र्यो": "✨",
  "ष्प्र्यौ": "✨",
  "त्स्र्या": "✨",
  "त्स्र्यि": "✨",
  "त्स्र्यी": "✨",
  "त्स्र्यु": "✨",
  "त्स्र्यू": "✨",
  "त्स्र्ये": "✨",
  "त्स्र्यै": "✨",
  "त्स्र्यो": "✨",
  "त्स्र्यौ": "✨",
  "द्ग्र्या": "✨",
  "द्ग्र्यि": "✨",
  "द्ग्र्यी": "✨",
  "द्ग्र्यु": "✨",
  "द्ग्र्यू": "✨",
  "द्ग्र्ये": "✨",
  "द्ग्र्यै": "✨",
  "द्ग्र्यो": "✨",
  "द्ग्र्यौ": "✨",
  "द्क्र्या": "✨",
  "द्क्र्यि": "✨",
  "द्क्र्यी": "✨",
  "द्क्र्यु": "✨",
  "द्क्र्यू": "✨",
  "द्क्र्ये": "✨",
  "द्क्र्यै": "✨",
  "द्क्र्यो": "✨",
  "द्क्र्यौ": "✨",
  "ह्भ्र्या": "✨",
  "ह्भ्र्यि": "✨",
  "ह्भ्र्यी": "✨",
  "ह्भ्र्यु": "✨",
  "ह्भ्र्यू": "✨",
  "ह्भ्र्ये": "✨",
  "ह्भ्र्यै": "✨",
  "ह्भ्र्यो": "✨",
  "ह्भ्र्यौ": "✨",
  "ण्ह्र्या": "✨",
  "ण्ह्र्यि": "✨",
  "ण्ह्र्यी": "✨",
  "ण्ह्र्यु": "✨",
  "ण्ह्र्यू": "✨",
  "ण्ह्र्ये": "✨",
  "ण्ह्र्यै": "✨",
  "ण्ह्र्यो": "✨",
  "ण्ह्र्यौ": "✨",
  "ह्ध्र्या": "✨",
  "ह्ध्र्यि": "✨",
  "ह्ध्र्यी": "✨",
  "ह्ध्र्यु": "✨",
  "ह्ध्र्यू": "✨",
  "ह्ध्र्ये": "✨",
  "ह्ध्र्यै": "✨",
  "ह्ध्र्यो": "✨",
  "ह्ध्र्यौ": "✨",
  "सम्प्र्यमेघः": "☁️",
  "सम्प्र्यखगः": "🐦",
  "सम्प्र्यपवनः": "💨",
  "सम्प्र्यसरः": "🏞️",
  "सम्प्र्यतरुः": "🌳",
  "सम्प्र्यपुष्पम्": "🌺",
  "सम्प्र्यगिरिः": "⛰️",
  "उत्प्र्यखगः": "🐦",
  "उत्प्र्यमेघः": "☁️",
  "उत्प्र्यपवनः": "💨",
  "उत्प्र्यतरुः": "🌳",
  "उत्प्र्यपुष्पम्": "🌺",
  "उत्प्र्यसरः": "🏞️",
  "उत्प्र्यगिरिः": "⛰️",
  "उद्प्र्यसूर्यः": "☀️",
  "उद्प्र्यमेघः": "☁️",
  "उद्प्र्यपवनः": "💨",
  "उद्प्र्यसरः": "🏞️",
  "उद्प्र्यतरुः": "🌳",
  "उद्प्र्यखगः": "🐦",
  "उद्प्र्यकमलम्": "🪷",
  "निष्प्र्यतरुः": "🌳",
  "निष्प्र्यवनम्": "🌲",
  "निष्प्र्यपवनः": "💨",
  "निष्प्र्यगिरिः": "⛰️",
  "निष्प्र्यमार्गः": "🛤️",
  "निष्प्र्यमेघः": "☁️",
  "निष्प्र्यसरः": "🏞️",
  "उत्स्र्यसरः": "🏞️",
  "उत्स्र्यपवनः": "💨",
  "उत्स्र्यमेघः": "☁️",
  "उत्स्र्यतरुः": "🌳",
  "उत्स्र्यकमलम्": "🪷",
  "उत्स्र्यखगः": "🐦",
  "उत्स्र्यगिरिः": "⛰️",
  "उद्ग्र्यगिरिः": "⛰️",
  "उद्ग्र्यतरुः": "🌳",
  "उद्ग्र्यमेघः": "☁️",
  "उद्ग्र्यखगः": "🐦",
  "उद्ग्र्यपवनः": "💨",
  "उद्ग्र्यसरः": "🏞️",
  "उद्ग्र्यपुष्पम्": "🌺",
  "उद्क्र्यमेघः": "☁️",
  "उद्क्र्यपवनः": "💨",
  "उद्क्र्यसरः": "🏞️",
  "उद्क्र्यतरुः": "🌳",
  "उद्क्र्यखगः": "🐦",
  "उद्क्र्यपुष्पम्": "🌺",
  "उद्क्र्यगिरिः": "⛰️",
  "आह्भ्र्यपवनः": "💨",
  "आह्भ्र्यमेघः": "☁️",
  "आह्भ्र्यखगः": "🐦",
  "आह्भ्र्यतरुः": "🌳",
  "आह्भ्र्यसरः": "🏞️",
  "आह्भ्र्यकमलम्": "🪷",
  "आह्भ्र्यगिरिः": "⛰️",
  "प्रण्ह्र्यपवनः": "💨",
  "प्रण्ह्र्यतरुः": "🌳",
  "प्रण्ह्र्यखगः": "🐦",
  "प्रण्ह्र्यमेघः": "☁️",
  "प्रण्ह्र्यसरः": "🏞️",
  "प्रण्ह्र्यपुष्पम्": "🌺",
  "प्रण्ह्र्यगिरिः": "⛰️",
  "आह्ध्र्यसरः": "🏞️",
  "आह्ध्र्यपवनः": "💨",
  "आह्ध्र्यतरुः": "🌳",
  "आह्ध्र्यपुष्पम्": "🌺",
  "आह्ध्र्यकमलम्": "🪷",
  "आह्ध्र्यखगः": "🐦",
  "आह्ध्र्यमेघः": "☁️",
};

export const iconForExampleWord = (word: string): string => {
  const clean = word.normalize('NFC').trim();
  return EXAMPLE_ICONS[clean] || '✨';
};
